//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';

export class DataControllersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Retrieve look-up values for drop-down by type
     * @param type (optional) 
     */
    getLookUpCodeValues(type: LookUpCodeTypes | undefined): Promise<DropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/drp-get-look-up-values?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodeValues(_response);
        });
    }

    protected processGetLookUpCodeValues(response: Response): Promise<DropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropDownItemResponse[]>(null as any);
    }

    /**
     * Retrieve platform look-up values for drop-down by type
     * @param type (optional) 
     */
    getPlatformLookUpCodeValues(type: PlatformLookUpCodeTypes | undefined): Promise<DropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/drp-platform-get-look-up-values?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlatformLookUpCodeValues(_response);
        });
    }

    protected processGetPlatformLookUpCodeValues(response: Response): Promise<DropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropDownItemResponse[]>(null as any);
    }

    /**
     * Retrieve public platform look-up values for registration drop-downs by type
     * @param type (optional) 
     */
    getPublicLookUpCodeValues(type: PlatformLookUpCodeTypes | undefined): Promise<DropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/drp-public-get-look-up-values?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicLookUpCodeValues(_response);
        });
    }

    protected processGetPublicLookUpCodeValues(response: Response): Promise<DropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropDownItemResponse[]>(null as any);
    }

    /**
     * Retrieve system users
     */
    getSystemUsers(ignoreLoggedInUser: boolean): Promise<UserDropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/system-users/{ignoreLoggedInUser}";
        if (ignoreLoggedInUser === undefined || ignoreLoggedInUser === null)
            throw new globalThis.Error("The parameter 'ignoreLoggedInUser' must be defined.");
        url_ = url_.replace("{ignoreLoggedInUser}", encodeURIComponent("" + ignoreLoggedInUser));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSystemUsers(_response);
        });
    }

    protected processGetSystemUsers(response: Response): Promise<UserDropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDropDownItemResponse[]>(null as any);
    }

    /**
     * Retrieve localization countries
     */
    getLocalizationCountries(): Promise<DropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/get-localization-countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocalizationCountries(_response);
        });
    }

    protected processGetLocalizationCountries(response: Response): Promise<DropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropDownItemResponse[]>(null as any);
    }

    /**
     * Retrieve localization states for selected country
     */
    getLocalizationStates(countryId: number): Promise<DropDownItemResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/get-localization-states/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocalizationStates(_response);
        });
    }

    protected processGetLocalizationStates(response: Response): Promise<DropDownItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropDownItemResponse[]>(null as any);
    }

    /**
     * Get a localization for selected country
     */
    getCountryLocalization(id: number): Promise<ViewCountryLocalizationResponse[]> {
        let url_ = this.baseUrl + "/api/datacontrollers/get-country-localization/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountryLocalization(_response);
        });
    }

    protected processGetCountryLocalization(response: Response): Promise<ViewCountryLocalizationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewCountryLocalizationResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewCountryLocalizationResponse[]>(null as any);
    }
}

export class SupportDocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    upload(request: UploadSupportDocumentRequest): Promise<SupportDocumentResponse> {
        let url_ = this.baseUrl + "/api/support/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<SupportDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportDocumentResponse>(null as any);
    }

    getAll(): Promise<SupportDocumentResponse[]> {
        let url_ = this.baseUrl + "/api/support/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SupportDocumentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportDocumentResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportDocumentResponse[]>(null as any);
    }

    download(id: number): Promise<DownloadFileResponse> {
        let url_ = this.baseUrl + "/api/support/documents/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<DownloadFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileResponse>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/support/documents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SupportInquiryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    create(request: CreateSupportInquiryRequest): Promise<SupportInquiryDetailResponse> {
        let url_ = this.baseUrl + "/api/support/inquiries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SupportInquiryDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportInquiryDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportInquiryDetailResponse>(null as any);
    }

    search(request: SearchSupportInquiryRequest): Promise<PaginationResponseOfSupportInquiryListResponse> {
        let url_ = this.baseUrl + "/api/support/inquiries/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfSupportInquiryListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfSupportInquiryListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfSupportInquiryListResponse>(null as any);
    }

    getById(id: number): Promise<SupportInquiryDetailResponse> {
        let url_ = this.baseUrl + "/api/support/inquiries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<SupportInquiryDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportInquiryDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportInquiryDetailResponse>(null as any);
    }
}

export class CustomPlanRequestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Search custom plan requests
     */
    search(request: SearchCustomPlanRequestsRequest): Promise<PaginationResponseOfCustomPlanRequestListResponse> {
        let url_ = this.baseUrl + "/api/custom-plan-requests/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfCustomPlanRequestListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfCustomPlanRequestListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfCustomPlanRequestListResponse>(null as any);
    }

    getById(id: number): Promise<CustomPlanRequestDetailResponse> {
        let url_ = this.baseUrl + "/api/custom-plan-requests/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<CustomPlanRequestDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPlanRequestDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPlanRequestDetailResponse>(null as any);
    }

    /**
     * Approve a custom plan request and create a private plan for customer checkout
     */
    approve(id: number): Promise<CustomPlanRequestDetailResponse> {
        let url_ = this.baseUrl + "/api/custom-plan-requests/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<CustomPlanRequestDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPlanRequestDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPlanRequestDetailResponse>(null as any);
    }

    /**
     * Reject a custom plan request
     */
    reject(id: number, request: RejectCustomPlanRequestRequest): Promise<CustomPlanRequestDetailResponse> {
        let url_ = this.baseUrl + "/api/custom-plan-requests/{id}/reject";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: Response): Promise<CustomPlanRequestDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPlanRequestDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPlanRequestDetailResponse>(null as any);
    }

    /**
     * Search current tenant's custom plan requests
     */
    searchMine(request: SearchCustomPlanRequestsRequest): Promise<PaginationResponseOfCustomPlanRequestListResponse> {
        let url_ = this.baseUrl + "/api/custom-plan-requests/my/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchMine(_response);
        });
    }

    protected processSearchMine(response: Response): Promise<PaginationResponseOfCustomPlanRequestListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfCustomPlanRequestListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfCustomPlanRequestListResponse>(null as any);
    }
}

export class CustomPricingAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Get the custom pricing configuration
     */
    get(): Promise<CustomPricingConfigurationResponse> {
        let url_ = this.baseUrl + "/api/subscription/custom-pricing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CustomPricingConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPricingConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPricingConfigurationResponse>(null as any);
    }

    /**
     * Create or update the custom pricing configuration
     */
    upsert(request: UpsertCustomPricingConfigurationRequest): Promise<CustomPricingConfigurationResponse> {
        let url_ = this.baseUrl + "/api/subscription/custom-pricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<CustomPricingConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPricingConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPricingConfigurationResponse>(null as any);
    }
}

export class CustomPricingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Check whether custom pricing is configured and active
     */
    getAvailability(): Promise<CustomPricingConfigurationResponse> {
        let url_ = this.baseUrl + "/api/subscription/custom-pricing/availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailability(_response);
        });
    }

    protected processGetAvailability(response: Response): Promise<CustomPricingConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPricingConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPricingConfigurationResponse>(null as any);
    }

    /**
     * Calculate a custom subscription price from instance/user quantities
     */
    calculate(request: CalculateCustomPriceRequest): Promise<CalculateCustomPriceResponse> {
        let url_ = this.baseUrl + "/api/subscription/custom-pricing/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<CalculateCustomPriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateCustomPriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateCustomPriceResponse>(null as any);
    }

    /**
     * Submit a custom plan request — emails and notifies SuperAdmin to follow up
     */
    request(request: CalculateCustomPriceRequest): Promise<CalculateCustomPriceResponse> {
        let url_ = this.baseUrl + "/api/subscription/custom-pricing/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequest(_response);
        });
    }

    protected processRequest(response: Response): Promise<CalculateCustomPriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateCustomPriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateCustomPriceResponse>(null as any);
    }
}

export class LicenseAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Search tenant licenses
     */
    search(request: SearchTenantLicensesRequest): Promise<PaginationResponseOfTenantLicenseListResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfTenantLicenseListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfTenantLicenseListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfTenantLicenseListResponse>(null as any);
    }

    getById(id: number): Promise<TenantLicenseDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<TenantLicenseDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLicenseDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLicenseDetailResponse>(null as any);
    }

    /**
     * Generate and activate license for a subscription
     */
    generate(tenantSubscriptionPlanId: number): Promise<TenantLicenseDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/subscription/{tenantSubscriptionPlanId}/generate";
        if (tenantSubscriptionPlanId === undefined || tenantSubscriptionPlanId === null)
            throw new globalThis.Error("The parameter 'tenantSubscriptionPlanId' must be defined.");
        url_ = url_.replace("{tenantSubscriptionPlanId}", encodeURIComponent("" + tenantSubscriptionPlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: Response): Promise<TenantLicenseDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLicenseDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLicenseDetailResponse>(null as any);
    }

    /**
     * Assign subscription plan to tenant and issue license
     */
    issue(request: AdminIssueLicenseRequest): Promise<TenantLicenseDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIssue(_response);
        });
    }

    protected processIssue(response: Response): Promise<TenantLicenseDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLicenseDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLicenseDetailResponse>(null as any);
    }

    updateStatus(id: number, request: UpdateLicenseStatusRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/licenses/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update user and instance limits for a trial license
     */
    updateTrialLimits(id: number, request: UpdateTrialLicenseLimitsRequest): Promise<TenantLicenseDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/{id}/trial-limits";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTrialLimits(_response);
        });
    }

    protected processUpdateTrialLimits(response: Response): Promise<TenantLicenseDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantLicenseDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantLicenseDetailResponse>(null as any);
    }

    resendEmail(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/licenses/{id}/resend-email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResendEmail(_response);
        });
    }

    protected processResendEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAnalyticsSummary(): Promise<LicenseAnalyticsSummaryResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/analytics/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalyticsSummary(_response);
        });
    }

    protected processGetAnalyticsSummary(response: Response): Promise<LicenseAnalyticsSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseAnalyticsSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseAnalyticsSummaryResponse>(null as any);
    }

    searchAudit(request: SearchLicenseAuditRequest): Promise<PaginationResponseOfLicenseAuditLogResponse> {
        let url_ = this.baseUrl + "/api/subscription/licenses/audit/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchAudit(_response);
        });
    }

    protected processSearchAudit(response: Response): Promise<PaginationResponseOfLicenseAuditLogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLicenseAuditLogResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfLicenseAuditLogResponse>(null as any);
    }

    /**
     * Get all license-activated devices for a tenant
     */
    getTenantDevices(tenantId: number): Promise<LicenseDeviceResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/tenants/{tenantId}/devices";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantDevices(_response);
        });
    }

    protected processGetTenantDevices(response: Response): Promise<LicenseDeviceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseDeviceResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDeviceResponse[]>(null as any);
    }
}

export class LicenseValidationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Validate license key for desktop application
     */
    validate(request: ValidateLicenseRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/public/license/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }
}

export class NotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    getNotifications(request: GetNotificationsRequest): Promise<PaginationResponseOfNotificationResponse> {
        let url_ = this.baseUrl + "/api/notification/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<PaginationResponseOfNotificationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfNotificationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfNotificationResponse>(null as any);
    }

    getUnreadCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/notification/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnreadCount(_response);
        });
    }

    protected processGetUnreadCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    markAsRead(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/notification/{id}/mark-read";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    markAllAsRead(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/notification/mark-all-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAllAsRead(_response);
        });
    }

    protected processMarkAllAsRead(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/notification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PromoCodeAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create a promotional code
     */
    create(request: CreatePromoCodeRequest): Promise<PromoCodeDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<PromoCodeDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromoCodeDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeDetailResponse>(null as any);
    }

    /**
     * Update a promotional code
     */
    update(request: UpdatePromoCodeRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete a promotional code
     */
    delete(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a promotional code by id
     */
    getById(id: number): Promise<PromoCodeDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<PromoCodeDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromoCodeDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeDetailResponse>(null as any);
    }

    /**
     * Search promotional codes
     */
    search(request: SearchPromoCodesRequest): Promise<PaginationResponseOfPromoCodeListResponse> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfPromoCodeListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfPromoCodeListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfPromoCodeListResponse>(null as any);
    }

    /**
     * Activate a promotional code
     */
    activate(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/{id}/activate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deactivate (disable) a promotional code
     */
    deactivate(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * View a promotional code's usage history
     */
    getUsageHistory(id: number, request: SearchRequestBaseClass): Promise<PaginationResponseOfPromoCodeUsageResponse> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/{id}/usage-history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsageHistory(_response);
        });
    }

    protected processGetUsageHistory(response: Response): Promise<PaginationResponseOfPromoCodeUsageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfPromoCodeUsageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfPromoCodeUsageResponse>(null as any);
    }
}

export class PromoCodeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Validate a promotional code before payment
     */
    validate(request: ValidatePromoCodeRequest): Promise<ValidatePromoCodeResponse> {
        let url_ = this.baseUrl + "/api/subscription/promo-codes/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<ValidatePromoCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidatePromoCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidatePromoCodeResponse>(null as any);
    }
}

export class SqlDbdInstallerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Get current SQLDBD installer info (name, size, last modified)
     */
    getInfo(): Promise<SqlDbdInstallerInfoResponse> {
        let url_ = this.baseUrl + "/api/sqldbd-installer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: Response): Promise<SqlDbdInstallerInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlDbdInstallerInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SqlDbdInstallerInfoResponse>(null as any);
    }

    /**
     * Download the current SQLDBD installer
     */
    download(): Promise<DownloadFileResponse> {
        let url_ = this.baseUrl + "/api/sqldbd-installer/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<DownloadFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileResponse>(null as any);
    }

    /**
     * Toggle whether customers receive the previous SQLDBD installer version
     */
    updateFallback(request: UpdateSqlDbdInstallerFallbackRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/sqldbd-installer/fallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFallback(_response);
        });
    }

    protected processUpdateFallback(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Queue a new SQLDBD installer build to upload in the background (SuperAdmin only)
     */
    upload(request: FileUploadRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/sqldbd-installer/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SubscriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Retrieve all subscription details
     */
    getAllSubscriptionDetails(): Promise<GetSubscriptionPlanDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/get-all-subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSubscriptionDetails(_response);
        });
    }

    protected processGetAllSubscriptionDetails(response: Response): Promise<GetSubscriptionPlanDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSubscriptionPlanDetailsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSubscriptionPlanDetailsResponse[]>(null as any);
    }

    /**
     * List activated devices for current tenant
     */
    getLicenseDevices(): Promise<LicenseDeviceResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/license/devices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseDevices(_response);
        });
    }

    protected processGetLicenseDevices(response: Response): Promise<LicenseDeviceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseDeviceResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDeviceResponse[]>(null as any);
    }

    /**
     * Get active SQL Server instance count for current tenant
     */
    getActiveSqlInstanceCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/subscription/license/sql-instances/active-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveSqlInstanceCount(_response);
        });
    }

    protected processGetActiveSqlInstanceCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deactivateLicenseDevice(activationId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/license/devices/{activationId}/deactivate";
        if (activationId === undefined || activationId === null)
            throw new globalThis.Error("The parameter 'activationId' must be defined.");
        url_ = url_.replace("{activationId}", encodeURIComponent("" + activationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateLicenseDevice(_response);
        });
    }

    protected processDeactivateLicenseDevice(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Browse public subscription plans (anonymous)
     */
    browsePlans(): Promise<GetPublicSubscriptionPlanResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/browse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBrowsePlans(_response);
        });
    }

    protected processBrowsePlans(response: Response): Promise<GetPublicSubscriptionPlanResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPublicSubscriptionPlanResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicSubscriptionPlanResponse[]>(null as any);
    }

    getCurrentSubscriptionDetail(): Promise<TenantCurrentSubscriptionDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/current-subscription-detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentSubscriptionDetail(_response);
        });
    }

    protected processGetCurrentSubscriptionDetail(response: Response): Promise<TenantCurrentSubscriptionDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantCurrentSubscriptionDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantCurrentSubscriptionDetailResponse>(null as any);
    }

    /**
     * Get public subscription plans for tenant admin
     */
    getPublicPlans(): Promise<GetPublicSubscriptionPlanResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPublicPlans(_response);
        });
    }

    protected processGetPublicPlans(response: Response): Promise<GetPublicSubscriptionPlanResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPublicSubscriptionPlanResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicSubscriptionPlanResponse[]>(null as any);
    }

    /**
     * Cancel current subscription
     */
    cancelSubscription(request: CancelSubscriptionRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/subscription/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelSubscription(_response);
        });
    }

    protected processCancelSubscription(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Upgrade to a higher subscription plan
     */
    upgradeSubscription(request: UpgradeSubscriptionRequest): Promise<AssignSubscriptionPlanResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription/upgrade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpgradeSubscription(_response);
        });
    }

    protected processUpgradeSubscription(response: Response): Promise<AssignSubscriptionPlanResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignSubscriptionPlanResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignSubscriptionPlanResponse>(null as any);
    }

    /**
     * Renew subscription with selected plan
     */
    renewSubscription(subscriptionPlanId: number): Promise<AssignSubscriptionPlanResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription/renew/{subscriptionPlanId}";
        if (subscriptionPlanId === undefined || subscriptionPlanId === null)
            throw new globalThis.Error("The parameter 'subscriptionPlanId' must be defined.");
        url_ = url_.replace("{subscriptionPlanId}", encodeURIComponent("" + subscriptionPlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewSubscription(_response);
        });
    }

    protected processRenewSubscription(response: Response): Promise<AssignSubscriptionPlanResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignSubscriptionPlanResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignSubscriptionPlanResponse>(null as any);
    }

    /**
     * Get subscription payment history
     */
    getPayments(): Promise<SubscriptionPaymentResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/subscription/payments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayments(_response);
        });
    }

    protected processGetPayments(response: Response): Promise<SubscriptionPaymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionPaymentResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionPaymentResponse[]>(null as any);
    }

    /**
     * Download license file content
     */
    getLicense(): Promise<LicenseDownloadResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription/license";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicense(_response);
        });
    }

    protected processGetLicense(response: Response): Promise<LicenseDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDownloadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDownloadResponse>(null as any);
    }

    /**
     * Download the NIBIRU SQLDBD desktop application installer
     */
    getSqlDbd(): Promise<DownloadFileResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription/sqldbd";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSqlDbd(_response);
        });
    }

    protected processGetSqlDbd(response: Response): Promise<DownloadFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileResponse>(null as any);
    }

    /**
     * Get recent license and subscription events for the current tenant
     * @param count (optional) 
     */
    getMyNotifications(count: number | undefined): Promise<TenantEventNotificationResponse[]> {
        let url_ = this.baseUrl + "/api/subscription/my-notifications?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyNotifications(_response);
        });
    }

    protected processGetMyNotifications(response: Response): Promise<TenantEventNotificationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantEventNotificationResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantEventNotificationResponse[]>(null as any);
    }

    /**
     * Request an offline grant token (authenticated tenant route)
     */
    requestOfflineGrant(request: OfflineGrantRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/subscription/offline-grant/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestOfflineGrant(_response);
        });
    }

    protected processRequestOfflineGrant(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Validate an offline grant token (authenticated tenant route)
     */
    validateOfflineGrant(request: OfflineGrantValidateRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/subscription/offline-grant/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateOfflineGrant(_response);
        });
    }

    protected processValidateOfflineGrant(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }
}

export class SubscriptionPlanAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create subscription plan
     */
    create(request: CreateSubscriptionPlanAdminRequest): Promise<CreateSubscriptionPlanAdminResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CreateSubscriptionPlanAdminResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionPlanAdminResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionPlanAdminResponse>(null as any);
    }

    /**
     * Update subscription plan
     */
    update(request: UpdateSubscriptionPlanAdminRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete subscription plan
     */
    delete(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get subscription plan by id
     */
    getById(id: number): Promise<ViewSubscriptionPlanDetailResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ViewSubscriptionPlanDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewSubscriptionPlanDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewSubscriptionPlanDetailResponse>(null as any);
    }

    /**
     * Search subscription plans
     */
    search(request: SearchSubscriptionPlansRequest): Promise<PaginationResponseOfViewSubscriptionPlanListResponse> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfViewSubscriptionPlanListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewSubscriptionPlanListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewSubscriptionPlanListResponse>(null as any);
    }

    /**
     * Activate subscription plan
     */
    activate(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/{id}/activate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deactivate subscription plan
     */
    deactivate(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/subscription/subscription-plans/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SubscriptionQuoteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create subscription price quote
     */
    createQuote(request: CreateSubscriptionQuoteRequest): Promise<SubscriptionQuoteResponse> {
        let url_ = this.baseUrl + "/api/v1/subscription/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateQuote(_response);
        });
    }

    protected processCreateQuote(response: Response): Promise<SubscriptionQuoteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionQuoteResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionQuoteResponse>(null as any);
    }

    getQuote(quoteId: string): Promise<SubscriptionQuoteResponse> {
        let url_ = this.baseUrl + "/api/v1/subscription/quote/{quoteId}";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuote(_response);
        });
    }

    protected processGetQuote(response: Response): Promise<SubscriptionQuoteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionQuoteResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionQuoteResponse>(null as any);
    }
}

export class TransactionAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Search subscription payment transactions (super admin)
     */
    search(request: SearchAdminTransactionsRequest): Promise<PaginationResponseOfAdminTransactionListResponse> {
        let url_ = this.baseUrl + "/api/subscription/transactions/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfAdminTransactionListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfAdminTransactionListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfAdminTransactionListResponse>(null as any);
    }

    /**
     * Transaction analytics for current filters
     */
    getAnalyticsSummary(request: SearchAdminTransactionsRequest): Promise<TransactionAnalyticsSummaryResponse> {
        let url_ = this.baseUrl + "/api/subscription/transactions/analytics/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalyticsSummary(_response);
        });
    }

    protected processGetAnalyticsSummary(response: Response): Promise<TransactionAnalyticsSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionAnalyticsSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionAnalyticsSummaryResponse>(null as any);
    }
}

export class SettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Retrieve all settings
     */
    getSettings(): Promise<ViewSettingResponse[]> {
        let url_ = this.baseUrl + "/api/settings/get-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: Response): Promise<ViewSettingResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewSettingResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewSettingResponse[]>(null as any);
    }

    /**
     * Update setting details
     */
    updateSettings(request: UpdateSettingsRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/settings/update-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSettings(_response);
        });
    }

    protected processUpdateSettings(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create a Stripe PaymentIntent or Subscription and return the client secret.
     * @param api_version (optional) 
     */
    createIntent(api_version: string | null | undefined, request: CreateIntentRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/create-intent?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateIntent(_response);
        });
    }

    protected processCreateIntent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Poll payment status by transaction key (no JSON parsing — reads DB field directly).
     * @param api_version (optional) 
     */
    getStatus(transKey: string, api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/status/{transKey}?";
        if (transKey === undefined || transKey === null)
            throw new globalThis.Error("The parameter 'transKey' must be defined.");
        url_ = url_.replace("{transKey}", encodeURIComponent("" + transKey));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Paginated payment history for the current tenant.
     * @param api_version (optional) 
     */
    getHistory(api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/history?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a Stripe invoice PDF.
     * @param api_version (optional) 
     */
    downloadInvoice(invoiceId: number, api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/download-invoice/{invoiceId}?";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInvoice(_response);
        });
    }

    protected processDownloadInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Stripe webhook — validates signature, then processes event idempotently.
     * @param api_version (optional) 
     */
    webhook(api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/webhook?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWebhook(_response);
        });
    }

    protected processWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * List saved card payment methods for the current tenant (Stripe tokenized — no raw card data).
     * @param api_version (optional) 
     */
    getPaymentMethods(api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/payment-methods?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentMethods(_response);
        });
    }

    protected processGetPaymentMethods(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Create a SetupIntent so the client can tokenize a new card via Stripe Elements.
     * @param api_version (optional) 
     */
    createSetupIntent(api_version: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/setup-intent?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSetupIntent(_response);
        });
    }

    protected processCreateSetupIntent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Set the tenant's default saved card for future charges.
     * @param api_version (optional) 
     */
    setDefaultPaymentMethod(api_version: string | null | undefined, request: PaymentMethodIdRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/payment-methods/default?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDefaultPaymentMethod(_response);
        });
    }

    protected processSetDefaultPaymentMethod(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Remove a saved card from the tenant's Stripe customer.
     * @param api_version (optional) 
     */
    detachPaymentMethod(api_version: string | null | undefined, request: PaymentMethodIdRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/payment-methods/detach?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDetachPaymentMethod(_response);
        });
    }

    protected processDetachPaymentMethod(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CampaignClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create a campaign
     */
    create(request: CreateCampaignRequest): Promise<CampaignDetailResponse> {
        let url_ = this.baseUrl + "/api/nexus/campaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CampaignDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignDetailResponse>(null as any);
    }

    /**
     * Delete a campaign
     */
    delete(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/nexus/campaigns/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a campaign by id
     */
    getById(id: number): Promise<CampaignDetailResponse> {
        let url_ = this.baseUrl + "/api/nexus/campaigns/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<CampaignDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignDetailResponse>(null as any);
    }

    /**
     * Search campaigns
     */
    search(request: SearchCampaignsRequest): Promise<PaginationResponseOfCampaignListResponse> {
        let url_ = this.baseUrl + "/api/nexus/campaigns/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfCampaignListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfCampaignListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfCampaignListResponse>(null as any);
    }

    /**
     * Resolve a public campaign registration link
     * @param campaignUniqueName (optional) 
     * @param sourceSlug (optional) 
     */
    resolveRegistrationLink(campaignUniqueName: string | undefined, sourceSlug: string | undefined): Promise<CampaignRegistrationResolveResponse> {
        let url_ = this.baseUrl + "/api/nexus/campaigns/registration-link?";
        if (campaignUniqueName === null)
            throw new globalThis.Error("The parameter 'campaignUniqueName' cannot be null.");
        else if (campaignUniqueName !== undefined)
            url_ += "CampaignUniqueName=" + encodeURIComponent("" + campaignUniqueName) + "&";
        if (sourceSlug === null)
            throw new globalThis.Error("The parameter 'sourceSlug' cannot be null.");
        else if (sourceSlug !== undefined)
            url_ += "SourceSlug=" + encodeURIComponent("" + sourceSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResolveRegistrationLink(_response);
        });
    }

    protected processResolveRegistrationLink(response: Response): Promise<CampaignRegistrationResolveResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignRegistrationResolveResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignRegistrationResolveResponse>(null as any);
    }
}

export class MultiTenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    getTenant(request: SearchTenantRequest): Promise<PaginationResponseOfViewTenantResponse> {
        let url_ = this.baseUrl + "/api/multitenant/get-tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<PaginationResponseOfViewTenantResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewTenantResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewTenantResponse>(null as any);
    }

    getTenantSubscription(id: number | null): Promise<GetTenantSubscriptionResponse[]> {
        let url_ = this.baseUrl + "/api/multitenant/get-tenant-subscriptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantSubscription(_response);
        });
    }

    protected processGetTenantSubscription(response: Response): Promise<GetTenantSubscriptionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTenantSubscriptionResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTenantSubscriptionResponse[]>(null as any);
    }

    downloadInvoice(id: number): Promise<DownloadFileResponse> {
        let url_ = this.baseUrl + "/api/multitenant/download-invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInvoice(_response);
        });
    }

    protected processDownloadInvoice(response: Response): Promise<DownloadFileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileResponse>(null as any);
    }

    getTenantUsers(id: number): Promise<ViewUserDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/multitenant/get-tenant-users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantUsers(_response);
        });
    }

    protected processGetTenantUsers(response: Response): Promise<ViewUserDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewUserDetailsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserDetailsResponse[]>(null as any);
    }

    getTenantById(id: number): Promise<ViewTenantResponse> {
        let url_ = this.baseUrl + "/api/multitenant/get-tenant/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantById(_response);
        });
    }

    protected processGetTenantById(response: Response): Promise<ViewTenantResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewTenantResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewTenantResponse>(null as any);
    }

    updateTenantDetails(request: UpdateTenantRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/multitenant/update-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenantDetails(_response);
        });
    }

    protected processUpdateTenantDetails(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LookUpClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Retrieve all look-ups
     */
    getLookUpCodes(): Promise<ViewLookUpsResponse[]> {
        let url_ = this.baseUrl + "/api/v1/lookup/get-look-ups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodes(_response);
        });
    }

    protected processGetLookUpCodes(response: Response): Promise<ViewLookUpsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewLookUpsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewLookUpsResponse[]>(null as any);
    }

    /**
     * Retrieve look-up values
     */
    getLookUpCodeValues(request: SearchLookUpCodeValuesRequest): Promise<PaginationResponseOfViewLookUpCodeValuesResponse> {
        let url_ = this.baseUrl + "/api/v1/lookup/get-look-up-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodeValues(_response);
        });
    }

    protected processGetLookUpCodeValues(response: Response): Promise<PaginationResponseOfViewLookUpCodeValuesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewLookUpCodeValuesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewLookUpCodeValuesResponse>(null as any);
    }

    /**
     * Create a new item for look-up
     */
    createLookUpCodeValue(request: CreateLookUpCodeValueRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/lookup/create-look-up-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLookUpCodeValue(_response);
        });
    }

    protected processCreateLookUpCodeValue(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get look-up value by id
     */
    getLookUpCodeValueById(id: number): Promise<ViewLookUpCodeValuesResponse> {
        let url_ = this.baseUrl + "/api/v1/lookup/get-look-up-value/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodeValueById(_response);
        });
    }

    protected processGetLookUpCodeValueById(response: Response): Promise<ViewLookUpCodeValuesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewLookUpCodeValuesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewLookUpCodeValuesResponse>(null as any);
    }

    /**
     * Update look-up value
     */
    updateLookUpCodeValue(request: UpdateLookUpCodeValueRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/lookup/update-look-up-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLookUpCodeValue(_response);
        });
    }

    protected processUpdateLookUpCodeValue(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PlatformLookUpClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Retrieve all platform look-ups
     * @param api_version (optional) 
     */
    getLookUpCodes(api_version: string | null | undefined): Promise<ViewPlatformLookUpsResponse[]> {
        let url_ = this.baseUrl + "/platform-lookup/get-look-ups?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodes(_response);
        });
    }

    protected processGetLookUpCodes(response: Response): Promise<ViewPlatformLookUpsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewPlatformLookUpsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewPlatformLookUpsResponse[]>(null as any);
    }

    /**
     * Retrieve platform look-up values
     * @param api_version (optional) 
     */
    getLookUpCodeValues(api_version: string | null | undefined, request: SearchPlatformLookUpCodeValuesRequest): Promise<PaginationResponseOfViewPlatformLookUpCodeValuesResponse> {
        let url_ = this.baseUrl + "/platform-lookup/get-look-up-values?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodeValues(_response);
        });
    }

    protected processGetLookUpCodeValues(response: Response): Promise<PaginationResponseOfViewPlatformLookUpCodeValuesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewPlatformLookUpCodeValuesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewPlatformLookUpCodeValuesResponse>(null as any);
    }

    /**
     * Create a new platform look-up value
     * @param api_version (optional) 
     */
    createLookUpCodeValue(api_version: string | null | undefined, request: CreatePlatformLookUpCodeValueRequest): Promise<string> {
        let url_ = this.baseUrl + "/platform-lookup/create-look-up-value?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLookUpCodeValue(_response);
        });
    }

    protected processCreateLookUpCodeValue(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get platform look-up value by id
     * @param api_version (optional) 
     */
    getLookUpCodeValueById(id: number, api_version: string | null | undefined): Promise<ViewPlatformLookUpCodeValuesResponse> {
        let url_ = this.baseUrl + "/platform-lookup/get-look-up-value/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookUpCodeValueById(_response);
        });
    }

    protected processGetLookUpCodeValueById(response: Response): Promise<ViewPlatformLookUpCodeValuesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewPlatformLookUpCodeValuesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewPlatformLookUpCodeValuesResponse>(null as any);
    }

    /**
     * Update platform look-up value
     * @param api_version (optional) 
     */
    updateLookUpCodeValue(api_version: string | null | undefined, request: UpdatePlatformLookUpCodeValueRequest): Promise<string> {
        let url_ = this.baseUrl + "/platform-lookup/update-look-up-value?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLookUpCodeValue(_response);
        });
    }

    protected processUpdateLookUpCodeValue(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LocalizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create a new country
     */
    createCountry(request: CreateCountryRequest): Promise<CreateCountryResponse> {
        let url_ = this.baseUrl + "/api/localization/create-country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCountry(_response);
        });
    }

    protected processCreateCountry(response: Response): Promise<CreateCountryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCountryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCountryResponse>(null as any);
    }

    /**
     * Get all country
     */
    getCountry(): Promise<ViewCountryResponse[]> {
        let url_ = this.baseUrl + "/api/localization/get-countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountry(_response);
        });
    }

    protected processGetCountry(response: Response): Promise<ViewCountryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewCountryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewCountryResponse[]>(null as any);
    }

    /**
     * Get a country by Id
     */
    getCountryById(id: number): Promise<ViewCountryResponse> {
        let url_ = this.baseUrl + "/api/localization/get-country-id/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountryById(_response);
        });
    }

    protected processGetCountryById(response: Response): Promise<ViewCountryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewCountryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewCountryResponse>(null as any);
    }

    /**
     * Update a country by Id
     */
    updateCountry(request: UpdateCountryRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/localization/update-country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCountry(_response);
        });
    }

    protected processUpdateCountry(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete a country
     */
    deleteCountry(countryId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/localization/delete-country/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCountry(_response);
        });
    }

    protected processDeleteCountry(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create a localization for country
     */
    createCountryLocalization(request: CreateCountryLocalizationRequest): Promise<CreateCountryLocalizationResponse> {
        let url_ = this.baseUrl + "/api/localization/create-localization-for-country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCountryLocalization(_response);
        });
    }

    protected processCreateCountryLocalization(response: Response): Promise<CreateCountryLocalizationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCountryLocalizationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCountryLocalizationResponse>(null as any);
    }

    /**
     * Get a localization for selected country
     */
    getCountryLocalization(request: SearchCountryLocalizationRequest): Promise<PaginationResponseOfViewCountryLocalizationResponse> {
        let url_ = this.baseUrl + "/api/localization/get-localizations-by-country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountryLocalization(_response);
        });
    }

    protected processGetCountryLocalization(response: Response): Promise<PaginationResponseOfViewCountryLocalizationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewCountryLocalizationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewCountryLocalizationResponse>(null as any);
    }

    /**
     * Get a localization by country Id
     */
    getCountryLocalizationById(id: number): Promise<ViewCountryLocalizationResponse> {
        let url_ = this.baseUrl + "/api/localization/get-localization-by-country-id/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountryLocalizationById(_response);
        });
    }

    protected processGetCountryLocalizationById(response: Response): Promise<ViewCountryLocalizationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewCountryLocalizationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewCountryLocalizationResponse>(null as any);
    }

    /**
     * Update a localization by country Id
     */
    updateCountryLocalization(request: UpdateCountryLocalizationRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/localization/update-localization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCountryLocalization(_response);
        });
    }

    protected processUpdateCountryLocalization(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LicenseVClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Validate license (v1)
     */
    validate(request: ValidateLicenseRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Activate license on device (v1)
     */
    activate(request: ActivateLicenseRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Deactivate license on device (v1)
     */
    deactivate(request: DeactivateLicenseRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * License heartbeat (v1)
     */
    heartbeat(request: ActivateLicenseRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHeartbeat(_response);
        });
    }

    protected processHeartbeat(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Issue 24h offline grant (v1)
     */
    offlineGrant(request: OfflineGrantRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/offline-grant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfflineGrant(_response);
        });
    }

    protected processOfflineGrant(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Validate offline grant token (v1)
     */
    offlineValidate(request: OfflineGrantValidateRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/offline-validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOfflineValidate(_response);
        });
    }

    protected processOfflineValidate(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Decode subscription snapshot from license JWT (v1)
     */
    decodePayload(request: ValidateLicenseRequest): Promise<LicensePayloadSnapshot> {
        let url_ = this.baseUrl + "/api/v1/license/decode-payload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDecodePayload(_response);
        });
    }

    protected processDecodePayload(response: Response): Promise<LicensePayloadSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicensePayloadSnapshot.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicensePayloadSnapshot>(null as any);
    }

    /**
     * Register SQL Server instance (v1)
     */
    registerSqlInstance(request: RegisterSqlServerInstanceRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/sql-instances/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterSqlInstance(_response);
        });
    }

    protected processRegisterSqlInstance(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Unregister SQL Server instance (v1)
     */
    unregisterSqlInstance(request: UnregisterSqlServerInstanceRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/sql-instances/unregister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnregisterSqlInstance(_response);
        });
    }

    protected processUnregisterSqlInstance(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }

    /**
     * Sync SQL Server instances from installation (v1)
     */
    syncSqlInstances(request: SyncSqlServerInstancesRequest): Promise<LicenseOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/license/sql-instances/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncSqlInstances(_response);
        });
    }

    protected processSyncSqlInstances(response: Response): Promise<LicenseOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOperationResponse>(null as any);
    }
}

export class PersonalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Get profile details of currently logged in user.
     */
    getProfile(): Promise<ViewUserDetailsResponse> {
        let url_ = this.baseUrl + "/api/personal/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<ViewUserDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewUserDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserDetailsResponse>(null as any);
    }

    /**
     * Update profile details of currently logged in user.
     */
    updateProfile(request: UpdateUserRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/personal/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Two Factor Authentication Details of currently logged in user.
     */
    getTwoFactorAuthenticationDetails(): Promise<ViewUserTwoFactorAuthenticationDetailsResponse> {
        let url_ = this.baseUrl + "/api/personal/get-two-factor-authentication-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTwoFactorAuthenticationDetails(_response);
        });
    }

    protected processGetTwoFactorAuthenticationDetails(response: Response): Promise<ViewUserTwoFactorAuthenticationDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewUserTwoFactorAuthenticationDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserTwoFactorAuthenticationDetailsResponse>(null as any);
    }

    /**
     * Update Two Factor Authentication Details of currently logged in user.
     */
    updateTwoFactorAuthenticationDetails(request: UpdateTwoFactorAuthenticationDetailsRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/personal/update-two-factor-authentication-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTwoFactorAuthenticationDetails(_response);
        });
    }

    protected processUpdateTwoFactorAuthenticationDetails(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Change password of currently logged in user.
     */
    changePassword(model: ChangePasswordRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/personal/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get permissions of currently logged in user.
     */
    getPermissions(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/personal/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get authenticator barcode.
     */
    generateAuthenticatorEnable(): Promise<AuthenticatorEnableResponse> {
        let url_ = this.baseUrl + "/api/personal/get-authenticator-barcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateAuthenticatorEnable(_response);
        });
    }

    protected processGenerateAuthenticatorEnable(response: Response): Promise<AuthenticatorEnableResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticatorEnableResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticatorEnableResponse>(null as any);
    }

    /**
     * Verify authenticator code.
     * @param code (optional) 
     */
    verifyAuthenticator(code: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/personal/verify-authenticator?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyAuthenticator(_response);
        });
    }

    protected processVerifyAuthenticator(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class RolesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Get a list of all roles. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    getList(tenantId: number | null | undefined): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/roles?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    /**
     * Create or update a role. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    registerRole(tenantId: number | null | undefined, request: CreateOrUpdateRoleRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/roles?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterRole(_response);
        });
    }

    protected processRegisterRole(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a list of all roles permissions, including any SQLDBD permissions granted to the effective tenant. Pass tenantId to view another org's assignable set (SuperAdmin only).
     * @param tenantId (optional) 
     */
    getAllPermissionList(tenantId: number | null | undefined): Promise<SystemPermission[]> {
        let url_ = this.baseUrl + "/api/roles/get-all?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPermissionList(_response);
        });
    }

    protected processGetAllPermissionList(response: Response): Promise<SystemPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemPermission.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemPermission[]>(null as any);
    }

    /**
     * Get role details. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    getById(id: string, tenantId: number | null | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/roles/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * Delete a role. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    delete(id: string, tenantId: number | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/roles/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get role details with its permissions. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    getByIdWithPermissions(id: string, tenantId: number | null | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/roles/{id}/permissions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByIdWithPermissions(_response);
        });
    }

    protected processGetByIdWithPermissions(response: Response): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * Update a role's permissions. Pass tenantId to act on another org (SuperAdmin only).
     * @param tenantId (optional) 
     */
    updatePermissions(id: string, tenantId: number | null | undefined, request: UpdateRolePermissionsRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/roles/{id}/permissions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePermissions(_response);
        });
    }

    protected processUpdatePermissions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TokensClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Request an access token using credentials.
     */
    getToken(request: TokenRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetToken(_response);
        });
    }

    protected processGetToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    verifyTwoFactor(request: VerifyTwoFactorRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/verify-two-factor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    requestTwoFactorEmailCode(sessionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/tokens/request-two-factor-email-code/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestTwoFactorEmailCode(_response);
        });
    }

    protected processRequestTwoFactorEmailCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Request an access token using a refresh token.
     */
    refresh(request: RefreshTokenRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    getSocialMediaToken(request: SocialMediaTokenRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/social-medial-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSocialMediaToken(_response);
        });
    }

    protected processGetSocialMediaToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Anonymous user creates a user.
     */
    selfRegister(request: RegisterUserRequest): Promise<RegisterUserResponse> {
        let url_ = this.baseUrl + "/api/users/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSelfRegister(_response);
        });
    }

    protected processSelfRegister(response: Response): Promise<RegisterUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterUserResponse>(null as any);
    }

    /**
     * Creates a new user.
     */
    create(request: CreateUserRequest): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUserResponse>(null as any);
    }

    /**
     * Get list of all users.
     */
    getList(): Promise<ViewUserDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<ViewUserDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewUserDetailsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserDetailsResponse[]>(null as any);
    }

    /**
     * SuperAdmin creates a new customer (a new Tenant plus its first Admin user).
     */
    adminCreateCustomer(request: CreateCustomerRequest): Promise<RegisterUserResponse> {
        let url_ = this.baseUrl + "/api/users/admin-create-customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminCreateCustomer(_response);
        });
    }

    protected processAdminCreateCustomer(response: Response): Promise<RegisterUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterUserResponse>(null as any);
    }

    /**
     * Search users with pagination.
     */
    search(request: SearchUsersRequest): Promise<PaginationResponseOfViewUserDetailsResponse> {
        let url_ = this.baseUrl + "/api/users/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfViewUserDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewUserDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewUserDetailsResponse>(null as any);
    }

    /**
     * Export customer data as CSV or JSON.
     */
    exportCustomers(request: ExportCustomersRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/customers/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportCustomers(_response);
        });
    }

    protected processExportCustomers(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get a user's details.
     */
    getById(id: string): Promise<ViewUserDetailsResponse> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ViewUserDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewUserDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserDetailsResponse>(null as any);
    }

    /**
     * Get all users belonging to a specific tenant (SuperAdmin only).
     */
    getByTenant(tenantId: number): Promise<ViewUserDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/users/by-tenant/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByTenant(_response);
        });
    }

    protected processGetByTenant(response: Response): Promise<ViewUserDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewUserDetailsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewUserDetailsResponse[]>(null as any);
    }

    /**
     * Get a user's roles.
     */
    getRoles(id: string): Promise<UserRoleResponse[]> {
        let url_ = this.baseUrl + "/api/users/{id}/roles";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<UserRoleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRoleResponse[]>(null as any);
    }

    /**
     * Update a user's assigned roles.
     */
    assignRoles(id: string, request: UserRolesRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users/{id}/roles";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignRoles(_response);
        });
    }

    protected processAssignRoles(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update a user details.
     */
    updateUser(id: string, request: UpdateUserDetailsRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users/{id}/update";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Confirm email address for a user.
     * @param userId (optional) 
     * @param code (optional) 
     */
    confirmEmail(userId: string | undefined, code: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/users/confirm-email?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * SuperAdmin manually confirms a user's email from the portal.
     */
    adminConfirmEmail(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/users/{id}/confirm-email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminConfirmEmail(_response);
        });
    }

    protected processAdminConfirmEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Request a password reset email for a user.
     */
    forgotPassword(request: ForgotPasswordRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Reset a user's password.
     */
    resetPassword(request: ResetForgotPasswordRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users/reset-forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    changePasswordForcefully(id: string, request: ChangePasswordForcefullyRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users/{id}/change-password-force-fully";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordForcefully(_response);
        });
    }

    protected processChangePasswordForcefully(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EmailLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Get email log records by filter.
     */
    getEmailLogList(request: SearchEmailLogRequest): Promise<PaginationResponseOfViewEmailLogResponse> {
        let url_ = this.baseUrl + "/api/emaillog/get-email-logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailLogList(_response);
        });
    }

    protected processGetEmailLogList(response: Response): Promise<PaginationResponseOfViewEmailLogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewEmailLogResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewEmailLogResponse>(null as any);
    }

    /**
     * Get email log by Id
     */
    getEmailLogById(id: number): Promise<ViewEmailLogDetailResponse> {
        let url_ = this.baseUrl + "/api/emaillog/get-email-log/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailLogById(_response);
        });
    }

    protected processGetEmailLogById(response: Response): Promise<ViewEmailLogDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewEmailLogDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewEmailLogDetailResponse>(null as any);
    }
}

export class EmailTemplateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Create a new email template
     */
    createEmailTemplate(request: CreateEmailTemplateRequest): Promise<CreateEmailTemplateResponse> {
        let url_ = this.baseUrl + "/api/emailtemplate/create-email-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateEmailTemplate(_response);
        });
    }

    protected processCreateEmailTemplate(response: Response): Promise<CreateEmailTemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateEmailTemplateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEmailTemplateResponse>(null as any);
    }

    /**
     * Get email template by id
     */
    getEmailTemplateById(id: number): Promise<ViewEmailTemplateDetailResponse> {
        let url_ = this.baseUrl + "/api/emailtemplate/get-email-template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailTemplateById(_response);
        });
    }

    protected processGetEmailTemplateById(response: Response): Promise<ViewEmailTemplateDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewEmailTemplateDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewEmailTemplateDetailResponse>(null as any);
    }

    /**
     * Update email template details
     */
    updateEmailTemplate(request: UpdateEmailTemplateRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/emailtemplate/update-email-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmailTemplate(_response);
        });
    }

    protected processUpdateEmailTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Retrieve all email templates
     */
    getEmailTemplates(request: SearchEmailTemplateRequest): Promise<PaginationResponseOfViewEmailTemplateResponse> {
        let url_ = this.baseUrl + "/api/emailtemplate/get-email-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: Response): Promise<PaginationResponseOfViewEmailTemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfViewEmailTemplateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfViewEmailTemplateResponse>(null as any);
    }

    /**
     * Delete email-template
     */
    deleteEmailTemplate(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/emailtemplate/delete-email-templateyer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmailTemplate(_response);
        });
    }

    protected processDeleteEmailTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DesktopAuthVClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Desktop application login (Nibiru identity + license validation)
     */
    login(request: DesktopAuthLoginRequest): Promise<DesktopAuthLoginResponse> {
        let url_ = this.baseUrl + "/api/v1/desktop/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<DesktopAuthLoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesktopAuthLoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesktopAuthLoginResponse>(null as any);
    }

    /**
     * Validate desktop user credentials without a license key
     */
    validateUser(request: DesktopAuthCredentialsRequest): Promise<DesktopAuthValidateUserResponse> {
        let url_ = this.baseUrl + "/api/v1/desktop/auth/validate-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateUser(_response);
        });
    }

    protected processValidateUser(response: Response): Promise<DesktopAuthValidateUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesktopAuthValidateUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesktopAuthValidateUserResponse>(null as any);
    }
}

export class DesktopLicenseVClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Resolve active tenant license JWT after credential validation
     */
    resolveForTenant(request: DesktopAuthCredentialsRequest): Promise<DesktopResolveLicenseResponse> {
        let url_ = this.baseUrl + "/api/v1/desktop/license/resolve-for-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResolveForTenant(_response);
        });
    }

    protected processResolveForTenant(response: Response): Promise<DesktopResolveLicenseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesktopResolveLicenseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesktopResolveLicenseResponse>(null as any);
    }
}

export class AuditLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7027";
    }

    /**
     * Search audit trail records. SuperAdmin sees every tenant; everyone else is restricted to
    their own tenant's records (enforced server-side in AuditTrailService, not just by this gate).
     */
    search(request: SearchAuditTrailRequest): Promise<PaginationResponseOfAuditTrailResponse> {
        let url_ = this.baseUrl + "/api/auditlog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginationResponseOfAuditTrailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfAuditTrailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginationResponseOfAuditTrailResponse>(null as any);
    }

    /**
     * Export audit trail records as CSV — same tenant scoping as Search.
     */
    export(request: SearchAuditTrailRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auditlog/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DropDownItemResponse implements IDropDownItemResponse {
    value!: number;
    text!: string;
    strValue?: string | undefined;

    constructor(data?: IDropDownItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
            this.strValue = _data["strValue"];
        }
    }

    static fromJS(data: any): DropDownItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        data["strValue"] = this.strValue;
        return data;
    }
}

export interface IDropDownItemResponse {
    value: number;
    text: string;
    strValue?: string | undefined;
}

export enum LookUpCodeTypes {
    Temp = "Temp",
    Temp1 = "Temp1",
}

export enum PlatformLookUpCodeTypes {
    UserTimeZone = "UserTimeZone",
    WindowsClientVersion = "WindowsClientVersion",
    MicrosoftSqlServerVersion = "MicrosoftSqlServerVersion",
    WindowsServerVersion = "WindowsServerVersion",
    JobTitle = "JobTitle",
    RegistrationSource = "RegistrationSource",
}

export class UserDropDownItemResponse implements IUserDropDownItemResponse {
    text!: string;
    strValue?: string | undefined;
    timeZone?: string | undefined;

    constructor(data?: IUserDropDownItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.strValue = _data["strValue"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UserDropDownItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDropDownItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["strValue"] = this.strValue;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUserDropDownItemResponse {
    text: string;
    strValue?: string | undefined;
    timeZone?: string | undefined;
}

export class ViewCountryLocalizationResponse implements IViewCountryLocalizationResponse {
    id!: number;
    fkCountryId!: number;
    key!: string;
    value!: string;

    constructor(data?: IViewCountryLocalizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkCountryId = _data["fkCountryId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ViewCountryLocalizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCountryLocalizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkCountryId"] = this.fkCountryId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IViewCountryLocalizationResponse {
    id: number;
    fkCountryId: number;
    key: string;
    value: string;
}

export class SupportDocumentResponse implements ISupportDocumentResponse {
    id?: number;
    title?: string;
    description?: string | undefined;
    fileName?: string;
    extension?: string;
    sizeBytes?: number;
    createdOn?: moment.Moment;
    uploadedByName?: string | undefined;
    /** Uploader's tenant/customer name. Null for documents SuperAdmin published globally. */
    tenantName?: string | undefined;
    /** Whether the current caller is allowed to delete this specific document. */
    canDelete?: boolean;
    /** Reference of the support ticket this document is attached to, if any. */
    ticketReference?: string | undefined;

    constructor(data?: ISupportDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.fileName = _data["fileName"];
            this.extension = _data["extension"];
            this.sizeBytes = _data["sizeBytes"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.uploadedByName = _data["uploadedByName"];
            this.tenantName = _data["tenantName"];
            this.canDelete = _data["canDelete"];
            this.ticketReference = _data["ticketReference"];
        }
    }

    static fromJS(data: any): SupportDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupportDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["fileName"] = this.fileName;
        data["extension"] = this.extension;
        data["sizeBytes"] = this.sizeBytes;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["uploadedByName"] = this.uploadedByName;
        data["tenantName"] = this.tenantName;
        data["canDelete"] = this.canDelete;
        data["ticketReference"] = this.ticketReference;
        return data;
    }
}

export interface ISupportDocumentResponse {
    id?: number;
    title?: string;
    description?: string | undefined;
    fileName?: string;
    extension?: string;
    sizeBytes?: number;
    createdOn?: moment.Moment;
    uploadedByName?: string | undefined;
    /** Uploader's tenant/customer name. Null for documents SuperAdmin published globally. */
    tenantName?: string | undefined;
    /** Whether the current caller is allowed to delete this specific document. */
    canDelete?: boolean;
    /** Reference of the support ticket this document is attached to, if any. */
    ticketReference?: string | undefined;
}

export class UploadSupportDocumentRequest implements IUploadSupportDocumentRequest {
    title!: string;
    description?: string | undefined;
    file!: FileUploadRequest;
    /** Optional support ticket this document should be linked to. */
    supportInquiryId?: number | undefined;

    constructor(data?: IUploadSupportDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.file = new FileUploadRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.file = _data["file"] ? FileUploadRequest.fromJS(_data["file"]) : new FileUploadRequest();
            this.supportInquiryId = _data["supportInquiryId"];
        }
    }

    static fromJS(data: any): UploadSupportDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSupportDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["supportInquiryId"] = this.supportInquiryId;
        return data;
    }
}

export interface IUploadSupportDocumentRequest {
    title: string;
    description?: string | undefined;
    file: FileUploadRequest;
    /** Optional support ticket this document should be linked to. */
    supportInquiryId?: number | undefined;
}

export class FileUploadRequest implements IFileUploadRequest {
    name?: string;
    extension?: string;
    data?: string;

    constructor(data?: IFileUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FileUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["data"] = this.data;
        return data;
    }
}

export interface IFileUploadRequest {
    name?: string;
    extension?: string;
    data?: string;
}

export class DownloadFileResponse implements IDownloadFileResponse {
    name!: string;
    extension!: string;
    fileBase64String!: string;

    constructor(data?: IDownloadFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.fileBase64String = _data["fileBase64String"];
        }
    }

    static fromJS(data: any): DownloadFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["fileBase64String"] = this.fileBase64String;
        return data;
    }
}

export interface IDownloadFileResponse {
    name: string;
    extension: string;
    fileBase64String: string;
}

export class SupportInquiryDetailResponse implements ISupportInquiryDetailResponse {
    id?: number;
    ticketReference!: string;
    subject!: string;
    description!: string;
    status?: SupportInquiryStatusTypes;
    createdOn?: moment.Moment;
    submitterEmail?: string | undefined;
    submitterName?: string | undefined;
    tenantName?: string | undefined;
    emailLogId?: number | undefined;
    timeline?: SupportInquiryEventResponse[];
    attachments?: SupportDocumentResponse[];

    constructor(data?: ISupportInquiryDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketReference = _data["ticketReference"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.submitterEmail = _data["submitterEmail"];
            this.submitterName = _data["submitterName"];
            this.tenantName = _data["tenantName"];
            this.emailLogId = _data["emailLogId"];
            if (Array.isArray(_data["timeline"])) {
                this.timeline = [] as any;
                for (let item of _data["timeline"])
                    this.timeline!.push(SupportInquiryEventResponse.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(SupportDocumentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupportInquiryDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupportInquiryDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketReference"] = this.ticketReference;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["submitterEmail"] = this.submitterEmail;
        data["submitterName"] = this.submitterName;
        data["tenantName"] = this.tenantName;
        data["emailLogId"] = this.emailLogId;
        if (Array.isArray(this.timeline)) {
            data["timeline"] = [];
            for (let item of this.timeline)
                data["timeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISupportInquiryDetailResponse {
    id?: number;
    ticketReference: string;
    subject: string;
    description: string;
    status?: SupportInquiryStatusTypes;
    createdOn?: moment.Moment;
    submitterEmail?: string | undefined;
    submitterName?: string | undefined;
    tenantName?: string | undefined;
    emailLogId?: number | undefined;
    timeline?: SupportInquiryEventResponse[];
    attachments?: SupportDocumentResponse[];
}

export enum SupportInquiryStatusTypes {
    Open = "Open",
    Delivered = "Delivered",
    Failed = "Failed",
}

export class SupportInquiryEventResponse implements ISupportInquiryEventResponse {
    id?: number;
    eventType!: string;
    summary!: string;
    createdOn?: moment.Moment;
    emailLogId?: number | undefined;

    constructor(data?: ISupportInquiryEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventType = _data["eventType"];
            this.summary = _data["summary"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.emailLogId = _data["emailLogId"];
        }
    }

    static fromJS(data: any): SupportInquiryEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupportInquiryEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventType"] = this.eventType;
        data["summary"] = this.summary;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["emailLogId"] = this.emailLogId;
        return data;
    }
}

export interface ISupportInquiryEventResponse {
    id?: number;
    eventType: string;
    summary: string;
    createdOn?: moment.Moment;
    emailLogId?: number | undefined;
}

export class CreateSupportInquiryRequest implements ICreateSupportInquiryRequest {
    subject!: string;
    description!: string;
    /** Optional file attached to the ticket when it's submitted. */
    attachment?: FileUploadRequest | undefined;

    constructor(data?: ICreateSupportInquiryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.attachment = _data["attachment"] ? FileUploadRequest.fromJS(_data["attachment"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateSupportInquiryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportInquiryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateSupportInquiryRequest {
    subject: string;
    description: string;
    /** Optional file attached to the ticket when it's submitted. */
    attachment?: FileUploadRequest | undefined;
}

export class PaginationResponseOfSupportInquiryListResponse implements IPaginationResponseOfSupportInquiryListResponse {
    data?: SupportInquiryListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfSupportInquiryListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SupportInquiryListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfSupportInquiryListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfSupportInquiryListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfSupportInquiryListResponse {
    data?: SupportInquiryListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SupportInquiryListResponse implements ISupportInquiryListResponse {
    id?: number;
    ticketReference!: string;
    subject!: string;
    status?: SupportInquiryStatusTypes;
    createdOn?: moment.Moment;
    submitterName?: string | undefined;
    tenantName?: string | undefined;
    /** Id of the document attached when this ticket was submitted, if any — lets the grid offer a direct download. */
    attachmentId?: number | undefined;

    constructor(data?: ISupportInquiryListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketReference = _data["ticketReference"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.submitterName = _data["submitterName"];
            this.tenantName = _data["tenantName"];
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): SupportInquiryListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupportInquiryListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketReference"] = this.ticketReference;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["submitterName"] = this.submitterName;
        data["tenantName"] = this.tenantName;
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface ISupportInquiryListResponse {
    id?: number;
    ticketReference: string;
    subject: string;
    status?: SupportInquiryStatusTypes;
    createdOn?: moment.Moment;
    submitterName?: string | undefined;
    tenantName?: string | undefined;
    /** Id of the document attached when this ticket was submitted, if any — lets the grid offer a direct download. */
    attachmentId?: number | undefined;
}

export class SearchSupportInquiryRequest implements ISearchSupportInquiryRequest {
    pageNumber?: number;
    pageSize?: number;
    keyword?: string | undefined;

    constructor(data?: ISearchSupportInquiryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): SearchSupportInquiryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSupportInquiryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface ISearchSupportInquiryRequest {
    pageNumber?: number;
    pageSize?: number;
    keyword?: string | undefined;
}

export class PaginationResponseOfCustomPlanRequestListResponse implements IPaginationResponseOfCustomPlanRequestListResponse {
    data?: CustomPlanRequestListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfCustomPlanRequestListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CustomPlanRequestListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfCustomPlanRequestListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfCustomPlanRequestListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfCustomPlanRequestListResponse {
    data?: CustomPlanRequestListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CustomPlanRequestListResponse implements ICustomPlanRequestListResponse {
    id!: number;
    instances!: number;
    users!: number;
    termMonths!: number;
    monthlyTotal!: number;
    discountPercent!: number;
    totalPrice!: number;
    requesterName?: string | undefined;
    requesterEmail?: string | undefined;
    tenantName?: string | undefined;
    status!: CustomPlanRequestStatusTypes;
    rejectReason?: string | undefined;
    createdOn!: moment.Moment;
    fkApprovedSubscriptionPlanId?: number | undefined;
    approvedOn?: moment.Moment | undefined;
    approvedByUserId?: string | undefined;
    canPay?: boolean;
    activatedOn?: moment.Moment | undefined;

    constructor(data?: ICustomPlanRequestListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instances = _data["instances"];
            this.users = _data["users"];
            this.termMonths = _data["termMonths"];
            this.monthlyTotal = _data["monthlyTotal"];
            this.discountPercent = _data["discountPercent"];
            this.totalPrice = _data["totalPrice"];
            this.requesterName = _data["requesterName"];
            this.requesterEmail = _data["requesterEmail"];
            this.tenantName = _data["tenantName"];
            this.status = _data["status"];
            this.rejectReason = _data["rejectReason"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.fkApprovedSubscriptionPlanId = _data["fkApprovedSubscriptionPlanId"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : undefined as any;
            this.approvedByUserId = _data["approvedByUserId"];
            this.canPay = _data["canPay"];
            this.activatedOn = _data["activatedOn"] ? moment(_data["activatedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CustomPlanRequestListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPlanRequestListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instances"] = this.instances;
        data["users"] = this.users;
        data["termMonths"] = this.termMonths;
        data["monthlyTotal"] = this.monthlyTotal;
        data["discountPercent"] = this.discountPercent;
        data["totalPrice"] = this.totalPrice;
        data["requesterName"] = this.requesterName;
        data["requesterEmail"] = this.requesterEmail;
        data["tenantName"] = this.tenantName;
        data["status"] = this.status;
        data["rejectReason"] = this.rejectReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["fkApprovedSubscriptionPlanId"] = this.fkApprovedSubscriptionPlanId;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedByUserId"] = this.approvedByUserId;
        data["canPay"] = this.canPay;
        data["activatedOn"] = this.activatedOn ? this.activatedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICustomPlanRequestListResponse {
    id: number;
    instances: number;
    users: number;
    termMonths: number;
    monthlyTotal: number;
    discountPercent: number;
    totalPrice: number;
    requesterName?: string | undefined;
    requesterEmail?: string | undefined;
    tenantName?: string | undefined;
    status: CustomPlanRequestStatusTypes;
    rejectReason?: string | undefined;
    createdOn: moment.Moment;
    fkApprovedSubscriptionPlanId?: number | undefined;
    approvedOn?: moment.Moment | undefined;
    approvedByUserId?: string | undefined;
    canPay?: boolean;
    activatedOn?: moment.Moment | undefined;
}

export enum CustomPlanRequestStatusTypes {
    Pending = "Pending",
    Approved = "Approved",
    Activated = "Activated",
    Rejected = "Rejected",
}

export class SearchCustomPlanRequestsRequest implements ISearchCustomPlanRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    keyword?: string | undefined;
    status?: CustomPlanRequestStatusTypes | undefined;

    constructor(data?: ISearchCustomPlanRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.keyword = _data["keyword"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SearchCustomPlanRequestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCustomPlanRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        return data;
    }
}

export interface ISearchCustomPlanRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    keyword?: string | undefined;
    status?: CustomPlanRequestStatusTypes | undefined;
}

export class CustomPlanRequestDetailResponse implements ICustomPlanRequestDetailResponse {
    id!: number;
    instances!: number;
    users!: number;
    termMonths!: number;
    monthlyTotal!: number;
    discountPercent!: number;
    totalPrice!: number;
    requesterName?: string | undefined;
    requesterEmail?: string | undefined;
    tenantName?: string | undefined;
    status!: CustomPlanRequestStatusTypes;
    rejectReason?: string | undefined;
    createdOn!: moment.Moment;
    fkApprovedSubscriptionPlanId?: number | undefined;
    approvedOn?: moment.Moment | undefined;
    approvedByUserId?: string | undefined;
    canPay?: boolean;
    fkTenantSubscriptionPlanId?: number | undefined;
    activatedOn?: moment.Moment | undefined;

    constructor(data?: ICustomPlanRequestDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instances = _data["instances"];
            this.users = _data["users"];
            this.termMonths = _data["termMonths"];
            this.monthlyTotal = _data["monthlyTotal"];
            this.discountPercent = _data["discountPercent"];
            this.totalPrice = _data["totalPrice"];
            this.requesterName = _data["requesterName"];
            this.requesterEmail = _data["requesterEmail"];
            this.tenantName = _data["tenantName"];
            this.status = _data["status"];
            this.rejectReason = _data["rejectReason"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.fkApprovedSubscriptionPlanId = _data["fkApprovedSubscriptionPlanId"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : undefined as any;
            this.approvedByUserId = _data["approvedByUserId"];
            this.canPay = _data["canPay"];
            this.fkTenantSubscriptionPlanId = _data["fkTenantSubscriptionPlanId"];
            this.activatedOn = _data["activatedOn"] ? moment(_data["activatedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CustomPlanRequestDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPlanRequestDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instances"] = this.instances;
        data["users"] = this.users;
        data["termMonths"] = this.termMonths;
        data["monthlyTotal"] = this.monthlyTotal;
        data["discountPercent"] = this.discountPercent;
        data["totalPrice"] = this.totalPrice;
        data["requesterName"] = this.requesterName;
        data["requesterEmail"] = this.requesterEmail;
        data["tenantName"] = this.tenantName;
        data["status"] = this.status;
        data["rejectReason"] = this.rejectReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["fkApprovedSubscriptionPlanId"] = this.fkApprovedSubscriptionPlanId;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["approvedByUserId"] = this.approvedByUserId;
        data["canPay"] = this.canPay;
        data["fkTenantSubscriptionPlanId"] = this.fkTenantSubscriptionPlanId;
        data["activatedOn"] = this.activatedOn ? this.activatedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICustomPlanRequestDetailResponse {
    id: number;
    instances: number;
    users: number;
    termMonths: number;
    monthlyTotal: number;
    discountPercent: number;
    totalPrice: number;
    requesterName?: string | undefined;
    requesterEmail?: string | undefined;
    tenantName?: string | undefined;
    status: CustomPlanRequestStatusTypes;
    rejectReason?: string | undefined;
    createdOn: moment.Moment;
    fkApprovedSubscriptionPlanId?: number | undefined;
    approvedOn?: moment.Moment | undefined;
    approvedByUserId?: string | undefined;
    canPay?: boolean;
    fkTenantSubscriptionPlanId?: number | undefined;
    activatedOn?: moment.Moment | undefined;
}

export class RejectCustomPlanRequestRequest implements IRejectCustomPlanRequestRequest {
    rejectReason?: string | undefined;

    constructor(data?: IRejectCustomPlanRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rejectReason = _data["rejectReason"];
        }
    }

    static fromJS(data: any): RejectCustomPlanRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectCustomPlanRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rejectReason"] = this.rejectReason;
        return data;
    }
}

export interface IRejectCustomPlanRequestRequest {
    rejectReason?: string | undefined;
}

export class CustomPricingConfigurationResponse implements ICustomPricingConfigurationResponse {
    id?: number;
    instancePricePerUnit?: number;
    minInstances?: number;
    maxInstances?: number;
    userPricePerUnit?: number;
    minUsers?: number;
    maxUsers?: number;
    isActive?: boolean;
    twoYearDiscountPercent?: number;
    threeYearDiscountPercent?: number;
    isConfigured?: boolean;
    lastModifiedOn?: moment.Moment | undefined;

    constructor(data?: ICustomPricingConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instancePricePerUnit = _data["instancePricePerUnit"];
            this.minInstances = _data["minInstances"];
            this.maxInstances = _data["maxInstances"];
            this.userPricePerUnit = _data["userPricePerUnit"];
            this.minUsers = _data["minUsers"];
            this.maxUsers = _data["maxUsers"];
            this.isActive = _data["isActive"];
            this.twoYearDiscountPercent = _data["twoYearDiscountPercent"];
            this.threeYearDiscountPercent = _data["threeYearDiscountPercent"];
            this.isConfigured = _data["isConfigured"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? moment(_data["lastModifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CustomPricingConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPricingConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instancePricePerUnit"] = this.instancePricePerUnit;
        data["minInstances"] = this.minInstances;
        data["maxInstances"] = this.maxInstances;
        data["userPricePerUnit"] = this.userPricePerUnit;
        data["minUsers"] = this.minUsers;
        data["maxUsers"] = this.maxUsers;
        data["isActive"] = this.isActive;
        data["twoYearDiscountPercent"] = this.twoYearDiscountPercent;
        data["threeYearDiscountPercent"] = this.threeYearDiscountPercent;
        data["isConfigured"] = this.isConfigured;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICustomPricingConfigurationResponse {
    id?: number;
    instancePricePerUnit?: number;
    minInstances?: number;
    maxInstances?: number;
    userPricePerUnit?: number;
    minUsers?: number;
    maxUsers?: number;
    isActive?: boolean;
    twoYearDiscountPercent?: number;
    threeYearDiscountPercent?: number;
    isConfigured?: boolean;
    lastModifiedOn?: moment.Moment | undefined;
}

export class UpsertCustomPricingConfigurationRequest implements IUpsertCustomPricingConfigurationRequest {
    instancePricePerUnit!: number;
    minInstances!: number;
    maxInstances!: number;
    userPricePerUnit!: number;
    minUsers!: number;
    maxUsers!: number;
    isActive?: boolean;
    /** Discount percent (0-100) applied when an admin commits to a 24-month term. */
    twoYearDiscountPercent?: number;
    /** Discount percent (0-100) applied when an admin commits to a 36-month term. */
    threeYearDiscountPercent?: number;

    constructor(data?: IUpsertCustomPricingConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instancePricePerUnit = _data["instancePricePerUnit"];
            this.minInstances = _data["minInstances"];
            this.maxInstances = _data["maxInstances"];
            this.userPricePerUnit = _data["userPricePerUnit"];
            this.minUsers = _data["minUsers"];
            this.maxUsers = _data["maxUsers"];
            this.isActive = _data["isActive"];
            this.twoYearDiscountPercent = _data["twoYearDiscountPercent"];
            this.threeYearDiscountPercent = _data["threeYearDiscountPercent"];
        }
    }

    static fromJS(data: any): UpsertCustomPricingConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCustomPricingConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instancePricePerUnit"] = this.instancePricePerUnit;
        data["minInstances"] = this.minInstances;
        data["maxInstances"] = this.maxInstances;
        data["userPricePerUnit"] = this.userPricePerUnit;
        data["minUsers"] = this.minUsers;
        data["maxUsers"] = this.maxUsers;
        data["isActive"] = this.isActive;
        data["twoYearDiscountPercent"] = this.twoYearDiscountPercent;
        data["threeYearDiscountPercent"] = this.threeYearDiscountPercent;
        return data;
    }
}

export interface IUpsertCustomPricingConfigurationRequest {
    instancePricePerUnit: number;
    minInstances: number;
    maxInstances: number;
    userPricePerUnit: number;
    minUsers: number;
    maxUsers: number;
    isActive?: boolean;
    /** Discount percent (0-100) applied when an admin commits to a 24-month term. */
    twoYearDiscountPercent?: number;
    /** Discount percent (0-100) applied when an admin commits to a 36-month term. */
    threeYearDiscountPercent?: number;
}

export class CalculateCustomPriceResponse implements ICalculateCustomPriceResponse {
    instances?: number;
    users?: number;
    instanceUnitPrice?: number;
    userUnitPrice?: number;
    instanceTotal?: number;
    userTotal?: number;
    /** Monthly total before applying the term commitment discount (InstanceTotal + UserTotal). */
    monthlyTotal?: number;
    termMonths?: number;
    /** Discount percent applied for the selected term (0 for 12 months). */
    discountPercent?: number;
    /** Amount saved versus paying the monthly total for the full term with no discount. */
    savings?: number;
    totalPrice?: number;
    minInstances?: number;
    maxInstances?: number;
    minUsers?: number;
    maxUsers?: number;

    constructor(data?: ICalculateCustomPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instances = _data["instances"];
            this.users = _data["users"];
            this.instanceUnitPrice = _data["instanceUnitPrice"];
            this.userUnitPrice = _data["userUnitPrice"];
            this.instanceTotal = _data["instanceTotal"];
            this.userTotal = _data["userTotal"];
            this.monthlyTotal = _data["monthlyTotal"];
            this.termMonths = _data["termMonths"];
            this.discountPercent = _data["discountPercent"];
            this.savings = _data["savings"];
            this.totalPrice = _data["totalPrice"];
            this.minInstances = _data["minInstances"];
            this.maxInstances = _data["maxInstances"];
            this.minUsers = _data["minUsers"];
            this.maxUsers = _data["maxUsers"];
        }
    }

    static fromJS(data: any): CalculateCustomPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateCustomPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instances"] = this.instances;
        data["users"] = this.users;
        data["instanceUnitPrice"] = this.instanceUnitPrice;
        data["userUnitPrice"] = this.userUnitPrice;
        data["instanceTotal"] = this.instanceTotal;
        data["userTotal"] = this.userTotal;
        data["monthlyTotal"] = this.monthlyTotal;
        data["termMonths"] = this.termMonths;
        data["discountPercent"] = this.discountPercent;
        data["savings"] = this.savings;
        data["totalPrice"] = this.totalPrice;
        data["minInstances"] = this.minInstances;
        data["maxInstances"] = this.maxInstances;
        data["minUsers"] = this.minUsers;
        data["maxUsers"] = this.maxUsers;
        return data;
    }
}

export interface ICalculateCustomPriceResponse {
    instances?: number;
    users?: number;
    instanceUnitPrice?: number;
    userUnitPrice?: number;
    instanceTotal?: number;
    userTotal?: number;
    /** Monthly total before applying the term commitment discount (InstanceTotal + UserTotal). */
    monthlyTotal?: number;
    termMonths?: number;
    /** Discount percent applied for the selected term (0 for 12 months). */
    discountPercent?: number;
    /** Amount saved versus paying the monthly total for the full term with no discount. */
    savings?: number;
    totalPrice?: number;
    minInstances?: number;
    maxInstances?: number;
    minUsers?: number;
    maxUsers?: number;
}

export class CalculateCustomPriceRequest implements ICalculateCustomPriceRequest {
    instances!: number;
    users!: number;
    /** Commitment term in months. Supported values: 12, 24, 36. Defaults to 12. */
    termMonths?: number;

    constructor(data?: ICalculateCustomPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instances = _data["instances"];
            this.users = _data["users"];
            this.termMonths = _data["termMonths"];
        }
    }

    static fromJS(data: any): CalculateCustomPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateCustomPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instances"] = this.instances;
        data["users"] = this.users;
        data["termMonths"] = this.termMonths;
        return data;
    }
}

export interface ICalculateCustomPriceRequest {
    instances: number;
    users: number;
    /** Commitment term in months. Supported values: 12, 24, 36. Defaults to 12. */
    termMonths?: number;
}

export class PaginationResponseOfTenantLicenseListResponse implements IPaginationResponseOfTenantLicenseListResponse {
    data?: TenantLicenseListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfTenantLicenseListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TenantLicenseListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfTenantLicenseListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfTenantLicenseListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfTenantLicenseListResponse {
    data?: TenantLicenseListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TenantLicenseListResponse implements ITenantLicenseListResponse {
    id!: number;
    tenantSubscriptionPlanId!: number;
    tenantId!: number;
    tenantName!: string;
    subscriptionPlanId?: number | undefined;
    adminDisplayName!: string;
    adminEmail!: string;
    planName!: string;
    licenseType!: LicenseTypeTypes;
    licenseStatus!: LicenseStatusTypes;
    revokedReason?: string | undefined;
    expiresOn!: moment.Moment;
    startedOn!: moment.Moment;
    hasLicenseKey?: boolean;
    activeInstace?: number;
    maxInstances?: number;
    createdOn?: moment.Moment;

    constructor(data?: ITenantLicenseListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantSubscriptionPlanId = _data["tenantSubscriptionPlanId"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.adminDisplayName = _data["adminDisplayName"];
            this.adminEmail = _data["adminEmail"];
            this.planName = _data["planName"];
            this.licenseType = _data["licenseType"];
            this.licenseStatus = _data["licenseStatus"];
            this.revokedReason = _data["revokedReason"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.startedOn = _data["startedOn"] ? moment(_data["startedOn"].toString()) : undefined as any;
            this.hasLicenseKey = _data["hasLicenseKey"];
            this.activeInstace = _data["activeInstace"];
            this.maxInstances = _data["maxInstances"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TenantLicenseListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLicenseListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantSubscriptionPlanId"] = this.tenantSubscriptionPlanId;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["adminDisplayName"] = this.adminDisplayName;
        data["adminEmail"] = this.adminEmail;
        data["planName"] = this.planName;
        data["licenseType"] = this.licenseType;
        data["licenseStatus"] = this.licenseStatus;
        data["revokedReason"] = this.revokedReason;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["hasLicenseKey"] = this.hasLicenseKey;
        data["activeInstace"] = this.activeInstace;
        data["maxInstances"] = this.maxInstances;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ITenantLicenseListResponse {
    id: number;
    tenantSubscriptionPlanId: number;
    tenantId: number;
    tenantName: string;
    subscriptionPlanId?: number | undefined;
    adminDisplayName: string;
    adminEmail: string;
    planName: string;
    licenseType: LicenseTypeTypes;
    licenseStatus: LicenseStatusTypes;
    revokedReason?: string | undefined;
    expiresOn: moment.Moment;
    startedOn: moment.Moment;
    hasLicenseKey?: boolean;
    activeInstace?: number;
    maxInstances?: number;
    createdOn?: moment.Moment;
}

export enum LicenseTypeTypes {
    Trial = "Trial",
    Paid = "Paid",
}

export enum LicenseStatusTypes {
    PendingIssue = "PendingIssue",
    Active = "Active",
    Inactive = "Inactive",
    Revoked = "Revoked",
    Expired = "Expired",
}

export class SearchRequestBaseClass implements ISearchRequestBaseClass {
    pageNumber?: number;
    pageSize?: number;
    sortOrder?: string | undefined;
    sortField?: string | undefined;

    constructor(data?: ISearchRequestBaseClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortOrder = _data["sortOrder"];
            this.sortField = _data["sortField"];
        }
    }

    static fromJS(data: any): SearchRequestBaseClass {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequestBaseClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortOrder"] = this.sortOrder;
        data["sortField"] = this.sortField;
        return data;
    }
}

export interface ISearchRequestBaseClass {
    pageNumber?: number;
    pageSize?: number;
    sortOrder?: string | undefined;
    sortField?: string | undefined;
}

export class SearchTenantLicensesRequest extends SearchRequestBaseClass implements ISearchTenantLicensesRequest {
    tenantId?: number | undefined;
    subscriptionPlanId?: number | undefined;
    licenseStatus?: LicenseStatusTypes | undefined;
    licenseType?: LicenseTypeTypes | undefined;
    keyword?: string | undefined;

    constructor(data?: ISearchTenantLicensesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.licenseStatus = _data["licenseStatus"];
            this.licenseType = _data["licenseType"];
            this.keyword = _data["keyword"];
        }
    }

    static override fromJS(data: any): SearchTenantLicensesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTenantLicensesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["licenseStatus"] = this.licenseStatus;
        data["licenseType"] = this.licenseType;
        data["keyword"] = this.keyword;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchTenantLicensesRequest extends ISearchRequestBaseClass {
    tenantId?: number | undefined;
    subscriptionPlanId?: number | undefined;
    licenseStatus?: LicenseStatusTypes | undefined;
    licenseType?: LicenseTypeTypes | undefined;
    keyword?: string | undefined;
}

export class TenantLicenseDetailResponse implements ITenantLicenseDetailResponse {
    id!: number;
    tenantId!: number;
    tenantUniqueId!: string;
    tenantName!: string;
    tenantSubscriptionPlanId!: number;
    licenseKey?: string | undefined;
    licenseType!: LicenseTypeTypes;
    licenseStatus!: LicenseStatusTypes;
    revokedReason?: string | undefined;
    expiresOn!: moment.Moment;
    startedOn!: moment.Moment;
    maxUsers!: number;
    maxInstances!: number;
    adminDisplayName!: string;
    adminEmail!: string;
    planName!: string;
    notes?: string | undefined;
    issuedAt?: moment.Moment | undefined;
    lastValidatedAt?: moment.Moment | undefined;

    constructor(data?: ITenantLicenseDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantUniqueId = _data["tenantUniqueId"];
            this.tenantName = _data["tenantName"];
            this.tenantSubscriptionPlanId = _data["tenantSubscriptionPlanId"];
            this.licenseKey = _data["licenseKey"];
            this.licenseType = _data["licenseType"];
            this.licenseStatus = _data["licenseStatus"];
            this.revokedReason = _data["revokedReason"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.startedOn = _data["startedOn"] ? moment(_data["startedOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.adminDisplayName = _data["adminDisplayName"];
            this.adminEmail = _data["adminEmail"];
            this.planName = _data["planName"];
            this.notes = _data["notes"];
            this.issuedAt = _data["issuedAt"] ? moment(_data["issuedAt"].toString()) : undefined as any;
            this.lastValidatedAt = _data["lastValidatedAt"] ? moment(_data["lastValidatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TenantLicenseDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLicenseDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantUniqueId"] = this.tenantUniqueId;
        data["tenantName"] = this.tenantName;
        data["tenantSubscriptionPlanId"] = this.tenantSubscriptionPlanId;
        data["licenseKey"] = this.licenseKey;
        data["licenseType"] = this.licenseType;
        data["licenseStatus"] = this.licenseStatus;
        data["revokedReason"] = this.revokedReason;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["adminDisplayName"] = this.adminDisplayName;
        data["adminEmail"] = this.adminEmail;
        data["planName"] = this.planName;
        data["notes"] = this.notes;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : undefined as any;
        data["lastValidatedAt"] = this.lastValidatedAt ? this.lastValidatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ITenantLicenseDetailResponse {
    id: number;
    tenantId: number;
    tenantUniqueId: string;
    tenantName: string;
    tenantSubscriptionPlanId: number;
    licenseKey?: string | undefined;
    licenseType: LicenseTypeTypes;
    licenseStatus: LicenseStatusTypes;
    revokedReason?: string | undefined;
    expiresOn: moment.Moment;
    startedOn: moment.Moment;
    maxUsers: number;
    maxInstances: number;
    adminDisplayName: string;
    adminEmail: string;
    planName: string;
    notes?: string | undefined;
    issuedAt?: moment.Moment | undefined;
    lastValidatedAt?: moment.Moment | undefined;
}

/** Super Admin: assign a subscription plan to a tenant and generate/activate the license. */
export class AdminIssueLicenseRequest implements IAdminIssueLicenseRequest {
    tenantId?: number;
    subscriptionPlanId?: number;
    isTrial?: boolean;
    notes?: string | undefined;

    constructor(data?: IAdminIssueLicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.isTrial = _data["isTrial"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AdminIssueLicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminIssueLicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["isTrial"] = this.isTrial;
        data["notes"] = this.notes;
        return data;
    }
}

/** Super Admin: assign a subscription plan to a tenant and generate/activate the license. */
export interface IAdminIssueLicenseRequest {
    tenantId?: number;
    subscriptionPlanId?: number;
    isTrial?: boolean;
    notes?: string | undefined;
}

export class UpdateLicenseStatusRequest implements IUpdateLicenseStatusRequest {
    licenseStatus!: LicenseStatusTypes;
    reason?: string | undefined;

    constructor(data?: IUpdateLicenseStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseStatus = _data["licenseStatus"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateLicenseStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseStatus"] = this.licenseStatus;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdateLicenseStatusRequest {
    licenseStatus: LicenseStatusTypes;
    reason?: string | undefined;
}

export class UpdateTrialLicenseLimitsRequest implements IUpdateTrialLicenseLimitsRequest {
    maxUsers!: number;
    maxInstances!: number;

    constructor(data?: IUpdateTrialLicenseLimitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
        }
    }

    static fromJS(data: any): UpdateTrialLicenseLimitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrialLicenseLimitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        return data;
    }
}

export interface IUpdateTrialLicenseLimitsRequest {
    maxUsers: number;
    maxInstances: number;
}

export class LicenseAnalyticsSummaryResponse implements ILicenseAnalyticsSummaryResponse {
    totalLicenses?: number;
    activeLicenses?: number;
    trialLicenses?: number;
    paidLicenses?: number;
    pendingIssue?: number;
    totalActiveDevices?: number;
    expiringWithin7Days?: number;
    estimatedMrr?: number;

    constructor(data?: ILicenseAnalyticsSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLicenses = _data["totalLicenses"];
            this.activeLicenses = _data["activeLicenses"];
            this.trialLicenses = _data["trialLicenses"];
            this.paidLicenses = _data["paidLicenses"];
            this.pendingIssue = _data["pendingIssue"];
            this.totalActiveDevices = _data["totalActiveDevices"];
            this.expiringWithin7Days = _data["expiringWithin7Days"];
            this.estimatedMrr = _data["estimatedMrr"];
        }
    }

    static fromJS(data: any): LicenseAnalyticsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseAnalyticsSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLicenses"] = this.totalLicenses;
        data["activeLicenses"] = this.activeLicenses;
        data["trialLicenses"] = this.trialLicenses;
        data["paidLicenses"] = this.paidLicenses;
        data["pendingIssue"] = this.pendingIssue;
        data["totalActiveDevices"] = this.totalActiveDevices;
        data["expiringWithin7Days"] = this.expiringWithin7Days;
        data["estimatedMrr"] = this.estimatedMrr;
        return data;
    }
}

export interface ILicenseAnalyticsSummaryResponse {
    totalLicenses?: number;
    activeLicenses?: number;
    trialLicenses?: number;
    paidLicenses?: number;
    pendingIssue?: number;
    totalActiveDevices?: number;
    expiringWithin7Days?: number;
    estimatedMrr?: number;
}

export class PaginationResponseOfLicenseAuditLogResponse implements IPaginationResponseOfLicenseAuditLogResponse {
    data?: LicenseAuditLogResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfLicenseAuditLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LicenseAuditLogResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfLicenseAuditLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfLicenseAuditLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfLicenseAuditLogResponse {
    data?: LicenseAuditLogResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class LicenseAuditLogResponse implements ILicenseAuditLogResponse {
    id!: number;
    licenseId?: number | undefined;
    tenantId?: number | undefined;
    eventType!: string;
    actorUserId?: string | undefined;
    summary?: string | undefined;
    createdOn?: moment.Moment;

    constructor(data?: ILicenseAuditLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.tenantId = _data["tenantId"];
            this.eventType = _data["eventType"];
            this.actorUserId = _data["actorUserId"];
            this.summary = _data["summary"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseAuditLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseAuditLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["tenantId"] = this.tenantId;
        data["eventType"] = this.eventType;
        data["actorUserId"] = this.actorUserId;
        data["summary"] = this.summary;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ILicenseAuditLogResponse {
    id: number;
    licenseId?: number | undefined;
    tenantId?: number | undefined;
    eventType: string;
    actorUserId?: string | undefined;
    summary?: string | undefined;
    createdOn?: moment.Moment;
}

export class SearchLicenseAuditRequest implements ISearchLicenseAuditRequest {
    pageNumber?: number;
    pageSize?: number;
    eventType?: string | undefined;
    tenantId?: number | undefined;
    licenseId?: number | undefined;
    keyword?: string | undefined;
    /** When false (default), routine validate/heartbeat checks are omitted from results. */
    includeRoutineEvents?: boolean;

    constructor(data?: ISearchLicenseAuditRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.eventType = _data["eventType"];
            this.tenantId = _data["tenantId"];
            this.licenseId = _data["licenseId"];
            this.keyword = _data["keyword"];
            this.includeRoutineEvents = _data["includeRoutineEvents"];
        }
    }

    static fromJS(data: any): SearchLicenseAuditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLicenseAuditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["eventType"] = this.eventType;
        data["tenantId"] = this.tenantId;
        data["licenseId"] = this.licenseId;
        data["keyword"] = this.keyword;
        data["includeRoutineEvents"] = this.includeRoutineEvents;
        return data;
    }
}

export interface ISearchLicenseAuditRequest {
    pageNumber?: number;
    pageSize?: number;
    eventType?: string | undefined;
    tenantId?: number | undefined;
    licenseId?: number | undefined;
    keyword?: string | undefined;
    /** When false (default), routine validate/heartbeat checks are omitted from results. */
    includeRoutineEvents?: boolean;
}

export class LicenseDeviceResponse implements ILicenseDeviceResponse {
    activationId!: number;
    machineName?: string | undefined;
    deviceId?: string | undefined;
    machineUuid?: string | undefined;
    biosSerial?: string | undefined;
    cpu?: string | undefined;
    ram?: string | undefined;
    storage?: string | undefined;
    windows?: string | undefined;
    osBuild?: string | undefined;
    macAddress?: string | undefined;
    osVersion?: string | undefined;
    appVersion?: string | undefined;
    activatedAt?: moment.Moment;
    lastSeenAt?: moment.Moment | undefined;
    isActive?: boolean;

    constructor(data?: ILicenseDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationId = _data["activationId"];
            this.machineName = _data["machineName"];
            this.deviceId = _data["deviceId"];
            this.machineUuid = _data["machineUuid"];
            this.biosSerial = _data["biosSerial"];
            this.cpu = _data["cpu"];
            this.ram = _data["ram"];
            this.storage = _data["storage"];
            this.windows = _data["windows"];
            this.osBuild = _data["osBuild"];
            this.macAddress = _data["macAddress"];
            this.osVersion = _data["osVersion"];
            this.appVersion = _data["appVersion"];
            this.activatedAt = _data["activatedAt"] ? moment(_data["activatedAt"].toString()) : undefined as any;
            this.lastSeenAt = _data["lastSeenAt"] ? moment(_data["lastSeenAt"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LicenseDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationId"] = this.activationId;
        data["machineName"] = this.machineName;
        data["deviceId"] = this.deviceId;
        data["machineUuid"] = this.machineUuid;
        data["biosSerial"] = this.biosSerial;
        data["cpu"] = this.cpu;
        data["ram"] = this.ram;
        data["storage"] = this.storage;
        data["windows"] = this.windows;
        data["osBuild"] = this.osBuild;
        data["macAddress"] = this.macAddress;
        data["osVersion"] = this.osVersion;
        data["appVersion"] = this.appVersion;
        data["activatedAt"] = this.activatedAt ? this.activatedAt.toISOString() : undefined as any;
        data["lastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILicenseDeviceResponse {
    activationId: number;
    machineName?: string | undefined;
    deviceId?: string | undefined;
    machineUuid?: string | undefined;
    biosSerial?: string | undefined;
    cpu?: string | undefined;
    ram?: string | undefined;
    storage?: string | undefined;
    windows?: string | undefined;
    osBuild?: string | undefined;
    macAddress?: string | undefined;
    osVersion?: string | undefined;
    appVersion?: string | undefined;
    activatedAt?: moment.Moment;
    lastSeenAt?: moment.Moment | undefined;
    isActive?: boolean;
}

export class LicenseOperationResponse implements ILicenseOperationResponse {
    isValid!: boolean;
    licenseStatus?: LicenseStatusTypes | undefined;
    enforcementMode?: LicenseEnforcementModeTypes | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number | undefined;
    maxInstances?: number | undefined;
    maxActivations?: number | undefined;
    activeActivations?: number | undefined;
    remainingActivations?: number | undefined;
    activeSqlInstances?: number | undefined;
    remainingSqlInstances?: number | undefined;
    activationId?: number | undefined;
    adminName?: string | undefined;
    planName?: string | undefined;
    businessLicenseType?: string | undefined;
    daysRemaining?: number | undefined;
    licenseSchemaVersion?: number;
    message?: string | undefined;
    offlineGrantToken?: string | undefined;
    offlineGrantExpiresOn?: moment.Moment | undefined;
    featureFlags?: string[] | undefined;
    /** Decoded subscription + user snapshot (from JWT claim or database). */
    licensePayload?: LicensePayloadSnapshot | undefined;

    constructor(data?: ILicenseOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.licenseStatus = _data["licenseStatus"];
            this.enforcementMode = _data["enforcementMode"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.maxActivations = _data["maxActivations"];
            this.activeActivations = _data["activeActivations"];
            this.remainingActivations = _data["remainingActivations"];
            this.activeSqlInstances = _data["activeSqlInstances"];
            this.remainingSqlInstances = _data["remainingSqlInstances"];
            this.activationId = _data["activationId"];
            this.adminName = _data["adminName"];
            this.planName = _data["planName"];
            this.businessLicenseType = _data["businessLicenseType"];
            this.daysRemaining = _data["daysRemaining"];
            this.licenseSchemaVersion = _data["licenseSchemaVersion"];
            this.message = _data["message"];
            this.offlineGrantToken = _data["offlineGrantToken"];
            this.offlineGrantExpiresOn = _data["offlineGrantExpiresOn"] ? moment(_data["offlineGrantExpiresOn"].toString()) : undefined as any;
            if (Array.isArray(_data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item of _data["featureFlags"])
                    this.featureFlags!.push(item);
            }
            this.licensePayload = _data["licensePayload"] ? LicensePayloadSnapshot.fromJS(_data["licensePayload"]) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["licenseStatus"] = this.licenseStatus;
        data["enforcementMode"] = this.enforcementMode;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["maxActivations"] = this.maxActivations;
        data["activeActivations"] = this.activeActivations;
        data["remainingActivations"] = this.remainingActivations;
        data["activeSqlInstances"] = this.activeSqlInstances;
        data["remainingSqlInstances"] = this.remainingSqlInstances;
        data["activationId"] = this.activationId;
        data["adminName"] = this.adminName;
        data["planName"] = this.planName;
        data["businessLicenseType"] = this.businessLicenseType;
        data["daysRemaining"] = this.daysRemaining;
        data["licenseSchemaVersion"] = this.licenseSchemaVersion;
        data["message"] = this.message;
        data["offlineGrantToken"] = this.offlineGrantToken;
        data["offlineGrantExpiresOn"] = this.offlineGrantExpiresOn ? this.offlineGrantExpiresOn.toISOString() : undefined as any;
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item of this.featureFlags)
                data["featureFlags"].push(item);
        }
        data["licensePayload"] = this.licensePayload ? this.licensePayload.toJSON() : undefined as any;
        return data;
    }
}

export interface ILicenseOperationResponse {
    isValid: boolean;
    licenseStatus?: LicenseStatusTypes | undefined;
    enforcementMode?: LicenseEnforcementModeTypes | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number | undefined;
    maxInstances?: number | undefined;
    maxActivations?: number | undefined;
    activeActivations?: number | undefined;
    remainingActivations?: number | undefined;
    activeSqlInstances?: number | undefined;
    remainingSqlInstances?: number | undefined;
    activationId?: number | undefined;
    adminName?: string | undefined;
    planName?: string | undefined;
    businessLicenseType?: string | undefined;
    daysRemaining?: number | undefined;
    licenseSchemaVersion?: number;
    message?: string | undefined;
    offlineGrantToken?: string | undefined;
    offlineGrantExpiresOn?: moment.Moment | undefined;
    featureFlags?: string[] | undefined;
    /** Decoded subscription + user snapshot (from JWT claim or database). */
    licensePayload?: LicensePayloadSnapshot | undefined;
}

export enum LicenseEnforcementModeTypes {
    Full = "Full",
    Warning = "Warning",
    Restricted = "Restricted",
    Blocked = "Blocked",
}

/** Readable subscription + admin snapshot embedded in the license JWT and stored in the database. This is NOT stored inside the SHA-256 hash (hashes cannot be decoded). */
export class LicensePayloadSnapshot implements ILicensePayloadSnapshot {
    licenseId?: number;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string;
    adminDisplayName?: string;
    adminEmail?: string;
    adminUserId?: string;
    tenantSubscriptionPlanId?: number;
    subscriptionPlanId?: number;
    planName?: string;
    planSlug?: string;
    planPrice?: number;
    subscriptionStatus?: string | undefined;
    isTrial?: boolean;
    licenseType?: string;
    businessLicenseType?: string;
    expiresOn?: moment.Moment;
    maxUsers?: number;
    maxInstances?: number;
    features?: string[] | undefined;
    licenseSchemaVersion?: number;

    constructor(data?: ILicensePayloadSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.tenantId = _data["tenantId"];
            this.tenantUniqueId = _data["tenantUniqueId"];
            this.tenantName = _data["tenantName"];
            this.adminDisplayName = _data["adminDisplayName"];
            this.adminEmail = _data["adminEmail"];
            this.adminUserId = _data["adminUserId"];
            this.tenantSubscriptionPlanId = _data["tenantSubscriptionPlanId"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.planName = _data["planName"];
            this.planSlug = _data["planSlug"];
            this.planPrice = _data["planPrice"];
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.isTrial = _data["isTrial"];
            this.licenseType = _data["licenseType"];
            this.businessLicenseType = _data["businessLicenseType"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.licenseSchemaVersion = _data["licenseSchemaVersion"];
        }
    }

    static fromJS(data: any): LicensePayloadSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new LicensePayloadSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["tenantId"] = this.tenantId;
        data["tenantUniqueId"] = this.tenantUniqueId;
        data["tenantName"] = this.tenantName;
        data["adminDisplayName"] = this.adminDisplayName;
        data["adminEmail"] = this.adminEmail;
        data["adminUserId"] = this.adminUserId;
        data["tenantSubscriptionPlanId"] = this.tenantSubscriptionPlanId;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["planName"] = this.planName;
        data["planSlug"] = this.planSlug;
        data["planPrice"] = this.planPrice;
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["isTrial"] = this.isTrial;
        data["licenseType"] = this.licenseType;
        data["businessLicenseType"] = this.businessLicenseType;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["licenseSchemaVersion"] = this.licenseSchemaVersion;
        return data;
    }
}

/** Readable subscription + admin snapshot embedded in the license JWT and stored in the database. This is NOT stored inside the SHA-256 hash (hashes cannot be decoded). */
export interface ILicensePayloadSnapshot {
    licenseId?: number;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string;
    adminDisplayName?: string;
    adminEmail?: string;
    adminUserId?: string;
    tenantSubscriptionPlanId?: number;
    subscriptionPlanId?: number;
    planName?: string;
    planSlug?: string;
    planPrice?: number;
    subscriptionStatus?: string | undefined;
    isTrial?: boolean;
    licenseType?: string;
    businessLicenseType?: string;
    expiresOn?: moment.Moment;
    maxUsers?: number;
    maxInstances?: number;
    features?: string[] | undefined;
    licenseSchemaVersion?: number;
}

export class ValidateLicenseRequest implements IValidateLicenseRequest {
    licenseKey!: string;
    clientAppVersion?: string | undefined;
    machineName?: string | undefined;
    machineFingerprint?: string | undefined;
    osVersion?: string | undefined;

    constructor(data?: IValidateLicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.clientAppVersion = _data["clientAppVersion"];
            this.machineName = _data["machineName"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.osVersion = _data["osVersion"];
        }
    }

    static fromJS(data: any): ValidateLicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateLicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["clientAppVersion"] = this.clientAppVersion;
        data["machineName"] = this.machineName;
        data["machineFingerprint"] = this.machineFingerprint;
        data["osVersion"] = this.osVersion;
        return data;
    }
}

export interface IValidateLicenseRequest {
    licenseKey: string;
    clientAppVersion?: string | undefined;
    machineName?: string | undefined;
    machineFingerprint?: string | undefined;
    osVersion?: string | undefined;
}

export class PaginationResponseOfNotificationResponse implements IPaginationResponseOfNotificationResponse {
    data?: NotificationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfNotificationResponse {
    data?: NotificationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class NotificationResponse implements INotificationResponse {
    id?: number;
    title?: string;
    message?: string;
    isRead?: boolean;
    icon?: string;
    iconColor?: string;
    notificationType?: number;
    priority?: number;
    actionUrl?: string | undefined;
    createdOn?: moment.Moment;

    constructor(data?: INotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.isRead = _data["isRead"];
            this.icon = _data["icon"];
            this.iconColor = _data["iconColor"];
            this.notificationType = _data["notificationType"];
            this.priority = _data["priority"];
            this.actionUrl = _data["actionUrl"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["message"] = this.message;
        data["isRead"] = this.isRead;
        data["icon"] = this.icon;
        data["iconColor"] = this.iconColor;
        data["notificationType"] = this.notificationType;
        data["priority"] = this.priority;
        data["actionUrl"] = this.actionUrl;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface INotificationResponse {
    id?: number;
    title?: string;
    message?: string;
    isRead?: boolean;
    icon?: string;
    iconColor?: string;
    notificationType?: number;
    priority?: number;
    actionUrl?: string | undefined;
    createdOn?: moment.Moment;
}

export class GetNotificationsRequest extends SearchRequestBaseClass implements IGetNotificationsRequest {
    /** null = all, true = read only, false = unread only */
    isRead?: boolean | undefined;

    constructor(data?: IGetNotificationsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isRead = _data["isRead"];
        }
    }

    static override fromJS(data: any): GetNotificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRead"] = this.isRead;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNotificationsRequest extends ISearchRequestBaseClass {
    /** null = all, true = read only, false = unread only */
    isRead?: boolean | undefined;
}

export class PromoCodeDetailResponse implements IPromoCodeDetailResponse {
    id?: number;
    code?: string;
    description?: string | undefined;
    discountType?: PromoCodeDiscountType;
    discountValue?: number;
    maxDiscountAmount?: number | undefined;
    startDate?: moment.Moment;
    expiryDate?: moment.Moment;
    maxUsageCount?: number | undefined;
    perAdminUsageLimit?: number | undefined;
    isActive?: boolean;
    appliesToAllPlans?: boolean;
    applicablePlanIds?: number[];
    applicablePlanNames?: string[];
    totalUsageCount?: number;
    createdOn?: moment.Moment;
    lastModifiedOn?: moment.Moment | undefined;

    constructor(data?: IPromoCodeDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.discountType = _data["discountType"];
            this.discountValue = _data["discountValue"];
            this.maxDiscountAmount = _data["maxDiscountAmount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.maxUsageCount = _data["maxUsageCount"];
            this.perAdminUsageLimit = _data["perAdminUsageLimit"];
            this.isActive = _data["isActive"];
            this.appliesToAllPlans = _data["appliesToAllPlans"];
            if (Array.isArray(_data["applicablePlanIds"])) {
                this.applicablePlanIds = [] as any;
                for (let item of _data["applicablePlanIds"])
                    this.applicablePlanIds!.push(item);
            }
            if (Array.isArray(_data["applicablePlanNames"])) {
                this.applicablePlanNames = [] as any;
                for (let item of _data["applicablePlanNames"])
                    this.applicablePlanNames!.push(item);
            }
            this.totalUsageCount = _data["totalUsageCount"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.lastModifiedOn = _data["lastModifiedOn"] ? moment(_data["lastModifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PromoCodeDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PromoCodeDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["maxUsageCount"] = this.maxUsageCount;
        data["perAdminUsageLimit"] = this.perAdminUsageLimit;
        data["isActive"] = this.isActive;
        data["appliesToAllPlans"] = this.appliesToAllPlans;
        if (Array.isArray(this.applicablePlanIds)) {
            data["applicablePlanIds"] = [];
            for (let item of this.applicablePlanIds)
                data["applicablePlanIds"].push(item);
        }
        if (Array.isArray(this.applicablePlanNames)) {
            data["applicablePlanNames"] = [];
            for (let item of this.applicablePlanNames)
                data["applicablePlanNames"].push(item);
        }
        data["totalUsageCount"] = this.totalUsageCount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPromoCodeDetailResponse {
    id?: number;
    code?: string;
    description?: string | undefined;
    discountType?: PromoCodeDiscountType;
    discountValue?: number;
    maxDiscountAmount?: number | undefined;
    startDate?: moment.Moment;
    expiryDate?: moment.Moment;
    maxUsageCount?: number | undefined;
    perAdminUsageLimit?: number | undefined;
    isActive?: boolean;
    appliesToAllPlans?: boolean;
    applicablePlanIds?: number[];
    applicablePlanNames?: string[];
    totalUsageCount?: number;
    createdOn?: moment.Moment;
    lastModifiedOn?: moment.Moment | undefined;
}

export enum PromoCodeDiscountType {
    Percentage = "Percentage",
    FixedAmount = "FixedAmount",
}

export class CreatePromoCodeRequest implements ICreatePromoCodeRequest {
    code!: string;
    description?: string | undefined;
    discountType!: PromoCodeDiscountType;
    discountValue!: number;
    maxDiscountAmount?: number | undefined;
    startDate!: moment.Moment;
    expiryDate!: moment.Moment;
    maxUsageCount?: number | undefined;
    perAdminUsageLimit?: number | undefined;
    isActive?: boolean;
    appliesToAllPlans?: boolean;
    applicablePlanIds?: number[];

    constructor(data?: ICreatePromoCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.discountType = _data["discountType"];
            this.discountValue = _data["discountValue"];
            this.maxDiscountAmount = _data["maxDiscountAmount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.maxUsageCount = _data["maxUsageCount"];
            this.perAdminUsageLimit = _data["perAdminUsageLimit"];
            this.isActive = _data["isActive"];
            this.appliesToAllPlans = _data["appliesToAllPlans"];
            if (Array.isArray(_data["applicablePlanIds"])) {
                this.applicablePlanIds = [] as any;
                for (let item of _data["applicablePlanIds"])
                    this.applicablePlanIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePromoCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePromoCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["maxUsageCount"] = this.maxUsageCount;
        data["perAdminUsageLimit"] = this.perAdminUsageLimit;
        data["isActive"] = this.isActive;
        data["appliesToAllPlans"] = this.appliesToAllPlans;
        if (Array.isArray(this.applicablePlanIds)) {
            data["applicablePlanIds"] = [];
            for (let item of this.applicablePlanIds)
                data["applicablePlanIds"].push(item);
        }
        return data;
    }
}

export interface ICreatePromoCodeRequest {
    code: string;
    description?: string | undefined;
    discountType: PromoCodeDiscountType;
    discountValue: number;
    maxDiscountAmount?: number | undefined;
    startDate: moment.Moment;
    expiryDate: moment.Moment;
    maxUsageCount?: number | undefined;
    perAdminUsageLimit?: number | undefined;
    isActive?: boolean;
    appliesToAllPlans?: boolean;
    applicablePlanIds?: number[];
}

export class UpdatePromoCodeRequest extends CreatePromoCodeRequest implements IUpdatePromoCodeRequest {
    id!: number;

    constructor(data?: IUpdatePromoCodeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdatePromoCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePromoCodeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePromoCodeRequest extends ICreatePromoCodeRequest {
    id: number;
}

export class PaginationResponseOfPromoCodeListResponse implements IPaginationResponseOfPromoCodeListResponse {
    data?: PromoCodeListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfPromoCodeListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PromoCodeListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfPromoCodeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfPromoCodeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfPromoCodeListResponse {
    data?: PromoCodeListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PromoCodeListResponse implements IPromoCodeListResponse {
    id?: number;
    code?: string;
    description?: string | undefined;
    discountType?: PromoCodeDiscountType;
    discountValue?: number;
    startDate?: moment.Moment;
    expiryDate?: moment.Moment;
    isActive?: boolean;
    maxUsageCount?: number | undefined;
    totalUsageCount?: number;
    createdOn?: moment.Moment;

    constructor(data?: IPromoCodeListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.discountType = _data["discountType"];
            this.discountValue = _data["discountValue"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.maxUsageCount = _data["maxUsageCount"];
            this.totalUsageCount = _data["totalUsageCount"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PromoCodeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PromoCodeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["maxUsageCount"] = this.maxUsageCount;
        data["totalUsageCount"] = this.totalUsageCount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPromoCodeListResponse {
    id?: number;
    code?: string;
    description?: string | undefined;
    discountType?: PromoCodeDiscountType;
    discountValue?: number;
    startDate?: moment.Moment;
    expiryDate?: moment.Moment;
    isActive?: boolean;
    maxUsageCount?: number | undefined;
    totalUsageCount?: number;
    createdOn?: moment.Moment;
}

export class SearchPromoCodesRequest extends SearchRequestBaseClass implements ISearchPromoCodesRequest {
    searchText?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ISearchPromoCodesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): SearchPromoCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPromoCodesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPromoCodesRequest extends ISearchRequestBaseClass {
    searchText?: string | undefined;
    isActive?: boolean | undefined;
}

export class PaginationResponseOfPromoCodeUsageResponse implements IPaginationResponseOfPromoCodeUsageResponse {
    data?: PromoCodeUsageResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfPromoCodeUsageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PromoCodeUsageResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfPromoCodeUsageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfPromoCodeUsageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfPromoCodeUsageResponse {
    data?: PromoCodeUsageResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PromoCodeUsageResponse implements IPromoCodeUsageResponse {
    id?: number;
    tenantId?: number;
    tenantName?: string | undefined;
    subscriptionPlanId?: number | undefined;
    subscriptionPlanName?: string | undefined;
    originalAmount?: number;
    discountAmount?: number;
    finalAmount?: number;
    usedOn?: moment.Moment;

    constructor(data?: IPromoCodeUsageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.subscriptionPlanName = _data["subscriptionPlanName"];
            this.originalAmount = _data["originalAmount"];
            this.discountAmount = _data["discountAmount"];
            this.finalAmount = _data["finalAmount"];
            this.usedOn = _data["usedOn"] ? moment(_data["usedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PromoCodeUsageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PromoCodeUsageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["subscriptionPlanName"] = this.subscriptionPlanName;
        data["originalAmount"] = this.originalAmount;
        data["discountAmount"] = this.discountAmount;
        data["finalAmount"] = this.finalAmount;
        data["usedOn"] = this.usedOn ? this.usedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPromoCodeUsageResponse {
    id?: number;
    tenantId?: number;
    tenantName?: string | undefined;
    subscriptionPlanId?: number | undefined;
    subscriptionPlanName?: string | undefined;
    originalAmount?: number;
    discountAmount?: number;
    finalAmount?: number;
    usedOn?: moment.Moment;
}

export class ValidatePromoCodeResponse implements IValidatePromoCodeResponse {
    isValid!: boolean;
    message!: string;
    promoCodeId?: number | undefined;
    code?: string | undefined;
    discountType?: PromoCodeDiscountType | undefined;
    originalPrice?: number;
    discountAmount?: number;
    finalPrice?: number;

    constructor(data?: IValidatePromoCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.message = _data["message"];
            this.promoCodeId = _data["promoCodeId"];
            this.code = _data["code"];
            this.discountType = _data["discountType"];
            this.originalPrice = _data["originalPrice"];
            this.discountAmount = _data["discountAmount"];
            this.finalPrice = _data["finalPrice"];
        }
    }

    static fromJS(data: any): ValidatePromoCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePromoCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        data["promoCodeId"] = this.promoCodeId;
        data["code"] = this.code;
        data["discountType"] = this.discountType;
        data["originalPrice"] = this.originalPrice;
        data["discountAmount"] = this.discountAmount;
        data["finalPrice"] = this.finalPrice;
        return data;
    }
}

export interface IValidatePromoCodeResponse {
    isValid: boolean;
    message: string;
    promoCodeId?: number | undefined;
    code?: string | undefined;
    discountType?: PromoCodeDiscountType | undefined;
    originalPrice?: number;
    discountAmount?: number;
    finalPrice?: number;
}

export class ValidatePromoCodeRequest implements IValidatePromoCodeRequest {
    code!: string;
    subscriptionPlanId!: number;
    /** Amount the discount should be computed against. Defaults to the plan's list price when omitted. */
    originalAmount?: number | undefined;

    constructor(data?: IValidatePromoCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.originalAmount = _data["originalAmount"];
        }
    }

    static fromJS(data: any): ValidatePromoCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePromoCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["originalAmount"] = this.originalAmount;
        return data;
    }
}

export interface IValidatePromoCodeRequest {
    code: string;
    subscriptionPlanId: number;
    /** Amount the discount should be computed against. Defaults to the plan's list price when omitted. */
    originalAmount?: number | undefined;
}

/** Metadata about the current SQLDBD installer on the download server (no file content). */
export class SqlDbdInstallerInfoResponse implements ISqlDbdInstallerInfoResponse {
    exists?: boolean;
    current?: SqlDbdInstallerFileInfoResponse | undefined;
    previous?: SqlDbdInstallerFileInfoResponse | undefined;
    servePrevious?: boolean;
    servedVersion?: string | undefined;
    fileName?: string | undefined;
    sizeBytes?: number;
    lastModifiedUtc?: moment.Moment | undefined;

    constructor(data?: ISqlDbdInstallerInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.current = _data["current"] ? SqlDbdInstallerFileInfoResponse.fromJS(_data["current"]) : undefined as any;
            this.previous = _data["previous"] ? SqlDbdInstallerFileInfoResponse.fromJS(_data["previous"]) : undefined as any;
            this.servePrevious = _data["servePrevious"];
            this.servedVersion = _data["servedVersion"];
            this.fileName = _data["fileName"];
            this.sizeBytes = _data["sizeBytes"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? moment(_data["lastModifiedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SqlDbdInstallerInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SqlDbdInstallerInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["current"] = this.current ? this.current.toJSON() : undefined as any;
        data["previous"] = this.previous ? this.previous.toJSON() : undefined as any;
        data["servePrevious"] = this.servePrevious;
        data["servedVersion"] = this.servedVersion;
        data["fileName"] = this.fileName;
        data["sizeBytes"] = this.sizeBytes;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : undefined as any;
        return data;
    }
}

/** Metadata about the current SQLDBD installer on the download server (no file content). */
export interface ISqlDbdInstallerInfoResponse {
    exists?: boolean;
    current?: SqlDbdInstallerFileInfoResponse | undefined;
    previous?: SqlDbdInstallerFileInfoResponse | undefined;
    servePrevious?: boolean;
    servedVersion?: string | undefined;
    fileName?: string | undefined;
    sizeBytes?: number;
    lastModifiedUtc?: moment.Moment | undefined;
}

export class SqlDbdInstallerFileInfoResponse implements ISqlDbdInstallerFileInfoResponse {
    fileName!: string;
    sizeBytes?: number;
    lastModifiedUtc?: moment.Moment | undefined;

    constructor(data?: ISqlDbdInstallerFileInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.sizeBytes = _data["sizeBytes"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? moment(_data["lastModifiedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SqlDbdInstallerFileInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SqlDbdInstallerFileInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["sizeBytes"] = this.sizeBytes;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ISqlDbdInstallerFileInfoResponse {
    fileName: string;
    sizeBytes?: number;
    lastModifiedUtc?: moment.Moment | undefined;
}

export class UpdateSqlDbdInstallerFallbackRequest implements IUpdateSqlDbdInstallerFallbackRequest {
    servePrevious!: boolean;

    constructor(data?: IUpdateSqlDbdInstallerFallbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servePrevious = _data["servePrevious"];
        }
    }

    static fromJS(data: any): UpdateSqlDbdInstallerFallbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSqlDbdInstallerFallbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servePrevious"] = this.servePrevious;
        return data;
    }
}

export interface IUpdateSqlDbdInstallerFallbackRequest {
    servePrevious: boolean;
}

export class GetSubscriptionPlanDetailsResponse implements IGetSubscriptionPlanDetailsResponse {
    id!: number;
    name!: string;
    price!: number;
    validityDuration!: number;
    validityDurationType!: ValidityDurationType;
    description!: string;
    displayOrder!: number;
    ribbonText?: string | undefined;
    isDefaultForRegistration!: boolean;
    trialEnabled!: boolean;

    constructor(data?: IGetSubscriptionPlanDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.validityDuration = _data["validityDuration"];
            this.validityDurationType = _data["validityDurationType"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.ribbonText = _data["ribbonText"];
            this.isDefaultForRegistration = _data["isDefaultForRegistration"];
            this.trialEnabled = _data["trialEnabled"];
        }
    }

    static fromJS(data: any): GetSubscriptionPlanDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionPlanDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["validityDuration"] = this.validityDuration;
        data["validityDurationType"] = this.validityDurationType;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["ribbonText"] = this.ribbonText;
        data["isDefaultForRegistration"] = this.isDefaultForRegistration;
        data["trialEnabled"] = this.trialEnabled;
        return data;
    }
}

export interface IGetSubscriptionPlanDetailsResponse {
    id: number;
    name: string;
    price: number;
    validityDuration: number;
    validityDurationType: ValidityDurationType;
    description: string;
    displayOrder: number;
    ribbonText?: string | undefined;
    isDefaultForRegistration: boolean;
    trialEnabled: boolean;
}

export enum ValidityDurationType {
    Days = "Days",
    Months = "Months",
    Years = "Years",
}

export class GetPublicSubscriptionPlanResponse implements IGetPublicSubscriptionPlanResponse {
    id!: number;
    name!: string;
    slug!: string;
    description!: string;
    price!: number;
    subscriptionPlanPaymentCycleType!: SubscriptionPlanPaymentCycleTypes;
    validityDuration!: number;
    validityDurationType!: ValidityDurationType;
    maxUsers!: number;
    maxInstances!: number;
    supportType!: SupportTypeTypes;
    slaHours!: number;
    ribbonText?: string | undefined;
    displayOrder!: number;
    highlightedPlan!: boolean;
    buttonLabel!: string;
    allowUpgrade!: boolean;
    features!: SubscriptionPlanFeatureResponse[];

    constructor(data?: IGetPublicSubscriptionPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.features = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.subscriptionPlanPaymentCycleType = _data["subscriptionPlanPaymentCycleType"];
            this.validityDuration = _data["validityDuration"];
            this.validityDurationType = _data["validityDurationType"];
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.supportType = _data["supportType"];
            this.slaHours = _data["slaHours"];
            this.ribbonText = _data["ribbonText"];
            this.displayOrder = _data["displayOrder"];
            this.highlightedPlan = _data["highlightedPlan"];
            this.buttonLabel = _data["buttonLabel"];
            this.allowUpgrade = _data["allowUpgrade"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(SubscriptionPlanFeatureResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicSubscriptionPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicSubscriptionPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["description"] = this.description;
        data["price"] = this.price;
        data["subscriptionPlanPaymentCycleType"] = this.subscriptionPlanPaymentCycleType;
        data["validityDuration"] = this.validityDuration;
        data["validityDurationType"] = this.validityDurationType;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["supportType"] = this.supportType;
        data["slaHours"] = this.slaHours;
        data["ribbonText"] = this.ribbonText;
        data["displayOrder"] = this.displayOrder;
        data["highlightedPlan"] = this.highlightedPlan;
        data["buttonLabel"] = this.buttonLabel;
        data["allowUpgrade"] = this.allowUpgrade;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPublicSubscriptionPlanResponse {
    id: number;
    name: string;
    slug: string;
    description: string;
    price: number;
    subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes;
    validityDuration: number;
    validityDurationType: ValidityDurationType;
    maxUsers: number;
    maxInstances: number;
    supportType: SupportTypeTypes;
    slaHours: number;
    ribbonText?: string | undefined;
    displayOrder: number;
    highlightedPlan: boolean;
    buttonLabel: string;
    allowUpgrade: boolean;
    features: SubscriptionPlanFeatureResponse[];
}

export enum SubscriptionPlanPaymentCycleTypes {
    Monthly = "Monthly",
    Yearly = "Yearly",
    OneTime = "OneTime",
    Free = "Free",
}

export enum SupportTypeTypes {
    Email = "Email",
    Priority = "Priority",
    Dedicated = "Dedicated",
}

export class SubscriptionPlanFeatureResponse implements ISubscriptionPlanFeatureResponse {
    id!: number;
    featureText!: string;
    sortOrder!: number;

    constructor(data?: ISubscriptionPlanFeatureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.featureText = _data["featureText"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): SubscriptionPlanFeatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPlanFeatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["featureText"] = this.featureText;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ISubscriptionPlanFeatureResponse {
    id: number;
    featureText: string;
    sortOrder: number;
}

export class TenantCurrentSubscriptionDetailResponse implements ITenantCurrentSubscriptionDetailResponse {
    name!: string;
    price!: number;
    expiredOn!: moment.Moment;
    paymentPending?: moment.Moment | undefined;
    isOverDue!: boolean;
    fkSubscriptionPlanPKId!: number;
    latePaymentOverDue!: boolean;
    invoices!: TenantInvoicesResponse[];
    subscriptionStatus?: TenantSubscriptionStatusTypes | undefined;
    isTrial?: boolean;
    licenseKey?: string | undefined;
    trialDaysRemaining?: number | undefined;
    maxUsers?: number;
    maxInstances?: number;
    supportType?: SupportTypeTypes | undefined;
    licenseStatus?: LicenseStatusTypes | undefined;
    canUseProduct?: boolean;
    pendingLicenseIssue?: boolean;
    enforcementMode?: LicenseEnforcementModeTypes | undefined;
    /** True when the subscription/trial expiry date is in the past. */
    isExpired?: boolean;
    /** True for the root (Super Admin) tenant – no subscription enforcement applies. */
    isSuperAdminTenant?: boolean;
    /** True when a higher-tier plan is available for this tenant to purchase. */
    canUpgrade?: boolean;

    constructor(data?: ITenantCurrentSubscriptionDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.invoices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.expiredOn = _data["expiredOn"] ? moment(_data["expiredOn"].toString()) : undefined as any;
            this.paymentPending = _data["paymentPending"] ? moment(_data["paymentPending"].toString()) : undefined as any;
            this.isOverDue = _data["isOverDue"];
            this.fkSubscriptionPlanPKId = _data["fkSubscriptionPlanPKId"];
            this.latePaymentOverDue = _data["latePaymentOverDue"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(TenantInvoicesResponse.fromJS(item));
            }
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.isTrial = _data["isTrial"];
            this.licenseKey = _data["licenseKey"];
            this.trialDaysRemaining = _data["trialDaysRemaining"];
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.supportType = _data["supportType"];
            this.licenseStatus = _data["licenseStatus"];
            this.canUseProduct = _data["canUseProduct"];
            this.pendingLicenseIssue = _data["pendingLicenseIssue"];
            this.enforcementMode = _data["enforcementMode"];
            this.isExpired = _data["isExpired"];
            this.isSuperAdminTenant = _data["isSuperAdminTenant"];
            this.canUpgrade = _data["canUpgrade"];
        }
    }

    static fromJS(data: any): TenantCurrentSubscriptionDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCurrentSubscriptionDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["expiredOn"] = this.expiredOn ? this.expiredOn.toISOString() : undefined as any;
        data["paymentPending"] = this.paymentPending ? this.paymentPending.toISOString() : undefined as any;
        data["isOverDue"] = this.isOverDue;
        data["fkSubscriptionPlanPKId"] = this.fkSubscriptionPlanPKId;
        data["latePaymentOverDue"] = this.latePaymentOverDue;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["isTrial"] = this.isTrial;
        data["licenseKey"] = this.licenseKey;
        data["trialDaysRemaining"] = this.trialDaysRemaining;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["supportType"] = this.supportType;
        data["licenseStatus"] = this.licenseStatus;
        data["canUseProduct"] = this.canUseProduct;
        data["pendingLicenseIssue"] = this.pendingLicenseIssue;
        data["enforcementMode"] = this.enforcementMode;
        data["isExpired"] = this.isExpired;
        data["isSuperAdminTenant"] = this.isSuperAdminTenant;
        data["canUpgrade"] = this.canUpgrade;
        return data;
    }
}

export interface ITenantCurrentSubscriptionDetailResponse {
    name: string;
    price: number;
    expiredOn: moment.Moment;
    paymentPending?: moment.Moment | undefined;
    isOverDue: boolean;
    fkSubscriptionPlanPKId: number;
    latePaymentOverDue: boolean;
    invoices: TenantInvoicesResponse[];
    subscriptionStatus?: TenantSubscriptionStatusTypes | undefined;
    isTrial?: boolean;
    licenseKey?: string | undefined;
    trialDaysRemaining?: number | undefined;
    maxUsers?: number;
    maxInstances?: number;
    supportType?: SupportTypeTypes | undefined;
    licenseStatus?: LicenseStatusTypes | undefined;
    canUseProduct?: boolean;
    pendingLicenseIssue?: boolean;
    enforcementMode?: LicenseEnforcementModeTypes | undefined;
    /** True when the subscription/trial expiry date is in the past. */
    isExpired?: boolean;
    /** True for the root (Super Admin) tenant – no subscription enforcement applies. */
    isSuperAdminTenant?: boolean;
    /** True when a higher-tier plan is available for this tenant to purchase. */
    canUpgrade?: boolean;
}

export class TenantInvoicesResponse implements ITenantInvoicesResponse {
    invoiceId!: number;
    periodFrom!: moment.Moment;
    periodTo!: moment.Moment;
    invoiceStatus!: string;
    stripeInvoiceUrl!: string;

    constructor(data?: ITenantInvoicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.periodFrom = _data["periodFrom"] ? moment(_data["periodFrom"].toString()) : undefined as any;
            this.periodTo = _data["periodTo"] ? moment(_data["periodTo"].toString()) : undefined as any;
            this.invoiceStatus = _data["invoiceStatus"];
            this.stripeInvoiceUrl = _data["stripeInvoiceUrl"];
        }
    }

    static fromJS(data: any): TenantInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInvoicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : undefined as any;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : undefined as any;
        data["invoiceStatus"] = this.invoiceStatus;
        data["stripeInvoiceUrl"] = this.stripeInvoiceUrl;
        return data;
    }
}

export interface ITenantInvoicesResponse {
    invoiceId: number;
    periodFrom: moment.Moment;
    periodTo: moment.Moment;
    invoiceStatus: string;
    stripeInvoiceUrl: string;
}

export enum TenantSubscriptionStatusTypes {
    Trial = "Trial",
    Active = "Active",
    Expired = "Expired",
    Cancelled = "Cancelled",
    Suspended = "Suspended",
    PendingPayment = "PendingPayment",
    Upcoming = "Upcoming",
}

export class CancelSubscriptionRequest implements ICancelSubscriptionRequest {
    cancellationReason?: string | undefined;

    constructor(data?: ICancelSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): CancelSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }
}

export interface ICancelSubscriptionRequest {
    cancellationReason?: string | undefined;
}

export class AssignSubscriptionPlanResponse implements IAssignSubscriptionPlanResponse {
    id!: number;
    message!: string;

    constructor(data?: IAssignSubscriptionPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AssignSubscriptionPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSubscriptionPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IAssignSubscriptionPlanResponse {
    id: number;
    message: string;
}

export class UpgradeSubscriptionRequest implements IUpgradeSubscriptionRequest {
    targetSubscriptionPlanId!: number;

    constructor(data?: IUpgradeSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetSubscriptionPlanId = _data["targetSubscriptionPlanId"];
        }
    }

    static fromJS(data: any): UpgradeSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpgradeSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSubscriptionPlanId"] = this.targetSubscriptionPlanId;
        return data;
    }
}

export interface IUpgradeSubscriptionRequest {
    targetSubscriptionPlanId: number;
}

export class SubscriptionPaymentResponse implements ISubscriptionPaymentResponse {
    id!: number;
    amount!: number;
    currency!: string;
    paymentStatus!: SubscriptionPaymentStatusTypes;
    invoiceUrl?: string | undefined;
    createdOn!: moment.Moment;

    constructor(data?: ISubscriptionPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentStatus = _data["paymentStatus"];
            this.invoiceUrl = _data["invoiceUrl"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubscriptionPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentStatus"] = this.paymentStatus;
        data["invoiceUrl"] = this.invoiceUrl;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ISubscriptionPaymentResponse {
    id: number;
    amount: number;
    currency: string;
    paymentStatus: SubscriptionPaymentStatusTypes;
    invoiceUrl?: string | undefined;
    createdOn: moment.Moment;
}

export enum SubscriptionPaymentStatusTypes {
    Pending = "Pending",
    Succeeded = "Succeeded",
    Failed = "Failed",
    Refunded = "Refunded",
}

export class LicenseDownloadResponse implements ILicenseDownloadResponse {
    licenseKey!: string;
    fileName!: string;
    content!: string;

    constructor(data?: ILicenseDownloadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.fileName = _data["fileName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): LicenseDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDownloadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        return data;
    }
}

export interface ILicenseDownloadResponse {
    licenseKey: string;
    fileName: string;
    content: string;
}

export class TenantEventNotificationResponse implements ITenantEventNotificationResponse {
    id?: number;
    title?: string;
    message?: string;
    icon?: string;
    iconColor?: string;
    createdOn?: moment.Moment;

    constructor(data?: ITenantEventNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.icon = _data["icon"];
            this.iconColor = _data["iconColor"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TenantEventNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEventNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["message"] = this.message;
        data["icon"] = this.icon;
        data["iconColor"] = this.iconColor;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ITenantEventNotificationResponse {
    id?: number;
    title?: string;
    message?: string;
    icon?: string;
    iconColor?: string;
    createdOn?: moment.Moment;
}

export class OfflineGrantRequest implements IOfflineGrantRequest {
    licenseKey!: string;
    machineFingerprint!: string;

    constructor(data?: IOfflineGrantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
        }
    }

    static fromJS(data: any): OfflineGrantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineGrantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        return data;
    }
}

export interface IOfflineGrantRequest {
    licenseKey: string;
    machineFingerprint: string;
}

export class OfflineGrantValidateRequest implements IOfflineGrantValidateRequest {
    offlineGrantToken!: string;

    constructor(data?: IOfflineGrantValidateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offlineGrantToken = _data["offlineGrantToken"];
        }
    }

    static fromJS(data: any): OfflineGrantValidateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineGrantValidateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offlineGrantToken"] = this.offlineGrantToken;
        return data;
    }
}

export interface IOfflineGrantValidateRequest {
    offlineGrantToken: string;
}

export class CreateSubscriptionPlanAdminResponse implements ICreateSubscriptionPlanAdminResponse {
    id!: number;
    message!: string;

    constructor(data?: ICreateSubscriptionPlanAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateSubscriptionPlanAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionPlanAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateSubscriptionPlanAdminResponse {
    id: number;
    message: string;
}

export class CreateSubscriptionPlanAdminRequest implements ICreateSubscriptionPlanAdminRequest {
    name!: string;
    slug!: string;
    description!: string;
    price!: number;
    subscriptionPlanPaymentCycleType!: SubscriptionPlanPaymentCycleTypes;
    validityDuration!: number;
    validityDurationType!: ValidityDurationType;
    maxUsers!: number;
    maxInstances!: number;
    supportType!: SupportTypeTypes;
    slaHours!: number;
    trialEnabled!: boolean;
    trialDays?: number | undefined;
    ribbonText?: string | undefined;
    displayOrder!: number;
    subscriptionPlanStatusType!: SubscriptionPlanStatusTypes;
    isPublic!: boolean;
    isDefaultForRegistration!: boolean;
    highlightedPlan!: boolean;
    buttonLabel?: string;
    allowUpgrade!: boolean;
    allowDowngrade!: boolean;
    features?: SubscriptionPlanFeatureItemRequest[];

    constructor(data?: ICreateSubscriptionPlanAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.subscriptionPlanPaymentCycleType = _data["subscriptionPlanPaymentCycleType"];
            this.validityDuration = _data["validityDuration"];
            this.validityDurationType = _data["validityDurationType"];
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.supportType = _data["supportType"];
            this.slaHours = _data["slaHours"];
            this.trialEnabled = _data["trialEnabled"];
            this.trialDays = _data["trialDays"];
            this.ribbonText = _data["ribbonText"];
            this.displayOrder = _data["displayOrder"];
            this.subscriptionPlanStatusType = _data["subscriptionPlanStatusType"];
            this.isPublic = _data["isPublic"];
            this.isDefaultForRegistration = _data["isDefaultForRegistration"];
            this.highlightedPlan = _data["highlightedPlan"];
            this.buttonLabel = _data["buttonLabel"];
            this.allowUpgrade = _data["allowUpgrade"];
            this.allowDowngrade = _data["allowDowngrade"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(SubscriptionPlanFeatureItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSubscriptionPlanAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionPlanAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["description"] = this.description;
        data["price"] = this.price;
        data["subscriptionPlanPaymentCycleType"] = this.subscriptionPlanPaymentCycleType;
        data["validityDuration"] = this.validityDuration;
        data["validityDurationType"] = this.validityDurationType;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["supportType"] = this.supportType;
        data["slaHours"] = this.slaHours;
        data["trialEnabled"] = this.trialEnabled;
        data["trialDays"] = this.trialDays;
        data["ribbonText"] = this.ribbonText;
        data["displayOrder"] = this.displayOrder;
        data["subscriptionPlanStatusType"] = this.subscriptionPlanStatusType;
        data["isPublic"] = this.isPublic;
        data["isDefaultForRegistration"] = this.isDefaultForRegistration;
        data["highlightedPlan"] = this.highlightedPlan;
        data["buttonLabel"] = this.buttonLabel;
        data["allowUpgrade"] = this.allowUpgrade;
        data["allowDowngrade"] = this.allowDowngrade;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateSubscriptionPlanAdminRequest {
    name: string;
    slug: string;
    description: string;
    price: number;
    subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes;
    validityDuration: number;
    validityDurationType: ValidityDurationType;
    maxUsers: number;
    maxInstances: number;
    supportType: SupportTypeTypes;
    slaHours: number;
    trialEnabled: boolean;
    trialDays?: number | undefined;
    ribbonText?: string | undefined;
    displayOrder: number;
    subscriptionPlanStatusType: SubscriptionPlanStatusTypes;
    isPublic: boolean;
    isDefaultForRegistration: boolean;
    highlightedPlan: boolean;
    buttonLabel?: string;
    allowUpgrade: boolean;
    allowDowngrade: boolean;
    features?: SubscriptionPlanFeatureItemRequest[];
}

export enum SubscriptionPlanStatusTypes {
    Deactive = "Deactive",
    Active = "Active",
}

export class SubscriptionPlanFeatureItemRequest implements ISubscriptionPlanFeatureItemRequest {
    id?: number | undefined;
    featureText!: string;
    sortOrder!: number;

    constructor(data?: ISubscriptionPlanFeatureItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.featureText = _data["featureText"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): SubscriptionPlanFeatureItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPlanFeatureItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["featureText"] = this.featureText;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ISubscriptionPlanFeatureItemRequest {
    id?: number | undefined;
    featureText: string;
    sortOrder: number;
}

export class UpdateSubscriptionPlanAdminRequest extends CreateSubscriptionPlanAdminRequest implements IUpdateSubscriptionPlanAdminRequest {
    id!: number;

    constructor(data?: IUpdateSubscriptionPlanAdminRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateSubscriptionPlanAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionPlanAdminRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateSubscriptionPlanAdminRequest extends ICreateSubscriptionPlanAdminRequest {
    id: number;
}

export class ViewSubscriptionPlanDetailResponse implements IViewSubscriptionPlanDetailResponse {
    id!: number;
    name!: string;
    slug!: string;
    description!: string;
    price!: number;
    subscriptionPlanPaymentCycleType!: SubscriptionPlanPaymentCycleTypes;
    validityDuration!: number;
    validityDurationType!: ValidityDurationType;
    maxUsers!: number;
    maxInstances!: number;
    supportType!: SupportTypeTypes;
    slaHours!: number;
    trialEnabled!: boolean;
    trialDays?: number | undefined;
    ribbonText?: string | undefined;
    displayOrder!: number;
    subscriptionPlanStatusType!: SubscriptionPlanStatusTypes;
    isPublic!: boolean;
    isCustomPlan!: boolean;
    isDefaultForRegistration!: boolean;
    highlightedPlan!: boolean;
    buttonLabel!: string;
    allowUpgrade!: boolean;
    allowDowngrade!: boolean;
    createdOn!: moment.Moment;
    lastModifiedOn!: moment.Moment | undefined;
    features!: SubscriptionPlanFeatureResponse[];

    constructor(data?: IViewSubscriptionPlanDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.features = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.subscriptionPlanPaymentCycleType = _data["subscriptionPlanPaymentCycleType"];
            this.validityDuration = _data["validityDuration"];
            this.validityDurationType = _data["validityDurationType"];
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.supportType = _data["supportType"];
            this.slaHours = _data["slaHours"];
            this.trialEnabled = _data["trialEnabled"];
            this.trialDays = _data["trialDays"];
            this.ribbonText = _data["ribbonText"];
            this.displayOrder = _data["displayOrder"];
            this.subscriptionPlanStatusType = _data["subscriptionPlanStatusType"];
            this.isPublic = _data["isPublic"];
            this.isCustomPlan = _data["isCustomPlan"];
            this.isDefaultForRegistration = _data["isDefaultForRegistration"];
            this.highlightedPlan = _data["highlightedPlan"];
            this.buttonLabel = _data["buttonLabel"];
            this.allowUpgrade = _data["allowUpgrade"];
            this.allowDowngrade = _data["allowDowngrade"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.lastModifiedOn = _data["lastModifiedOn"] ? moment(_data["lastModifiedOn"].toString()) : undefined as any;
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(SubscriptionPlanFeatureResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViewSubscriptionPlanDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewSubscriptionPlanDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["description"] = this.description;
        data["price"] = this.price;
        data["subscriptionPlanPaymentCycleType"] = this.subscriptionPlanPaymentCycleType;
        data["validityDuration"] = this.validityDuration;
        data["validityDurationType"] = this.validityDurationType;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["supportType"] = this.supportType;
        data["slaHours"] = this.slaHours;
        data["trialEnabled"] = this.trialEnabled;
        data["trialDays"] = this.trialDays;
        data["ribbonText"] = this.ribbonText;
        data["displayOrder"] = this.displayOrder;
        data["subscriptionPlanStatusType"] = this.subscriptionPlanStatusType;
        data["isPublic"] = this.isPublic;
        data["isCustomPlan"] = this.isCustomPlan;
        data["isDefaultForRegistration"] = this.isDefaultForRegistration;
        data["highlightedPlan"] = this.highlightedPlan;
        data["buttonLabel"] = this.buttonLabel;
        data["allowUpgrade"] = this.allowUpgrade;
        data["allowDowngrade"] = this.allowDowngrade;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : undefined as any;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IViewSubscriptionPlanDetailResponse {
    id: number;
    name: string;
    slug: string;
    description: string;
    price: number;
    subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes;
    validityDuration: number;
    validityDurationType: ValidityDurationType;
    maxUsers: number;
    maxInstances: number;
    supportType: SupportTypeTypes;
    slaHours: number;
    trialEnabled: boolean;
    trialDays?: number | undefined;
    ribbonText?: string | undefined;
    displayOrder: number;
    subscriptionPlanStatusType: SubscriptionPlanStatusTypes;
    isPublic: boolean;
    isCustomPlan: boolean;
    isDefaultForRegistration: boolean;
    highlightedPlan: boolean;
    buttonLabel: string;
    allowUpgrade: boolean;
    allowDowngrade: boolean;
    createdOn: moment.Moment;
    lastModifiedOn: moment.Moment | undefined;
    features: SubscriptionPlanFeatureResponse[];
}

export class PaginationResponseOfViewSubscriptionPlanListResponse implements IPaginationResponseOfViewSubscriptionPlanListResponse {
    data?: ViewSubscriptionPlanListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewSubscriptionPlanListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewSubscriptionPlanListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewSubscriptionPlanListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewSubscriptionPlanListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewSubscriptionPlanListResponse {
    data?: ViewSubscriptionPlanListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewSubscriptionPlanListResponse implements IViewSubscriptionPlanListResponse {
    id!: number;
    name!: string;
    price!: number;
    subscriptionPlanPaymentCycleType!: SubscriptionPlanPaymentCycleTypes;
    maxInstances!: number;
    maxUsers!: number;
    supportType!: SupportTypeTypes;
    subscriptionPlanStatusType!: SubscriptionPlanStatusTypes;
    trialEnabled!: boolean;
    isCustomPlan!: boolean;
    createdOn!: moment.Moment;

    constructor(data?: IViewSubscriptionPlanListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.subscriptionPlanPaymentCycleType = _data["subscriptionPlanPaymentCycleType"];
            this.maxInstances = _data["maxInstances"];
            this.maxUsers = _data["maxUsers"];
            this.supportType = _data["supportType"];
            this.subscriptionPlanStatusType = _data["subscriptionPlanStatusType"];
            this.trialEnabled = _data["trialEnabled"];
            this.isCustomPlan = _data["isCustomPlan"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ViewSubscriptionPlanListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewSubscriptionPlanListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["subscriptionPlanPaymentCycleType"] = this.subscriptionPlanPaymentCycleType;
        data["maxInstances"] = this.maxInstances;
        data["maxUsers"] = this.maxUsers;
        data["supportType"] = this.supportType;
        data["subscriptionPlanStatusType"] = this.subscriptionPlanStatusType;
        data["trialEnabled"] = this.trialEnabled;
        data["isCustomPlan"] = this.isCustomPlan;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IViewSubscriptionPlanListResponse {
    id: number;
    name: string;
    price: number;
    subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes;
    maxInstances: number;
    maxUsers: number;
    supportType: SupportTypeTypes;
    subscriptionPlanStatusType: SubscriptionPlanStatusTypes;
    trialEnabled: boolean;
    isCustomPlan: boolean;
    createdOn: moment.Moment;
}

export class SearchSubscriptionPlansRequest extends SearchRequestBaseClass implements ISearchSubscriptionPlansRequest {
    searchText?: string | undefined;
    status?: SubscriptionPlanStatusTypes | undefined;
    billingCycle?: SubscriptionPlanPaymentCycleTypes | undefined;
    trialEnabled?: boolean | undefined;

    constructor(data?: ISearchSubscriptionPlansRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
            this.status = _data["status"];
            this.billingCycle = _data["billingCycle"];
            this.trialEnabled = _data["trialEnabled"];
        }
    }

    static override fromJS(data: any): SearchSubscriptionPlansRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSubscriptionPlansRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["status"] = this.status;
        data["billingCycle"] = this.billingCycle;
        data["trialEnabled"] = this.trialEnabled;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchSubscriptionPlansRequest extends ISearchRequestBaseClass {
    searchText?: string | undefined;
    status?: SubscriptionPlanStatusTypes | undefined;
    billingCycle?: SubscriptionPlanPaymentCycleTypes | undefined;
    trialEnabled?: boolean | undefined;
}

export class SubscriptionQuoteResponse implements ISubscriptionQuoteResponse {
    quoteId!: string;
    subscriptionPlanId!: number;
    planName!: string;
    seats!: number;
    termMonths!: number;
    discountPercent!: number;
    basePrice!: number;
    totalPrice!: number;
    currency!: string;
    expiresOn!: moment.Moment;
    lineItemsSummary?: string | undefined;
    promoCodeApplied?: string | undefined;
    discountAmount?: number;

    constructor(data?: ISubscriptionQuoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.planName = _data["planName"];
            this.seats = _data["seats"];
            this.termMonths = _data["termMonths"];
            this.discountPercent = _data["discountPercent"];
            this.basePrice = _data["basePrice"];
            this.totalPrice = _data["totalPrice"];
            this.currency = _data["currency"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.lineItemsSummary = _data["lineItemsSummary"];
            this.promoCodeApplied = _data["promoCodeApplied"];
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any): SubscriptionQuoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionQuoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["planName"] = this.planName;
        data["seats"] = this.seats;
        data["termMonths"] = this.termMonths;
        data["discountPercent"] = this.discountPercent;
        data["basePrice"] = this.basePrice;
        data["totalPrice"] = this.totalPrice;
        data["currency"] = this.currency;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["lineItemsSummary"] = this.lineItemsSummary;
        data["promoCodeApplied"] = this.promoCodeApplied;
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface ISubscriptionQuoteResponse {
    quoteId: string;
    subscriptionPlanId: number;
    planName: string;
    seats: number;
    termMonths: number;
    discountPercent: number;
    basePrice: number;
    totalPrice: number;
    currency: string;
    expiresOn: moment.Moment;
    lineItemsSummary?: string | undefined;
    promoCodeApplied?: string | undefined;
    discountAmount?: number;
}

export class CreateSubscriptionQuoteRequest implements ICreateSubscriptionQuoteRequest {
    subscriptionPlanId!: number;
    seats?: number;
    termMonths?: number;
    discountPercent?: number;
    /** Optional promotional/coupon code to validate and apply to this quote. */
    promoCode?: string | undefined;

    constructor(data?: ICreateSubscriptionQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPlanId = _data["subscriptionPlanId"];
            this.seats = _data["seats"];
            this.termMonths = _data["termMonths"];
            this.discountPercent = _data["discountPercent"];
            this.promoCode = _data["promoCode"];
        }
    }

    static fromJS(data: any): CreateSubscriptionQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPlanId"] = this.subscriptionPlanId;
        data["seats"] = this.seats;
        data["termMonths"] = this.termMonths;
        data["discountPercent"] = this.discountPercent;
        data["promoCode"] = this.promoCode;
        return data;
    }
}

export interface ICreateSubscriptionQuoteRequest {
    subscriptionPlanId: number;
    seats?: number;
    termMonths?: number;
    discountPercent?: number;
    /** Optional promotional/coupon code to validate and apply to this quote. */
    promoCode?: string | undefined;
}

export class PaginationResponseOfAdminTransactionListResponse implements IPaginationResponseOfAdminTransactionListResponse {
    data?: AdminTransactionListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfAdminTransactionListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdminTransactionListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfAdminTransactionListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfAdminTransactionListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfAdminTransactionListResponse {
    data?: AdminTransactionListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdminTransactionListResponse implements IAdminTransactionListResponse {
    id!: number;
    tenantId!: number;
    tenantName!: string;
    tenantAdminEmail!: string;
    tenantSubscriptionPlanId!: number;
    planName!: string;
    amount!: number;
    currency!: string;
    paymentStatus!: SubscriptionPaymentStatusTypes;
    stripePaymentIntentId?: string | undefined;
    invoiceUrl?: string | undefined;
    purchasedByUserId?: string | undefined;
    createdOn!: moment.Moment;

    constructor(data?: IAdminTransactionListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.tenantAdminEmail = _data["tenantAdminEmail"];
            this.tenantSubscriptionPlanId = _data["tenantSubscriptionPlanId"];
            this.planName = _data["planName"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentStatus = _data["paymentStatus"];
            this.stripePaymentIntentId = _data["stripePaymentIntentId"];
            this.invoiceUrl = _data["invoiceUrl"];
            this.purchasedByUserId = _data["purchasedByUserId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminTransactionListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTransactionListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["tenantAdminEmail"] = this.tenantAdminEmail;
        data["tenantSubscriptionPlanId"] = this.tenantSubscriptionPlanId;
        data["planName"] = this.planName;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentStatus"] = this.paymentStatus;
        data["stripePaymentIntentId"] = this.stripePaymentIntentId;
        data["invoiceUrl"] = this.invoiceUrl;
        data["purchasedByUserId"] = this.purchasedByUserId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminTransactionListResponse {
    id: number;
    tenantId: number;
    tenantName: string;
    tenantAdminEmail: string;
    tenantSubscriptionPlanId: number;
    planName: string;
    amount: number;
    currency: string;
    paymentStatus: SubscriptionPaymentStatusTypes;
    stripePaymentIntentId?: string | undefined;
    invoiceUrl?: string | undefined;
    purchasedByUserId?: string | undefined;
    createdOn: moment.Moment;
}

export class SearchAdminTransactionsRequest extends SearchRequestBaseClass implements ISearchAdminTransactionsRequest {
    paymentStatus?: SubscriptionPaymentStatusTypes | undefined;
    dateFrom?: moment.Moment | undefined;
    dateTo?: moment.Moment | undefined;
    tenantId?: number | undefined;
    keyword?: string | undefined;

    constructor(data?: ISearchAdminTransactionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentStatus = _data["paymentStatus"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.keyword = _data["keyword"];
        }
    }

    static override fromJS(data: any): SearchAdminTransactionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAdminTransactionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["keyword"] = this.keyword;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchAdminTransactionsRequest extends ISearchRequestBaseClass {
    paymentStatus?: SubscriptionPaymentStatusTypes | undefined;
    dateFrom?: moment.Moment | undefined;
    dateTo?: moment.Moment | undefined;
    tenantId?: number | undefined;
    keyword?: string | undefined;
}

export class TransactionAnalyticsSummaryResponse implements ITransactionAnalyticsSummaryResponse {
    totalCount?: number;
    succeededCount?: number;
    failedCount?: number;
    pendingCount?: number;
    refundedCount?: number;
    succeededAmount?: number;
    currency?: string;

    constructor(data?: ITransactionAnalyticsSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.succeededCount = _data["succeededCount"];
            this.failedCount = _data["failedCount"];
            this.pendingCount = _data["pendingCount"];
            this.refundedCount = _data["refundedCount"];
            this.succeededAmount = _data["succeededAmount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): TransactionAnalyticsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionAnalyticsSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["succeededCount"] = this.succeededCount;
        data["failedCount"] = this.failedCount;
        data["pendingCount"] = this.pendingCount;
        data["refundedCount"] = this.refundedCount;
        data["succeededAmount"] = this.succeededAmount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ITransactionAnalyticsSummaryResponse {
    totalCount?: number;
    succeededCount?: number;
    failedCount?: number;
    pendingCount?: number;
    refundedCount?: number;
    succeededAmount?: number;
    currency?: string;
}

export class ViewSettingResponse implements IViewSettingResponse {
    id?: number;
    settingType!: SettingTypes;
    description?: string | undefined;

    constructor(data?: IViewSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settingType = _data["settingType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ViewSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settingType"] = this.settingType;
        data["description"] = this.description;
        return data;
    }
}

export interface IViewSettingResponse {
    id?: number;
    settingType: SettingTypes;
    description?: string | undefined;
}

export enum SettingTypes {
    Appointment = "Appointment",
    ApprovedAppointment = "ApprovedAppointment",
}

export class UpdateSettingsRequest implements IUpdateSettingsRequest {
    id!: number;
    settingJson!: string;

    constructor(data?: IUpdateSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settingJson = _data["settingJson"];
        }
    }

    static fromJS(data: any): UpdateSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settingJson"] = this.settingJson;
        return data;
    }
}

export interface IUpdateSettingsRequest {
    id: number;
    settingJson: string;
}

export class CreateIntentRequest implements ICreateIntentRequest {
    currency!: StripeCurrencyType;
    subscriptionId!: number;
    quoteId?: string | undefined;
    intentType?: SubscriptionPurchaseIntentType;
    previousTenantSubscriptionPlanId?: number | undefined;
    /** Stripe PaymentMethod id (pm_*) to charge a saved card. Must belong to the tenant's Stripe customer. */
    paymentMethodId?: string | undefined;

    constructor(data?: ICreateIntentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.subscriptionId = _data["subscriptionId"];
            this.quoteId = _data["quoteId"];
            this.intentType = _data["intentType"];
            this.previousTenantSubscriptionPlanId = _data["previousTenantSubscriptionPlanId"];
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): CreateIntentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["subscriptionId"] = this.subscriptionId;
        data["quoteId"] = this.quoteId;
        data["intentType"] = this.intentType;
        data["previousTenantSubscriptionPlanId"] = this.previousTenantSubscriptionPlanId;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }
}

export interface ICreateIntentRequest {
    currency: StripeCurrencyType;
    subscriptionId: number;
    quoteId?: string | undefined;
    intentType?: SubscriptionPurchaseIntentType;
    previousTenantSubscriptionPlanId?: number | undefined;
    /** Stripe PaymentMethod id (pm_*) to charge a saved card. Must belong to the tenant's Stripe customer. */
    paymentMethodId?: string | undefined;
}

export enum StripeCurrencyType {
    USD = "USD",
    INR = "INR",
}

export enum SubscriptionPurchaseIntentType {
    NewPurchase = "NewPurchase",
    Upgrade = "Upgrade",
    Renew = "Renew",
}

export class PaymentMethodIdRequest implements IPaymentMethodIdRequest {
    paymentMethodId!: string;

    constructor(data?: IPaymentMethodIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any): PaymentMethodIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }
}

export interface IPaymentMethodIdRequest {
    paymentMethodId: string;
}

export class CampaignListResponse implements ICampaignListResponse {
    id?: number;
    name!: string;
    uniqueName!: string;
    description?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    referralCode?: string | undefined;
    promoCode?: string | undefined;
    isActive?: boolean;
    signupCount?: number;
    createdOn?: moment.Moment;

    constructor(data?: ICampaignListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uniqueName = _data["uniqueName"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.referralCode = _data["referralCode"];
            this.promoCode = _data["promoCode"];
            this.isActive = _data["isActive"];
            this.signupCount = _data["signupCount"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CampaignListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uniqueName"] = this.uniqueName;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["referralCode"] = this.referralCode;
        data["promoCode"] = this.promoCode;
        data["isActive"] = this.isActive;
        data["signupCount"] = this.signupCount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICampaignListResponse {
    id?: number;
    name: string;
    uniqueName: string;
    description?: string | undefined;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    referralCode?: string | undefined;
    promoCode?: string | undefined;
    isActive?: boolean;
    signupCount?: number;
    createdOn?: moment.Moment;
}

export class CampaignDetailResponse extends CampaignListResponse implements ICampaignDetailResponse {
    platforms?: CampaignPlatformLinkResponse[];

    constructor(data?: ICampaignDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["platforms"])) {
                this.platforms = [] as any;
                for (let item of _data["platforms"])
                    this.platforms!.push(CampaignPlatformLinkResponse.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CampaignDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.platforms)) {
            data["platforms"] = [];
            for (let item of this.platforms)
                data["platforms"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICampaignDetailResponse extends ICampaignListResponse {
    platforms?: CampaignPlatformLinkResponse[];
}

export class CampaignPlatformLinkResponse implements ICampaignPlatformLinkResponse {
    id?: number;
    registrationSourceValueId?: number;
    registrationSource!: string;
    sourceSlug!: string;
    registrationUrl!: string;

    constructor(data?: ICampaignPlatformLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationSourceValueId = _data["registrationSourceValueId"];
            this.registrationSource = _data["registrationSource"];
            this.sourceSlug = _data["sourceSlug"];
            this.registrationUrl = _data["registrationUrl"];
        }
    }

    static fromJS(data: any): CampaignPlatformLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignPlatformLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationSourceValueId"] = this.registrationSourceValueId;
        data["registrationSource"] = this.registrationSource;
        data["sourceSlug"] = this.sourceSlug;
        data["registrationUrl"] = this.registrationUrl;
        return data;
    }
}

export interface ICampaignPlatformLinkResponse {
    id?: number;
    registrationSourceValueId?: number;
    registrationSource: string;
    sourceSlug: string;
    registrationUrl: string;
}

export class CreateCampaignRequest implements ICreateCampaignRequest {
    name!: string;
    uniqueName!: string;
    description?: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    referralCode?: string | undefined;
    promoCode?: string | undefined;

    constructor(data?: ICreateCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uniqueName = _data["uniqueName"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.referralCode = _data["referralCode"];
            this.promoCode = _data["promoCode"];
        }
    }

    static fromJS(data: any): CreateCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uniqueName"] = this.uniqueName;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["referralCode"] = this.referralCode;
        data["promoCode"] = this.promoCode;
        return data;
    }
}

export interface ICreateCampaignRequest {
    name: string;
    uniqueName: string;
    description?: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    referralCode?: string | undefined;
    promoCode?: string | undefined;
}

export class PaginationResponseOfCampaignListResponse implements IPaginationResponseOfCampaignListResponse {
    data?: CampaignListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfCampaignListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CampaignListResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfCampaignListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfCampaignListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfCampaignListResponse {
    data?: CampaignListResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SearchCampaignsRequest extends SearchRequestBaseClass implements ISearchCampaignsRequest {
    searchText?: string | undefined;

    constructor(data?: ISearchCampaignsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static override fromJS(data: any): SearchCampaignsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCampaignsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchCampaignsRequest extends ISearchRequestBaseClass {
    searchText?: string | undefined;
}

export class CampaignRegistrationResolveResponse implements ICampaignRegistrationResolveResponse {
    campaignId?: number;
    campaignUniqueName!: string;
    registrationSourceValueId?: number;
    sourceSlug!: string;
    registrationSource!: string;

    constructor(data?: ICampaignRegistrationResolveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.campaignUniqueName = _data["campaignUniqueName"];
            this.registrationSourceValueId = _data["registrationSourceValueId"];
            this.sourceSlug = _data["sourceSlug"];
            this.registrationSource = _data["registrationSource"];
        }
    }

    static fromJS(data: any): CampaignRegistrationResolveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRegistrationResolveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["campaignUniqueName"] = this.campaignUniqueName;
        data["registrationSourceValueId"] = this.registrationSourceValueId;
        data["sourceSlug"] = this.sourceSlug;
        data["registrationSource"] = this.registrationSource;
        return data;
    }
}

export interface ICampaignRegistrationResolveResponse {
    campaignId?: number;
    campaignUniqueName: string;
    registrationSourceValueId?: number;
    sourceSlug: string;
    registrationSource: string;
}

export class PaginationResponseOfViewTenantResponse implements IPaginationResponseOfViewTenantResponse {
    data?: ViewTenantResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewTenantResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewTenantResponse {
    data?: ViewTenantResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewTenantResponse implements IViewTenantResponse {
    name!: string;
    adminEmail!: string;
    isActive!: boolean;
    stripeCustomerId?: string | undefined;
    createdOn!: moment.Moment;
    id!: number;

    constructor(data?: IViewTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.adminEmail = _data["adminEmail"];
            this.isActive = _data["isActive"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ViewTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["adminEmail"] = this.adminEmail;
        data["isActive"] = this.isActive;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IViewTenantResponse {
    name: string;
    adminEmail: string;
    isActive: boolean;
    stripeCustomerId?: string | undefined;
    createdOn: moment.Moment;
    id: number;
}

export class SearchTenantRequest extends SearchRequestBaseClass implements ISearchTenantRequest {
    freeText?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ISearchTenantRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.freeText = _data["freeText"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): SearchTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTenantRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeText"] = this.freeText;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchTenantRequest extends ISearchRequestBaseClass {
    freeText?: string | undefined;
    isActive?: boolean | undefined;
}

export class GetTenantSubscriptionResponse implements IGetTenantSubscriptionResponse {
    tenantSubscriptionId!: number;
    tenantSubscriptionName!: string;
    tenantSubscriptionDescription!: string;
    validityDurationType!: ValidityDurationType;
    validityDuration!: number;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionSchedulerId?: string | undefined;
    isActive!: boolean;
    expiredOn!: moment.Moment;
    startedOn!: moment.Moment;
    price!: number;
    tenantSubscriptionInvoiceResponses!: TenantSubscriptionInvoiceResponse[];

    constructor(data?: IGetTenantSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenantSubscriptionInvoiceResponses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantSubscriptionId = _data["tenantSubscriptionId"];
            this.tenantSubscriptionName = _data["tenantSubscriptionName"];
            this.tenantSubscriptionDescription = _data["tenantSubscriptionDescription"];
            this.validityDurationType = _data["validityDurationType"];
            this.validityDuration = _data["validityDuration"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.stripeSubscriptionSchedulerId = _data["stripeSubscriptionSchedulerId"];
            this.isActive = _data["isActive"];
            this.expiredOn = _data["expiredOn"] ? moment(_data["expiredOn"].toString()) : undefined as any;
            this.startedOn = _data["startedOn"] ? moment(_data["startedOn"].toString()) : undefined as any;
            this.price = _data["price"];
            if (Array.isArray(_data["tenantSubscriptionInvoiceResponses"])) {
                this.tenantSubscriptionInvoiceResponses = [] as any;
                for (let item of _data["tenantSubscriptionInvoiceResponses"])
                    this.tenantSubscriptionInvoiceResponses!.push(TenantSubscriptionInvoiceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantSubscriptionId"] = this.tenantSubscriptionId;
        data["tenantSubscriptionName"] = this.tenantSubscriptionName;
        data["tenantSubscriptionDescription"] = this.tenantSubscriptionDescription;
        data["validityDurationType"] = this.validityDurationType;
        data["validityDuration"] = this.validityDuration;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["stripeSubscriptionSchedulerId"] = this.stripeSubscriptionSchedulerId;
        data["isActive"] = this.isActive;
        data["expiredOn"] = this.expiredOn ? this.expiredOn.toISOString() : undefined as any;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["price"] = this.price;
        if (Array.isArray(this.tenantSubscriptionInvoiceResponses)) {
            data["tenantSubscriptionInvoiceResponses"] = [];
            for (let item of this.tenantSubscriptionInvoiceResponses)
                data["tenantSubscriptionInvoiceResponses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantSubscriptionResponse {
    tenantSubscriptionId: number;
    tenantSubscriptionName: string;
    tenantSubscriptionDescription: string;
    validityDurationType: ValidityDurationType;
    validityDuration: number;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionSchedulerId?: string | undefined;
    isActive: boolean;
    expiredOn: moment.Moment;
    startedOn: moment.Moment;
    price: number;
    tenantSubscriptionInvoiceResponses: TenantSubscriptionInvoiceResponse[];
}

export class TenantSubscriptionInvoiceResponse implements ITenantSubscriptionInvoiceResponse {
    tenantSubscriptionInvoiceId!: number;
    stripeInvoiceId?: string | undefined;
    periodFrom!: moment.Moment;
    periodTo!: moment.Moment;
    stripePaymentStatus!: string;

    constructor(data?: ITenantSubscriptionInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantSubscriptionInvoiceId = _data["tenantSubscriptionInvoiceId"];
            this.stripeInvoiceId = _data["stripeInvoiceId"];
            this.periodFrom = _data["periodFrom"] ? moment(_data["periodFrom"].toString()) : undefined as any;
            this.periodTo = _data["periodTo"] ? moment(_data["periodTo"].toString()) : undefined as any;
            this.stripePaymentStatus = _data["stripePaymentStatus"];
        }
    }

    static fromJS(data: any): TenantSubscriptionInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSubscriptionInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantSubscriptionInvoiceId"] = this.tenantSubscriptionInvoiceId;
        data["stripeInvoiceId"] = this.stripeInvoiceId;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : undefined as any;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : undefined as any;
        data["stripePaymentStatus"] = this.stripePaymentStatus;
        return data;
    }
}

export interface ITenantSubscriptionInvoiceResponse {
    tenantSubscriptionInvoiceId: number;
    stripeInvoiceId?: string | undefined;
    periodFrom: moment.Moment;
    periodTo: moment.Moment;
    stripePaymentStatus: string;
}

export class ViewUserDetailsResponse implements IViewUserDetailsResponse {
    id?: string;
    userName!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    isActive!: boolean;
    emailConfirmed!: boolean;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isTwoFactorAuthenticationEnabled?: boolean | undefined;
    fkTenantId?: number;
    tenantName?: string | undefined;
    roles?: string[];
    windowsClientVersionIds?: number[];
    microsoftSqlServerVersionIds?: number[];
    windowsServerVersionIds?: number[];
    countryId?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    jobTitle?: string | undefined;
    registrationSource?: string | undefined;
    lastLogin?: moment.Moment | undefined;
    createdOn?: moment.Moment | undefined;

    constructor(data?: IViewUserDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.isTwoFactorAuthenticationEnabled = _data["isTwoFactorAuthenticationEnabled"];
            this.fkTenantId = _data["fkTenantId"];
            this.tenantName = _data["tenantName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["windowsClientVersionIds"])) {
                this.windowsClientVersionIds = [] as any;
                for (let item of _data["windowsClientVersionIds"])
                    this.windowsClientVersionIds!.push(item);
            }
            if (Array.isArray(_data["microsoftSqlServerVersionIds"])) {
                this.microsoftSqlServerVersionIds = [] as any;
                for (let item of _data["microsoftSqlServerVersionIds"])
                    this.microsoftSqlServerVersionIds!.push(item);
            }
            if (Array.isArray(_data["windowsServerVersionIds"])) {
                this.windowsServerVersionIds = [] as any;
                for (let item of _data["windowsServerVersionIds"])
                    this.windowsServerVersionIds!.push(item);
            }
            this.countryId = _data["countryId"];
            this.stateId = _data["stateId"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.jobTitle = _data["jobTitle"];
            this.registrationSource = _data["registrationSource"];
            this.lastLogin = _data["lastLogin"] ? moment(_data["lastLogin"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ViewUserDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewUserDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["isTwoFactorAuthenticationEnabled"] = this.isTwoFactorAuthenticationEnabled;
        data["fkTenantId"] = this.fkTenantId;
        data["tenantName"] = this.tenantName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.windowsClientVersionIds)) {
            data["windowsClientVersionIds"] = [];
            for (let item of this.windowsClientVersionIds)
                data["windowsClientVersionIds"].push(item);
        }
        if (Array.isArray(this.microsoftSqlServerVersionIds)) {
            data["microsoftSqlServerVersionIds"] = [];
            for (let item of this.microsoftSqlServerVersionIds)
                data["microsoftSqlServerVersionIds"].push(item);
        }
        if (Array.isArray(this.windowsServerVersionIds)) {
            data["windowsServerVersionIds"] = [];
            for (let item of this.windowsServerVersionIds)
                data["windowsServerVersionIds"].push(item);
        }
        data["countryId"] = this.countryId;
        data["stateId"] = this.stateId;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["jobTitle"] = this.jobTitle;
        data["registrationSource"] = this.registrationSource;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IViewUserDetailsResponse {
    id?: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
    emailConfirmed: boolean;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isTwoFactorAuthenticationEnabled?: boolean | undefined;
    fkTenantId?: number;
    tenantName?: string | undefined;
    roles?: string[];
    windowsClientVersionIds?: number[];
    microsoftSqlServerVersionIds?: number[];
    windowsServerVersionIds?: number[];
    countryId?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    jobTitle?: string | undefined;
    registrationSource?: string | undefined;
    lastLogin?: moment.Moment | undefined;
    createdOn?: moment.Moment | undefined;
}

export class UpdateTenantRequest implements IUpdateTenantRequest {
    name!: string;
    adminEmail!: string;
    isActive!: boolean;
    id!: number;

    constructor(data?: IUpdateTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.adminEmail = _data["adminEmail"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["adminEmail"] = this.adminEmail;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTenantRequest {
    name: string;
    adminEmail: string;
    isActive: boolean;
    id: number;
}

export class ViewLookUpsResponse implements IViewLookUpsResponse {
    id?: number;
    lookUpCodeType!: LookUpCodeTypes;
    description?: string | undefined;

    constructor(data?: IViewLookUpsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpCodeType = _data["lookUpCodeType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ViewLookUpsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewLookUpsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpCodeType"] = this.lookUpCodeType;
        data["description"] = this.description;
        return data;
    }
}

export interface IViewLookUpsResponse {
    id?: number;
    lookUpCodeType: LookUpCodeTypes;
    description?: string | undefined;
}

export class PaginationResponseOfViewLookUpCodeValuesResponse implements IPaginationResponseOfViewLookUpCodeValuesResponse {
    data?: ViewLookUpCodeValuesResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewLookUpCodeValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewLookUpCodeValuesResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewLookUpCodeValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewLookUpCodeValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewLookUpCodeValuesResponse {
    data?: ViewLookUpCodeValuesResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewLookUpCodeValuesResponse implements IViewLookUpCodeValuesResponse {
    id?: number;
    lookUpValue!: string;
    displayOrder!: number;
    isActive!: boolean;

    constructor(data?: IViewLookUpCodeValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ViewLookUpCodeValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewLookUpCodeValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IViewLookUpCodeValuesResponse {
    id?: number;
    lookUpValue: string;
    displayOrder: number;
    isActive: boolean;
}

export class SearchLookUpCodeValuesRequest extends SearchRequestBaseClass implements ISearchLookUpCodeValuesRequest {
    type?: LookUpCodeTypes;

    constructor(data?: ISearchLookUpCodeValuesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): SearchLookUpCodeValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLookUpCodeValuesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchLookUpCodeValuesRequest extends ISearchRequestBaseClass {
    type?: LookUpCodeTypes;
}

export class CreateLookUpCodeValueRequest implements ICreateLookUpCodeValueRequest {
    lookUpValue!: string;
    displayOrder!: number;
    lookUpCodeId?: number;
    isActive!: boolean;

    constructor(data?: ICreateLookUpCodeValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.lookUpCodeId = _data["lookUpCodeId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateLookUpCodeValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLookUpCodeValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["lookUpCodeId"] = this.lookUpCodeId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateLookUpCodeValueRequest {
    lookUpValue: string;
    displayOrder: number;
    lookUpCodeId?: number;
    isActive: boolean;
}

export class UpdateLookUpCodeValueRequest implements IUpdateLookUpCodeValueRequest {
    id!: number;
    lookUpValue!: string;
    displayOrder!: number;
    isActive!: boolean;

    constructor(data?: IUpdateLookUpCodeValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateLookUpCodeValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLookUpCodeValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateLookUpCodeValueRequest {
    id: number;
    lookUpValue: string;
    displayOrder: number;
    isActive: boolean;
}

export class ViewPlatformLookUpsResponse implements IViewPlatformLookUpsResponse {
    id!: number;
    lookUpCodeType!: PlatformLookUpCodeTypes;
    description?: string | undefined;

    constructor(data?: IViewPlatformLookUpsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpCodeType = _data["lookUpCodeType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ViewPlatformLookUpsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewPlatformLookUpsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpCodeType"] = this.lookUpCodeType;
        data["description"] = this.description;
        return data;
    }
}

export interface IViewPlatformLookUpsResponse {
    id: number;
    lookUpCodeType: PlatformLookUpCodeTypes;
    description?: string | undefined;
}

export class PaginationResponseOfViewPlatformLookUpCodeValuesResponse implements IPaginationResponseOfViewPlatformLookUpCodeValuesResponse {
    data?: ViewPlatformLookUpCodeValuesResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewPlatformLookUpCodeValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewPlatformLookUpCodeValuesResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewPlatformLookUpCodeValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewPlatformLookUpCodeValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewPlatformLookUpCodeValuesResponse {
    data?: ViewPlatformLookUpCodeValuesResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewPlatformLookUpCodeValuesResponse implements IViewPlatformLookUpCodeValuesResponse {
    id!: number;
    lookUpValue!: string;
    displayOrder!: number;
    isActive!: boolean;
    isDefault!: boolean;

    constructor(data?: IViewPlatformLookUpCodeValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ViewPlatformLookUpCodeValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewPlatformLookUpCodeValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IViewPlatformLookUpCodeValuesResponse {
    id: number;
    lookUpValue: string;
    displayOrder: number;
    isActive: boolean;
    isDefault: boolean;
}

export class SearchPlatformLookUpCodeValuesRequest extends SearchRequestBaseClass implements ISearchPlatformLookUpCodeValuesRequest {
    type!: PlatformLookUpCodeTypes;

    constructor(data?: ISearchPlatformLookUpCodeValuesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): SearchPlatformLookUpCodeValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPlatformLookUpCodeValuesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPlatformLookUpCodeValuesRequest extends ISearchRequestBaseClass {
    type: PlatformLookUpCodeTypes;
}

export class CreatePlatformLookUpCodeValueRequest implements ICreatePlatformLookUpCodeValueRequest {
    lookUpValue!: string;
    displayOrder!: number;
    lookUpCodeId?: number;
    isActive!: boolean;
    isDefault!: boolean;

    constructor(data?: ICreatePlatformLookUpCodeValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.lookUpCodeId = _data["lookUpCodeId"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CreatePlatformLookUpCodeValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlatformLookUpCodeValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["lookUpCodeId"] = this.lookUpCodeId;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ICreatePlatformLookUpCodeValueRequest {
    lookUpValue: string;
    displayOrder: number;
    lookUpCodeId?: number;
    isActive: boolean;
    isDefault: boolean;
}

export class UpdatePlatformLookUpCodeValueRequest implements IUpdatePlatformLookUpCodeValueRequest {
    id?: number;
    lookUpValue!: string;
    displayOrder!: number;
    isActive!: boolean;
    isDefault!: boolean;

    constructor(data?: IUpdatePlatformLookUpCodeValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lookUpValue = _data["lookUpValue"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdatePlatformLookUpCodeValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformLookUpCodeValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lookUpValue"] = this.lookUpValue;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdatePlatformLookUpCodeValueRequest {
    id?: number;
    lookUpValue: string;
    displayOrder: number;
    isActive: boolean;
    isDefault: boolean;
}

export class CreateCountryResponse implements ICreateCountryResponse {
    id!: number;
    message!: string;

    constructor(data?: ICreateCountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateCountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateCountryResponse {
    id: number;
    message: string;
}

export class CreateCountryRequest implements ICreateCountryRequest {
    countryName!: string;
    countryCode!: string;
    displayOrder!: number;

    constructor(data?: ICreateCountryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateCountryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ICreateCountryRequest {
    countryName: string;
    countryCode: string;
    displayOrder: number;
}

export class ViewCountryResponse implements IViewCountryResponse {
    id!: number;
    countryName!: string;
    countryCode!: string;
    displayOrder!: number;

    constructor(data?: IViewCountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ViewCountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IViewCountryResponse {
    id: number;
    countryName: string;
    countryCode: string;
    displayOrder: number;
}

export class UpdateCountryRequest implements IUpdateCountryRequest {
    id!: number;
    countryName!: string;
    countryCode!: string;
    displayOrder!: number;

    constructor(data?: IUpdateCountryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): UpdateCountryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IUpdateCountryRequest {
    id: number;
    countryName: string;
    countryCode: string;
    displayOrder: number;
}

export class CreateCountryLocalizationResponse implements ICreateCountryLocalizationResponse {
    id!: number;
    message!: string;

    constructor(data?: ICreateCountryLocalizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateCountryLocalizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryLocalizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateCountryLocalizationResponse {
    id: number;
    message: string;
}

export class CreateCountryLocalizationRequest implements ICreateCountryLocalizationRequest {
    fkCountryId!: number;
    key!: string;
    value!: string;

    constructor(data?: ICreateCountryLocalizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fkCountryId = _data["fkCountryId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateCountryLocalizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryLocalizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fkCountryId"] = this.fkCountryId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateCountryLocalizationRequest {
    fkCountryId: number;
    key: string;
    value: string;
}

export class PaginationResponseOfViewCountryLocalizationResponse implements IPaginationResponseOfViewCountryLocalizationResponse {
    data?: ViewCountryLocalizationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewCountryLocalizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewCountryLocalizationResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewCountryLocalizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewCountryLocalizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewCountryLocalizationResponse {
    data?: ViewCountryLocalizationResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SearchCountryLocalizationRequest extends SearchRequestBaseClass implements ISearchCountryLocalizationRequest {
    countryId!: number;

    constructor(data?: ISearchCountryLocalizationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryId = _data["countryId"];
        }
    }

    static override fromJS(data: any): SearchCountryLocalizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCountryLocalizationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchCountryLocalizationRequest extends ISearchRequestBaseClass {
    countryId: number;
}

export class UpdateCountryLocalizationRequest implements IUpdateCountryLocalizationRequest {
    id!: number;
    key!: string;
    value!: string;

    constructor(data?: IUpdateCountryLocalizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCountryLocalizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryLocalizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCountryLocalizationRequest {
    id: number;
    key: string;
    value: string;
}

export class ActivateLicenseRequest implements IActivateLicenseRequest {
    licenseKey!: string;
    machineFingerprint!: string;
    machineName?: string | undefined;
    deviceId?: string | undefined;
    machineUuid?: string | undefined;
    biosSerial?: string | undefined;
    cpu?: string | undefined;
    ram?: string | undefined;
    storage?: string | undefined;
    windows?: string | undefined;
    osBuild?: string | undefined;
    osVersion?: string | undefined;
    appVersion?: string | undefined;
    /** Primary network adapter MAC address (e.g. "AA:BB:CC:DD:EE:FF"), gathered client-side by the
SQLDBD desktop app. The server has no way to read this itself over HTTP — it can only store
whatever the client reports here. */
    macAddress?: string | undefined;

    constructor(data?: IActivateLicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.machineName = _data["machineName"];
            this.deviceId = _data["deviceId"];
            this.machineUuid = _data["machineUuid"];
            this.biosSerial = _data["biosSerial"];
            this.cpu = _data["cpu"];
            this.ram = _data["ram"];
            this.storage = _data["storage"];
            this.windows = _data["windows"];
            this.osBuild = _data["osBuild"];
            this.osVersion = _data["osVersion"];
            this.appVersion = _data["appVersion"];
            this.macAddress = _data["macAddress"];
        }
    }

    static fromJS(data: any): ActivateLicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateLicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["machineName"] = this.machineName;
        data["deviceId"] = this.deviceId;
        data["machineUuid"] = this.machineUuid;
        data["biosSerial"] = this.biosSerial;
        data["cpu"] = this.cpu;
        data["ram"] = this.ram;
        data["storage"] = this.storage;
        data["windows"] = this.windows;
        data["osBuild"] = this.osBuild;
        data["osVersion"] = this.osVersion;
        data["appVersion"] = this.appVersion;
        data["macAddress"] = this.macAddress;
        return data;
    }
}

export interface IActivateLicenseRequest {
    licenseKey: string;
    machineFingerprint: string;
    machineName?: string | undefined;
    deviceId?: string | undefined;
    machineUuid?: string | undefined;
    biosSerial?: string | undefined;
    cpu?: string | undefined;
    ram?: string | undefined;
    storage?: string | undefined;
    windows?: string | undefined;
    osBuild?: string | undefined;
    osVersion?: string | undefined;
    appVersion?: string | undefined;
    /** Primary network adapter MAC address (e.g. "AA:BB:CC:DD:EE:FF"), gathered client-side by the
SQLDBD desktop app. The server has no way to read this itself over HTTP — it can only store
whatever the client reports here. */
    macAddress?: string | undefined;
}

export class DeactivateLicenseRequest implements IDeactivateLicenseRequest {
    licenseKey!: string;
    machineFingerprint!: string;
    machineName?: string | undefined;

    constructor(data?: IDeactivateLicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.machineName = _data["machineName"];
        }
    }

    static fromJS(data: any): DeactivateLicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateLicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["machineName"] = this.machineName;
        return data;
    }
}

export interface IDeactivateLicenseRequest {
    licenseKey: string;
    machineFingerprint: string;
    machineName?: string | undefined;
}

export class RegisterSqlServerInstanceRequest implements IRegisterSqlServerInstanceRequest {
    licenseKey!: string;
    machineFingerprint!: string;
    serverName!: string;
    hostOrIp?: string | undefined;
    port?: number | undefined;
    machineName?: string | undefined;

    constructor(data?: IRegisterSqlServerInstanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.serverName = _data["serverName"];
            this.hostOrIp = _data["hostOrIp"];
            this.port = _data["port"];
            this.machineName = _data["machineName"];
        }
    }

    static fromJS(data: any): RegisterSqlServerInstanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSqlServerInstanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["serverName"] = this.serverName;
        data["hostOrIp"] = this.hostOrIp;
        data["port"] = this.port;
        data["machineName"] = this.machineName;
        return data;
    }
}

export interface IRegisterSqlServerInstanceRequest {
    licenseKey: string;
    machineFingerprint: string;
    serverName: string;
    hostOrIp?: string | undefined;
    port?: number | undefined;
    machineName?: string | undefined;
}

export class UnregisterSqlServerInstanceRequest implements IUnregisterSqlServerInstanceRequest {
    licenseKey!: string;
    machineFingerprint!: string;
    serverName!: string;
    machineName?: string | undefined;

    constructor(data?: IUnregisterSqlServerInstanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.serverName = _data["serverName"];
            this.machineName = _data["machineName"];
        }
    }

    static fromJS(data: any): UnregisterSqlServerInstanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnregisterSqlServerInstanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["serverName"] = this.serverName;
        data["machineName"] = this.machineName;
        return data;
    }
}

export interface IUnregisterSqlServerInstanceRequest {
    licenseKey: string;
    machineFingerprint: string;
    serverName: string;
    machineName?: string | undefined;
}

export class SyncSqlServerInstancesRequest implements ISyncSqlServerInstancesRequest {
    licenseKey!: string;
    machineFingerprint!: string;
    machineName?: string | undefined;
    servers?: SqlServerInstanceItemRequest[];

    constructor(data?: ISyncSqlServerInstancesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.machineName = _data["machineName"];
            if (Array.isArray(_data["servers"])) {
                this.servers = [] as any;
                for (let item of _data["servers"])
                    this.servers!.push(SqlServerInstanceItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncSqlServerInstancesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncSqlServerInstancesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["machineName"] = this.machineName;
        if (Array.isArray(this.servers)) {
            data["servers"] = [];
            for (let item of this.servers)
                data["servers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISyncSqlServerInstancesRequest {
    licenseKey: string;
    machineFingerprint: string;
    machineName?: string | undefined;
    servers?: SqlServerInstanceItemRequest[];
}

export class SqlServerInstanceItemRequest implements ISqlServerInstanceItemRequest {
    serverName!: string;
    hostOrIp?: string | undefined;
    port?: number | undefined;

    constructor(data?: ISqlServerInstanceItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverName = _data["serverName"];
            this.hostOrIp = _data["hostOrIp"];
            this.port = _data["port"];
        }
    }

    static fromJS(data: any): SqlServerInstanceItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SqlServerInstanceItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverName"] = this.serverName;
        data["hostOrIp"] = this.hostOrIp;
        data["port"] = this.port;
        return data;
    }
}

export interface ISqlServerInstanceItemRequest {
    serverName: string;
    hostOrIp?: string | undefined;
    port?: number | undefined;
}

export class ViewUserTwoFactorAuthenticationDetailsResponse implements IViewUserTwoFactorAuthenticationDetailsResponse {
    isTwoFactorAuthenticationEnabled!: boolean;
    userTwoFactorAuthenticationType!: UserTwoFactorAuthenticationTypes;

    constructor(data?: IViewUserTwoFactorAuthenticationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTwoFactorAuthenticationEnabled = _data["isTwoFactorAuthenticationEnabled"];
            this.userTwoFactorAuthenticationType = _data["userTwoFactorAuthenticationType"];
        }
    }

    static fromJS(data: any): ViewUserTwoFactorAuthenticationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewUserTwoFactorAuthenticationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTwoFactorAuthenticationEnabled"] = this.isTwoFactorAuthenticationEnabled;
        data["userTwoFactorAuthenticationType"] = this.userTwoFactorAuthenticationType;
        return data;
    }
}

export interface IViewUserTwoFactorAuthenticationDetailsResponse {
    isTwoFactorAuthenticationEnabled: boolean;
    userTwoFactorAuthenticationType: UserTwoFactorAuthenticationTypes;
}

export enum UserTwoFactorAuthenticationTypes {
    None = "None",
    Email = "Email",
    Authenticator = "Authenticator",
}

export class UpdateUserRequest implements IUpdateUserRequest {
    id?: string;
    firstName!: string;
    lastName!: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    windowsClientVersionIds?: number[];
    microsoftSqlServerVersionIds?: number[];
    windowsServerVersionIds?: number[];
    countryId?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    jobTitle?: string | undefined;
    image?: FileUploadRequest | undefined;
    deleteCurrentImage?: boolean;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            if (Array.isArray(_data["windowsClientVersionIds"])) {
                this.windowsClientVersionIds = [] as any;
                for (let item of _data["windowsClientVersionIds"])
                    this.windowsClientVersionIds!.push(item);
            }
            if (Array.isArray(_data["microsoftSqlServerVersionIds"])) {
                this.microsoftSqlServerVersionIds = [] as any;
                for (let item of _data["microsoftSqlServerVersionIds"])
                    this.microsoftSqlServerVersionIds!.push(item);
            }
            if (Array.isArray(_data["windowsServerVersionIds"])) {
                this.windowsServerVersionIds = [] as any;
                for (let item of _data["windowsServerVersionIds"])
                    this.windowsServerVersionIds!.push(item);
            }
            this.countryId = _data["countryId"];
            this.stateId = _data["stateId"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.jobTitle = _data["jobTitle"];
            this.image = _data["image"] ? FileUploadRequest.fromJS(_data["image"]) : undefined as any;
            this.deleteCurrentImage = _data["deleteCurrentImage"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        if (Array.isArray(this.windowsClientVersionIds)) {
            data["windowsClientVersionIds"] = [];
            for (let item of this.windowsClientVersionIds)
                data["windowsClientVersionIds"].push(item);
        }
        if (Array.isArray(this.microsoftSqlServerVersionIds)) {
            data["microsoftSqlServerVersionIds"] = [];
            for (let item of this.microsoftSqlServerVersionIds)
                data["microsoftSqlServerVersionIds"].push(item);
        }
        if (Array.isArray(this.windowsServerVersionIds)) {
            data["windowsServerVersionIds"] = [];
            for (let item of this.windowsServerVersionIds)
                data["windowsServerVersionIds"].push(item);
        }
        data["countryId"] = this.countryId;
        data["stateId"] = this.stateId;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["jobTitle"] = this.jobTitle;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        data["deleteCurrentImage"] = this.deleteCurrentImage;
        return data;
    }
}

export interface IUpdateUserRequest {
    id?: string;
    firstName: string;
    lastName: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    windowsClientVersionIds?: number[];
    microsoftSqlServerVersionIds?: number[];
    windowsServerVersionIds?: number[];
    countryId?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    jobTitle?: string | undefined;
    image?: FileUploadRequest | undefined;
    deleteCurrentImage?: boolean;
}

export class UpdateTwoFactorAuthenticationDetailsRequest implements IUpdateTwoFactorAuthenticationDetailsRequest {
    isTwoFactorAuthenticationEnabled!: boolean;
    userTwoFactorAuthenticationType!: UserTwoFactorAuthenticationTypes;

    constructor(data?: IUpdateTwoFactorAuthenticationDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTwoFactorAuthenticationEnabled = _data["isTwoFactorAuthenticationEnabled"];
            this.userTwoFactorAuthenticationType = _data["userTwoFactorAuthenticationType"];
        }
    }

    static fromJS(data: any): UpdateTwoFactorAuthenticationDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTwoFactorAuthenticationDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTwoFactorAuthenticationEnabled"] = this.isTwoFactorAuthenticationEnabled;
        data["userTwoFactorAuthenticationType"] = this.userTwoFactorAuthenticationType;
        return data;
    }
}

export interface IUpdateTwoFactorAuthenticationDetailsRequest {
    isTwoFactorAuthenticationEnabled: boolean;
    userTwoFactorAuthenticationType: UserTwoFactorAuthenticationTypes;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    password!: string;
    newPassword!: string;
    confirmNewPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    password: string;
    newPassword: string;
    confirmNewPassword: string;
}

export class AuthenticatorEnableResponse implements IAuthenticatorEnableResponse {
    secretKey!: string;
    qrCodeImageUrl!: DownloadFileResponse;

    constructor(data?: IAuthenticatorEnableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.qrCodeImageUrl = new DownloadFileResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretKey = _data["secretKey"];
            this.qrCodeImageUrl = _data["qrCodeImageUrl"] ? DownloadFileResponse.fromJS(_data["qrCodeImageUrl"]) : new DownloadFileResponse();
        }
    }

    static fromJS(data: any): AuthenticatorEnableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatorEnableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretKey"] = this.secretKey;
        data["qrCodeImageUrl"] = this.qrCodeImageUrl ? this.qrCodeImageUrl.toJSON() : undefined as any;
        return data;
    }
}

export interface IAuthenticatorEnableResponse {
    secretKey: string;
    qrCodeImageUrl: DownloadFileResponse;
}

export class RoleDto implements IRoleDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    permissions?: string[] | undefined;
    /** Who last touched this role (create, edit, or permission change) and when. Populated so an
owning tenant's Admin can see when SuperAdmin has modified their organization's roles/
permissions from the cross-tenant "Admin Permissions" screen — not just their own edits. */
    lastModifiedByName?: string | undefined;
    lastModifiedOn?: moment.Moment | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? moment(_data["lastModifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IRoleDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    permissions?: string[] | undefined;
    /** Who last touched this role (create, edit, or permission change) and when. Populated so an
owning tenant's Admin can see when SuperAdmin has modified their organization's roles/
permissions from the cross-tenant "Admin Permissions" screen — not just their own edits. */
    lastModifiedByName?: string | undefined;
    lastModifiedOn?: moment.Moment | undefined;
}

export class SystemPermission implements ISystemPermission {
    description?: string;
    action?: string;
    resource?: string;
    isBasic?: boolean;
    isRoot?: boolean;
    isAdmin?: boolean;
    /** True when this permission was synced in from an external product (currently only SQLDBD) via
ToSystemPermission, false for every
native Admin Portal permission declared in SystemPermissions. Explicit discriminator
for API consumers — added as an init property (not a positional parameter) so every existing
native `new SystemPermission(...)` call site in the catalog above continues to compile unchanged. */
    isSynced?: boolean;
    name?: string;

    constructor(data?: ISystemPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.action = _data["action"];
            this.resource = _data["resource"];
            this.isBasic = _data["isBasic"];
            this.isRoot = _data["isRoot"];
            this.isAdmin = _data["isAdmin"];
            this.isSynced = _data["isSynced"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SystemPermission {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["action"] = this.action;
        data["resource"] = this.resource;
        data["isBasic"] = this.isBasic;
        data["isRoot"] = this.isRoot;
        data["isAdmin"] = this.isAdmin;
        data["isSynced"] = this.isSynced;
        data["name"] = this.name;
        return data;
    }
}

export interface ISystemPermission {
    description?: string;
    action?: string;
    resource?: string;
    isBasic?: boolean;
    isRoot?: boolean;
    isAdmin?: boolean;
    /** True when this permission was synced in from an external product (currently only SQLDBD) via
ToSystemPermission, false for every
native Admin Portal permission declared in SystemPermissions. Explicit discriminator
for API consumers — added as an init property (not a positional parameter) so every existing
native `new SystemPermission(...)` call site in the catalog above continues to compile unchanged. */
    isSynced?: boolean;
    name?: string;
}

export class UpdateRolePermissionsRequest implements IUpdateRolePermissionsRequest {
    roleId?: string;
    permissions?: string[];

    constructor(data?: IUpdateRolePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRolePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IUpdateRolePermissionsRequest {
    roleId?: string;
    permissions?: string[];
}

export class CreateOrUpdateRoleRequest implements ICreateOrUpdateRoleRequest {
    id?: string | undefined;
    name!: string;
    description?: string | undefined;

    constructor(data?: ICreateOrUpdateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateOrUpdateRoleRequest {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
}

export class TokenResponse implements ITokenResponse {
    requiresTwoFactor?: boolean;
    twoFactorSessionId?: string;
    token?: string;
    refreshToken?: string;
    refreshTokenExpiryTime?: moment.Moment;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiresTwoFactor = _data["requiresTwoFactor"];
            this.twoFactorSessionId = _data["twoFactorSessionId"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"] ? moment(_data["refreshTokenExpiryTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiresTwoFactor"] = this.requiresTwoFactor;
        data["twoFactorSessionId"] = this.twoFactorSessionId;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime ? this.refreshTokenExpiryTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ITokenResponse {
    requiresTwoFactor?: boolean;
    twoFactorSessionId?: string;
    token?: string;
    refreshToken?: string;
    refreshTokenExpiryTime?: moment.Moment;
}

export class TokenRequest implements ITokenRequest {
    email?: string;
    password?: string;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ITokenRequest {
    email?: string;
    password?: string;
}

export class VerifyTwoFactorRequest implements IVerifyTwoFactorRequest {
    twoFactorSessionId?: string;
    code?: string;

    constructor(data?: IVerifyTwoFactorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorSessionId = _data["twoFactorSessionId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyTwoFactorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyTwoFactorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twoFactorSessionId"] = this.twoFactorSessionId;
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifyTwoFactorRequest {
    twoFactorSessionId?: string;
    code?: string;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    token?: string;
    refreshToken?: string;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    token?: string;
    refreshToken?: string;
}

export class SocialMediaTokenRequest implements ISocialMediaTokenRequest {
    jsonResponse!: string;
    socialMediaType!: UserRegistrationType;

    constructor(data?: ISocialMediaTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonResponse = _data["jsonResponse"];
            this.socialMediaType = _data["socialMediaType"];
        }
    }

    static fromJS(data: any): SocialMediaTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediaTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonResponse"] = this.jsonResponse;
        data["socialMediaType"] = this.socialMediaType;
        return data;
    }
}

export interface ISocialMediaTokenRequest {
    jsonResponse: string;
    socialMediaType: UserRegistrationType;
}

export enum UserRegistrationType {
    SeedUser = "SeedUser",
    Registration = "Registration",
    ManageUser = "ManageUser",
    Facebook = "Facebook",
    Google = "Google",
}

export class RegisterUserResponse implements IRegisterUserResponse {
    userId!: string;
    message!: string;

    constructor(data?: IRegisterUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RegisterUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["message"] = this.message;
        return data;
    }
}

export interface IRegisterUserResponse {
    userId: string;
    message: string;
}

export class RegisterUserRequest implements IRegisterUserRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    confirmPassword!: string;
    phoneNumber?: string | undefined;
    /** Optional company / organisation name used as the tenant name. */
    companyName?: string | undefined;
    isTermsAndConditionsAccepted!: boolean;
    windowsClientVersionIds!: number[];
    microsoftSqlServerVersionIds!: number[];
    windowsServerVersionIds!: number[];
    countryId?: number;
    stateId?: number;
    city!: string;
    zipCode!: string;
    jobTitle?: string | undefined;
    registrationSource?: string | undefined;
    campaignUniqueName?: string | undefined;
    campaignSourceSlug?: string | undefined;
    recaptchaToken!: string;

    constructor(data?: IRegisterUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.windowsClientVersionIds = [];
            this.microsoftSqlServerVersionIds = [];
            this.windowsServerVersionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.phoneNumber = _data["phoneNumber"];
            this.companyName = _data["companyName"];
            this.isTermsAndConditionsAccepted = _data["isTermsAndConditionsAccepted"];
            if (Array.isArray(_data["windowsClientVersionIds"])) {
                this.windowsClientVersionIds = [] as any;
                for (let item of _data["windowsClientVersionIds"])
                    this.windowsClientVersionIds!.push(item);
            }
            if (Array.isArray(_data["microsoftSqlServerVersionIds"])) {
                this.microsoftSqlServerVersionIds = [] as any;
                for (let item of _data["microsoftSqlServerVersionIds"])
                    this.microsoftSqlServerVersionIds!.push(item);
            }
            if (Array.isArray(_data["windowsServerVersionIds"])) {
                this.windowsServerVersionIds = [] as any;
                for (let item of _data["windowsServerVersionIds"])
                    this.windowsServerVersionIds!.push(item);
            }
            this.countryId = _data["countryId"];
            this.stateId = _data["stateId"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.jobTitle = _data["jobTitle"];
            this.registrationSource = _data["registrationSource"];
            this.campaignUniqueName = _data["campaignUniqueName"];
            this.campaignSourceSlug = _data["campaignSourceSlug"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): RegisterUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["phoneNumber"] = this.phoneNumber;
        data["companyName"] = this.companyName;
        data["isTermsAndConditionsAccepted"] = this.isTermsAndConditionsAccepted;
        if (Array.isArray(this.windowsClientVersionIds)) {
            data["windowsClientVersionIds"] = [];
            for (let item of this.windowsClientVersionIds)
                data["windowsClientVersionIds"].push(item);
        }
        if (Array.isArray(this.microsoftSqlServerVersionIds)) {
            data["microsoftSqlServerVersionIds"] = [];
            for (let item of this.microsoftSqlServerVersionIds)
                data["microsoftSqlServerVersionIds"].push(item);
        }
        if (Array.isArray(this.windowsServerVersionIds)) {
            data["windowsServerVersionIds"] = [];
            for (let item of this.windowsServerVersionIds)
                data["windowsServerVersionIds"].push(item);
        }
        data["countryId"] = this.countryId;
        data["stateId"] = this.stateId;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["jobTitle"] = this.jobTitle;
        data["registrationSource"] = this.registrationSource;
        data["campaignUniqueName"] = this.campaignUniqueName;
        data["campaignSourceSlug"] = this.campaignSourceSlug;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IRegisterUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    phoneNumber?: string | undefined;
    /** Optional company / organisation name used as the tenant name. */
    companyName?: string | undefined;
    isTermsAndConditionsAccepted: boolean;
    windowsClientVersionIds: number[];
    microsoftSqlServerVersionIds: number[];
    windowsServerVersionIds: number[];
    countryId?: number;
    stateId?: number;
    city: string;
    zipCode: string;
    jobTitle?: string | undefined;
    registrationSource?: string | undefined;
    campaignUniqueName?: string | undefined;
    campaignSourceSlug?: string | undefined;
    recaptchaToken: string;
}

export class CreateUserResponse implements ICreateUserResponse {
    userId!: string;
    message!: string;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateUserResponse {
    userId: string;
    message: string;
}

export class CreateUserRequest implements ICreateUserRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    confirmPassword!: string;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    phoneNumber?: string | undefined;
}

/** SuperAdmin-only request to create a brand-new customer: a new Tenant plus its first Admin user, mirroring the public self-registration flow (tenant DB provisioning, default roles, confirmation email) but triggered from the portal instead of anonymously. */
export class CreateCustomerRequest implements ICreateCustomerRequest {
    companyName!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

/** SuperAdmin-only request to create a brand-new customer: a new Tenant plus its first Admin user, mirroring the public self-registration flow (tenant DB provisioning, default roles, confirmation email) but triggered from the portal instead of anonymously. */
export interface ICreateCustomerRequest {
    companyName: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phoneNumber?: string | undefined;
}

export class PaginationResponseOfViewUserDetailsResponse implements IPaginationResponseOfViewUserDetailsResponse {
    data?: ViewUserDetailsResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewUserDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewUserDetailsResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewUserDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewUserDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewUserDetailsResponse {
    data?: ViewUserDetailsResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SearchUsersRequest extends SearchRequestBaseClass implements ISearchUsersRequest {
    searchText?: string | undefined;

    constructor(data?: ISearchUsersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static override fromJS(data: any): SearchUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUsersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchUsersRequest extends ISearchRequestBaseClass {
    searchText?: string | undefined;
}

export class ExportCustomersRequest extends SearchUsersRequest implements IExportCustomersRequest {
    format?: string;

    constructor(data?: IExportCustomersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.format = _data["format"];
        }
    }

    static override fromJS(data: any): ExportCustomersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCustomersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        super.toJSON(data);
        return data;
    }
}

export interface IExportCustomersRequest extends ISearchUsersRequest {
    format?: string;
}

export class UserRoleResponse implements IUserRoleResponse {
    roleId?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;

    constructor(data?: IUserRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UserRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUserRoleResponse {
    roleId?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
}

export class UserRolesRequest implements IUserRolesRequest {
    userRoles?: UserRoleResponse[];

    constructor(data?: IUserRolesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRoleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserRolesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRolesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserRolesRequest {
    userRoles?: UserRoleResponse[];
}

export class UpdateUserDetailsRequest implements IUpdateUserDetailsRequest {
    isActive?: boolean;
    userId?: string | undefined;
    firstName!: string;
    lastName!: string;
    phoneNumber?: string | undefined;
    /** SuperAdmin-only: when set to true, marks the user's email as confirmed.
Ignored (never un-confirms) if omitted, false, or the caller isn't a SuperAdmin. */
    emailConfirmed?: boolean | undefined;

    constructor(data?: IUpdateUserDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): UpdateUserDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IUpdateUserDetailsRequest {
    isActive?: boolean;
    userId?: string | undefined;
    firstName: string;
    lastName: string;
    phoneNumber?: string | undefined;
    /** SuperAdmin-only: when set to true, marks the user's email as confirmed.
Ignored (never un-confirms) if omitted, false, or the caller isn't a SuperAdmin. */
    emailConfirmed?: boolean | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email?: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email?: string;
}

export class ResetForgotPasswordRequest implements IResetForgotPasswordRequest {
    email?: string;
    password?: string;
    confirmPassword?: string;
    token?: string;

    constructor(data?: IResetForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["token"] = this.token;
        return data;
    }
}

export interface IResetForgotPasswordRequest {
    email?: string;
    password?: string;
    confirmPassword?: string;
    token?: string;
}

export class ChangePasswordForcefullyRequest implements IChangePasswordForcefullyRequest {
    newPassword!: string;
    confirmNewPassword!: string;

    constructor(data?: IChangePasswordForcefullyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordForcefullyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordForcefullyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordForcefullyRequest {
    newPassword: string;
    confirmNewPassword: string;
}

export class PaginationResponseOfViewEmailLogResponse implements IPaginationResponseOfViewEmailLogResponse {
    data?: ViewEmailLogResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewEmailLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewEmailLogResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewEmailLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewEmailLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewEmailLogResponse {
    data?: ViewEmailLogResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewEmailLogResponse implements IViewEmailLogResponse {
    id!: number;
    to?: string[] | undefined;
    subject?: string | undefined;
    isEmailSent?: boolean | undefined;
    createdOn?: moment.Moment;
    from?: string | undefined;

    constructor(data?: IViewEmailLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.subject = _data["subject"];
            this.isEmailSent = _data["isEmailSent"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): ViewEmailLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewEmailLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["subject"] = this.subject;
        data["isEmailSent"] = this.isEmailSent;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["from"] = this.from;
        return data;
    }
}

export interface IViewEmailLogResponse {
    id: number;
    to?: string[] | undefined;
    subject?: string | undefined;
    isEmailSent?: boolean | undefined;
    createdOn?: moment.Moment;
    from?: string | undefined;
}

export class SearchEmailLogRequest extends SearchRequestBaseClass implements ISearchEmailLogRequest {
    to?: string | undefined;
    subject?: string | undefined;
    sentStatus?: boolean | undefined;
    from?: string | undefined;
    sendDateTimeOffset?: moment.Moment | undefined;

    constructor(data?: ISearchEmailLogRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.sentStatus = _data["sentStatus"];
            this.from = _data["from"];
            this.sendDateTimeOffset = _data["sendDateTimeOffset"] ? moment(_data["sendDateTimeOffset"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SearchEmailLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailLogRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["sentStatus"] = this.sentStatus;
        data["from"] = this.from;
        data["sendDateTimeOffset"] = this.sendDateTimeOffset ? this.sendDateTimeOffset.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchEmailLogRequest extends ISearchRequestBaseClass {
    to?: string | undefined;
    subject?: string | undefined;
    sentStatus?: boolean | undefined;
    from?: string | undefined;
    sendDateTimeOffset?: moment.Moment | undefined;
}

export class ViewEmailLogDetailResponse implements IViewEmailLogDetailResponse {
    id!: number;
    to!: string[];
    subject!: string;
    emailType!: EmailTypes;
    body!: string;
    from!: string;
    displayName!: string;
    replyTo?: string | undefined;
    replyToName?: string | undefined;
    bcc?: string[] | undefined;
    cc?: string[] | undefined;
    headers?: string | undefined;
    emailSmtpUsed?: string | undefined;
    isEmailSent?: boolean;
    emailSentMessage?: string | undefined;

    constructor(data?: IViewEmailLogDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.to = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.subject = _data["subject"];
            this.emailType = _data["emailType"];
            this.body = _data["body"];
            this.from = _data["from"];
            this.displayName = _data["displayName"];
            this.replyTo = _data["replyTo"];
            this.replyToName = _data["replyToName"];
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.headers = _data["headers"];
            this.emailSmtpUsed = _data["emailSmtpUsed"];
            this.isEmailSent = _data["isEmailSent"];
            this.emailSentMessage = _data["emailSentMessage"];
        }
    }

    static fromJS(data: any): ViewEmailLogDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewEmailLogDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["subject"] = this.subject;
        data["emailType"] = this.emailType;
        data["body"] = this.body;
        data["from"] = this.from;
        data["displayName"] = this.displayName;
        data["replyTo"] = this.replyTo;
        data["replyToName"] = this.replyToName;
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["headers"] = this.headers;
        data["emailSmtpUsed"] = this.emailSmtpUsed;
        data["isEmailSent"] = this.isEmailSent;
        data["emailSentMessage"] = this.emailSentMessage;
        return data;
    }
}

export interface IViewEmailLogDetailResponse {
    id: number;
    to: string[];
    subject: string;
    emailType: EmailTypes;
    body: string;
    from: string;
    displayName: string;
    replyTo?: string | undefined;
    replyToName?: string | undefined;
    bcc?: string[] | undefined;
    cc?: string[] | undefined;
    headers?: string | undefined;
    emailSmtpUsed?: string | undefined;
    isEmailSent?: boolean;
    emailSentMessage?: string | undefined;
}

export enum EmailTypes {
    RegistrationVerificationEmail = "RegistrationVerificationEmail",
    ForgotPasswordEmail = "ForgotPasswordEmail",
    TwoFactorVerificationEmail = "TwoFactorVerificationEmail",
    PaymentReceipt = "PaymentReceipt",
    PaymentFailed = "PaymentFailed",
    SupportInquiry = "SupportInquiry",
    AdminCreatedCustomerCredentials = "AdminCreatedCustomerCredentials",
    CustomPlanRequest = "CustomPlanRequest",
}

export class CreateEmailTemplateResponse implements ICreateEmailTemplateResponse {
    id!: number;
    message!: string;

    constructor(data?: ICreateEmailTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateEmailTemplateResponse {
    id: number;
    message: string;
}

export class CreateEmailTemplateRequest implements ICreateEmailTemplateRequest {
    name!: string;
    description?: string | undefined;
    templateUsedFor!: EmailTemplateUsedFor;
    emailSubject!: string;
    emailBody!: string;
    isShared!: boolean;

    constructor(data?: ICreateEmailTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.templateUsedFor = _data["templateUsedFor"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["templateUsedFor"] = this.templateUsedFor;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ICreateEmailTemplateRequest {
    name: string;
    description?: string | undefined;
    templateUsedFor: EmailTemplateUsedFor;
    emailSubject: string;
    emailBody: string;
    isShared: boolean;
}

export enum EmailTemplateUsedFor {
    Users = "Users",
    General = "General",
}

export class ViewEmailTemplateDetailResponse implements IViewEmailTemplateDetailResponse {
    name!: string;
    description?: string | undefined;
    templateUsedFor!: EmailTemplateUsedFor;
    emailSubject!: string;
    emailBody!: string;
    isShared!: boolean;

    constructor(data?: IViewEmailTemplateDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.templateUsedFor = _data["templateUsedFor"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): ViewEmailTemplateDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewEmailTemplateDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["templateUsedFor"] = this.templateUsedFor;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface IViewEmailTemplateDetailResponse {
    name: string;
    description?: string | undefined;
    templateUsedFor: EmailTemplateUsedFor;
    emailSubject: string;
    emailBody: string;
    isShared: boolean;
}

export class UpdateEmailTemplateRequest implements IUpdateEmailTemplateRequest {
    id!: number;
    name!: string;
    description?: string | undefined;
    templateUsedFor!: EmailTemplateUsedFor;
    emailSubject!: string;
    emailBody!: string;
    isShared!: boolean;

    constructor(data?: IUpdateEmailTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.templateUsedFor = _data["templateUsedFor"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["templateUsedFor"] = this.templateUsedFor;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface IUpdateEmailTemplateRequest {
    id: number;
    name: string;
    description?: string | undefined;
    templateUsedFor: EmailTemplateUsedFor;
    emailSubject: string;
    emailBody: string;
    isShared: boolean;
}

export class PaginationResponseOfViewEmailTemplateResponse implements IPaginationResponseOfViewEmailTemplateResponse {
    data?: ViewEmailTemplateResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfViewEmailTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ViewEmailTemplateResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfViewEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfViewEmailTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfViewEmailTemplateResponse {
    data?: ViewEmailTemplateResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ViewEmailTemplateResponse implements IViewEmailTemplateResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    templateUsedFor!: EmailTemplateUsedFor;
    emailSubject!: string;
    isShared!: boolean;

    constructor(data?: IViewEmailTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.templateUsedFor = _data["templateUsedFor"];
            this.emailSubject = _data["emailSubject"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): ViewEmailTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewEmailTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["templateUsedFor"] = this.templateUsedFor;
        data["emailSubject"] = this.emailSubject;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface IViewEmailTemplateResponse {
    id: number;
    name: string;
    description?: string | undefined;
    templateUsedFor: EmailTemplateUsedFor;
    emailSubject: string;
    isShared: boolean;
}

export class SearchEmailTemplateRequest extends SearchRequestBaseClass implements ISearchEmailTemplateRequest {
    nameDescription?: string | undefined;
    templateUsedFor?: EmailTemplateUsedFor;
    isShared?: boolean | undefined;

    constructor(data?: ISearchEmailTemplateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameDescription = _data["nameDescription"];
            this.templateUsedFor = _data["templateUsedFor"];
            this.isShared = _data["isShared"];
        }
    }

    static override fromJS(data: any): SearchEmailTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailTemplateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameDescription"] = this.nameDescription;
        data["templateUsedFor"] = this.templateUsedFor;
        data["isShared"] = this.isShared;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchEmailTemplateRequest extends ISearchRequestBaseClass {
    nameDescription?: string | undefined;
    templateUsedFor?: EmailTemplateUsedFor;
    isShared?: boolean | undefined;
}

export class DesktopAuthLoginResponse implements IDesktopAuthLoginResponse {
    isSuccess?: boolean;
    message?: string;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string | undefined;
    phoneNumber?: string | undefined;
    primaryRole?: string | undefined;
    isTenantAdmin?: boolean;
    permissions?: string[];
    /** The subset of the user's flattened Admin Portal permissions that are actually SQLDBD-native
codes (extracted from the "Permissions.SqlDbd_{Module}.{Code}" claims — see
SyncedPermissionNaming), stripped back down to raw codes SQLDBD's own PermissionMaster catalog
understands. This is what SQLDBD should write into its local UserPermissions table (delete +
reinsert, every login) — not the raw Permissions list above, which is Admin-Portal-shaped. */
    sqlDbdPermissions?: string[];
    planName?: string | undefined;
    licenseExpiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;
    maxActivations?: number;

    constructor(data?: IDesktopAuthLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.tenantId = _data["tenantId"];
            this.tenantUniqueId = _data["tenantUniqueId"];
            this.tenantName = _data["tenantName"];
            this.phoneNumber = _data["phoneNumber"];
            this.primaryRole = _data["primaryRole"];
            this.isTenantAdmin = _data["isTenantAdmin"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["sqlDbdPermissions"])) {
                this.sqlDbdPermissions = [] as any;
                for (let item of _data["sqlDbdPermissions"])
                    this.sqlDbdPermissions!.push(item);
            }
            this.planName = _data["planName"];
            this.licenseExpiresOn = _data["licenseExpiresOn"] ? moment(_data["licenseExpiresOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
            this.maxActivations = _data["maxActivations"];
        }
    }

    static fromJS(data: any): DesktopAuthLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopAuthLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["tenantId"] = this.tenantId;
        data["tenantUniqueId"] = this.tenantUniqueId;
        data["tenantName"] = this.tenantName;
        data["phoneNumber"] = this.phoneNumber;
        data["primaryRole"] = this.primaryRole;
        data["isTenantAdmin"] = this.isTenantAdmin;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.sqlDbdPermissions)) {
            data["sqlDbdPermissions"] = [];
            for (let item of this.sqlDbdPermissions)
                data["sqlDbdPermissions"].push(item);
        }
        data["planName"] = this.planName;
        data["licenseExpiresOn"] = this.licenseExpiresOn ? this.licenseExpiresOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        data["maxActivations"] = this.maxActivations;
        return data;
    }
}

export interface IDesktopAuthLoginResponse {
    isSuccess?: boolean;
    message?: string;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string | undefined;
    phoneNumber?: string | undefined;
    primaryRole?: string | undefined;
    isTenantAdmin?: boolean;
    permissions?: string[];
    /** The subset of the user's flattened Admin Portal permissions that are actually SQLDBD-native
codes (extracted from the "Permissions.SqlDbd_{Module}.{Code}" claims — see
SyncedPermissionNaming), stripped back down to raw codes SQLDBD's own PermissionMaster catalog
understands. This is what SQLDBD should write into its local UserPermissions table (delete +
reinsert, every login) — not the raw Permissions list above, which is Admin-Portal-shaped. */
    sqlDbdPermissions?: string[];
    planName?: string | undefined;
    licenseExpiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;
    maxActivations?: number;
}

export class DesktopAuthLoginRequest implements IDesktopAuthLoginRequest {
    email!: string;
    password!: string;
    licenseKey!: string;
    machineFingerprint?: string | undefined;
    machineName?: string | undefined;
    appVersion?: string | undefined;
    /** SQLDBD's local permission catalog codes, reported on every login so Admin Portal learns about
new permissions as SQLDBD ships them. Any code not already known is recorded as SuperAdmin-only
visible until explicitly granted to this tenant — see ISyncedPermissionService. Optional/nullable
so older SQLDBD builds that don't send this yet don't fail the login call. */
    localPermissionCatalog?: DesktopPermissionCatalogEntryRequest[] | undefined;

    constructor(data?: IDesktopAuthLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.licenseKey = _data["licenseKey"];
            this.machineFingerprint = _data["machineFingerprint"];
            this.machineName = _data["machineName"];
            this.appVersion = _data["appVersion"];
            if (Array.isArray(_data["localPermissionCatalog"])) {
                this.localPermissionCatalog = [] as any;
                for (let item of _data["localPermissionCatalog"])
                    this.localPermissionCatalog!.push(DesktopPermissionCatalogEntryRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DesktopAuthLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopAuthLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["licenseKey"] = this.licenseKey;
        data["machineFingerprint"] = this.machineFingerprint;
        data["machineName"] = this.machineName;
        data["appVersion"] = this.appVersion;
        if (Array.isArray(this.localPermissionCatalog)) {
            data["localPermissionCatalog"] = [];
            for (let item of this.localPermissionCatalog)
                data["localPermissionCatalog"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDesktopAuthLoginRequest {
    email: string;
    password: string;
    licenseKey: string;
    machineFingerprint?: string | undefined;
    machineName?: string | undefined;
    appVersion?: string | undefined;
    /** SQLDBD's local permission catalog codes, reported on every login so Admin Portal learns about
new permissions as SQLDBD ships them. Any code not already known is recorded as SuperAdmin-only
visible until explicitly granted to this tenant — see ISyncedPermissionService. Optional/nullable
so older SQLDBD builds that don't send this yet don't fail the login call. */
    localPermissionCatalog?: DesktopPermissionCatalogEntryRequest[] | undefined;
}

export class DesktopPermissionCatalogEntryRequest implements IDesktopPermissionCatalogEntryRequest {
    code!: string;
    description?: string | undefined;
    moduleName?: string | undefined;

    constructor(data?: IDesktopPermissionCatalogEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.moduleName = _data["moduleName"];
        }
    }

    static fromJS(data: any): DesktopPermissionCatalogEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopPermissionCatalogEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["moduleName"] = this.moduleName;
        return data;
    }
}

export interface IDesktopPermissionCatalogEntryRequest {
    code: string;
    description?: string | undefined;
    moduleName?: string | undefined;
}

export class DesktopAuthValidateUserResponse implements IDesktopAuthValidateUserResponse {
    isSuccess?: boolean;
    message?: string;
    email?: string | undefined;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string | undefined;
    phoneNumber?: string | undefined;
    primaryRole?: string | undefined;
    isTenantAdmin?: boolean;
    /** True when the tenant's active subscription is a trial plan. */
    isTrial?: boolean;
    /** True when the tenant has an active, non-expired license/subscription. */
    hasActiveSubscription?: boolean;
    planName?: string | undefined;
    licenseType?: string | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;

    constructor(data?: IDesktopAuthValidateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.tenantId = _data["tenantId"];
            this.tenantUniqueId = _data["tenantUniqueId"];
            this.tenantName = _data["tenantName"];
            this.phoneNumber = _data["phoneNumber"];
            this.primaryRole = _data["primaryRole"];
            this.isTenantAdmin = _data["isTenantAdmin"];
            this.isTrial = _data["isTrial"];
            this.hasActiveSubscription = _data["hasActiveSubscription"];
            this.planName = _data["planName"];
            this.licenseType = _data["licenseType"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
        }
    }

    static fromJS(data: any): DesktopAuthValidateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopAuthValidateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["tenantId"] = this.tenantId;
        data["tenantUniqueId"] = this.tenantUniqueId;
        data["tenantName"] = this.tenantName;
        data["phoneNumber"] = this.phoneNumber;
        data["primaryRole"] = this.primaryRole;
        data["isTenantAdmin"] = this.isTenantAdmin;
        data["isTrial"] = this.isTrial;
        data["hasActiveSubscription"] = this.hasActiveSubscription;
        data["planName"] = this.planName;
        data["licenseType"] = this.licenseType;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        return data;
    }
}

export interface IDesktopAuthValidateUserResponse {
    isSuccess?: boolean;
    message?: string;
    email?: string | undefined;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    tenantId?: number;
    tenantUniqueId?: string;
    tenantName?: string | undefined;
    phoneNumber?: string | undefined;
    primaryRole?: string | undefined;
    isTenantAdmin?: boolean;
    /** True when the tenant's active subscription is a trial plan. */
    isTrial?: boolean;
    /** True when the tenant has an active, non-expired license/subscription. */
    hasActiveSubscription?: boolean;
    planName?: string | undefined;
    licenseType?: string | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;
}

export class DesktopAuthCredentialsRequest implements IDesktopAuthCredentialsRequest {
    email!: string;
    password!: string;

    constructor(data?: IDesktopAuthCredentialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DesktopAuthCredentialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopAuthCredentialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IDesktopAuthCredentialsRequest {
    email: string;
    password: string;
}

export class DesktopResolveLicenseResponse implements IDesktopResolveLicenseResponse {
    isSuccess?: boolean;
    message?: string;
    licenseKey?: string | undefined;
    planName?: string | undefined;
    licenseType?: string | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;

    constructor(data?: IDesktopResolveLicenseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.licenseKey = _data["licenseKey"];
            this.planName = _data["planName"];
            this.licenseType = _data["licenseType"];
            this.expiresOn = _data["expiresOn"] ? moment(_data["expiresOn"].toString()) : undefined as any;
            this.maxUsers = _data["maxUsers"];
            this.maxInstances = _data["maxInstances"];
        }
    }

    static fromJS(data: any): DesktopResolveLicenseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopResolveLicenseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["licenseKey"] = this.licenseKey;
        data["planName"] = this.planName;
        data["licenseType"] = this.licenseType;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["maxUsers"] = this.maxUsers;
        data["maxInstances"] = this.maxInstances;
        return data;
    }
}

export interface IDesktopResolveLicenseResponse {
    isSuccess?: boolean;
    message?: string;
    licenseKey?: string | undefined;
    planName?: string | undefined;
    licenseType?: string | undefined;
    expiresOn?: moment.Moment | undefined;
    maxUsers?: number;
    maxInstances?: number;
}

export class PaginationResponseOfAuditTrailResponse implements IPaginationResponseOfAuditTrailResponse {
    data?: AuditTrailResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginationResponseOfAuditTrailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuditTrailResponse.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginationResponseOfAuditTrailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfAuditTrailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginationResponseOfAuditTrailResponse {
    data?: AuditTrailResponse[];
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AuditTrailResponse implements IAuditTrailResponse {
    id?: number;
    type?: string | undefined;
    tableName?: string | undefined;
    primaryKey?: string | undefined;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    affectedColumns?: string | undefined;
    createdBy?: string;
    createdOn?: moment.Moment;

    constructor(data?: IAuditTrailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.tableName = _data["tableName"];
            this.primaryKey = _data["primaryKey"];
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.affectedColumns = _data["affectedColumns"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AuditTrailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTrailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["primaryKey"] = this.primaryKey;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["affectedColumns"] = this.affectedColumns;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IAuditTrailResponse {
    id?: number;
    type?: string | undefined;
    tableName?: string | undefined;
    primaryKey?: string | undefined;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    affectedColumns?: string | undefined;
    createdBy?: string;
    createdOn?: moment.Moment;
}

export class SearchAuditTrailRequest extends SearchRequestBaseClass implements ISearchAuditTrailRequest {
    tableName?: string | undefined;
    trailType?: string | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;

    constructor(data?: ISearchAuditTrailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.trailType = _data["trailType"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? moment(_data["to"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SearchAuditTrailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAuditTrailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["trailType"] = this.trailType;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchAuditTrailRequest extends ISearchRequestBaseClass {
    tableName?: string | undefined;
    trailType?: string | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
